/**
 * Created by abdulhafeth on 12/14/15.
 */
window.OnBoardingAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    /**
     * Make sure to cache the attachments lookup with its codes and ids
     */
    self.attachmentCodeLookup = {};
    self.SEND_DOCUMNTS_ERROR_CODES = {'IRS_ERROR': 'IRS_8850_CANT_BE_SENT_AFTER_OFFER'}
    self.DOCUMENTS_CATEGORIES = {'ON_BOARDING': 'ON_BOARDING'}
    /**
     * This function to load attachment lookup for all documents need lookup
     */
    self.getAttachmentCodeLookup = function () {
        var defer = $q.defer();

        HStorageManager.remove({
            key: 'onboarding_attachment_code_lookups',
            storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
        })

        if (Object.keys(self.attachmentCodeLookup).length) {
            defer.resolve(self.attachmentCodeLookup);
        } else {
            _protected.request(publicConfiguration.OnboardingServerBaseURL + 'attachment_code_lookups', 'GET')
                .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        for (var i in res.data.data) {
                            var attachmentLookup = res.data.data[i];
                            self.attachmentCodeLookup[attachmentLookup.code] = attachmentLookup;
                        }

                        defer.resolve(self.attachmentCodeLookup);
                    }
                    else {
                        defer.reject(res);
                    }
                }, function (err) {
                    defer.reject(err);
                });
        }

        return defer.promise;
    };

    self.prospectTerminationCheck = function(prospectId) {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'prospects/' + prospectId + '/termination/check', 'GET').then(function (res) {
            defer.resolve(res.data.data);
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    /**
     * Loads the positions by category
     * @returns {*}
     */
    self.loadBrands = function(groupId, includeArchived) {
        var defer = $q.defer();
        var optionalParameter = '';
        if (_protected.getCached('user_brands')) {
            var data = _protected.getCached('user_brands');
            defer.resolve(data);
            return defer.promise;
        }

        if (includeArchived) {
            optionalParameter = '?include_archived=true';
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL +'groups/' + groupId + '/user_brands' + optionalParameter, 'GET').then(function (res) {
            _protected.handleResponse(res.data, defer);
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getAttachmentPath = function(attachmentId) {
        var defer = $q.defer();

        _protected.request(`${publicConfiguration.OnboardingServerBaseURL.replace('v1', 'v2')}attachment_url/${attachmentId}`, 'GET').then(function (res) {
            defer.resolve(res.data.data);
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    /**
     * Executes candidates search depending on the filters
     */
    self.searchCandidates = function(groupId, filters) {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL +'brands/' + groupId + '/mydocs/search', 'PUT', filters).then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };


    /**
     * Executes documents search depending on the candidate user id
     */
    self.searchDocuments = function () {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'user/doc_storage', 'GET').then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    /**
     * Executes candidates search depending on the filters
     */
    self.loadCandidateSpeedyXdata = function (brand_id, user_id, filters) {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL.replace('v1', 'v2') + 'prospect/speedy_screen/' + brand_id + '/' + user_id, 'GET', filters).then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.loadDropdownActions = async (brandId) => {
        let params = {
            'include_parents': true
        };
        const res = await _protected.request(`${publicConfiguration.OnboardingServerBaseURL}brands/${brandId}/documents/categories/BRAND_CUSTOM/subcategories`, 'GET', params);
        if (res.data && res.data.data && res.data.status_code === 200) {
            return res.data.data;
        } else {
            throw res;
        }
    };

    self.getEmploymentEligibilityHistory = async (brandId, userId) => {
        const res = await _protected.request(`${publicConfiguration.OnboardingServerBaseURL}brands/${brandId}/users/${userId}/employment_eligibility_audit`, 'GET');

        if (res.data?.data && res.data?.status_code === 200) {
            return res.data.data;
        } else {
            throw res;
        }
    };

    self.sendPayRateNotice = function(prospectIds, document, syncTeam) {
        var defer = $q.defer();

        var data = {
            "sync_team": syncTeam,
            "document": document,
            "prospect_ids": prospectIds
        };

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/prospects/documents/pay_rate', 'PUT', data)
            .then(function(res) {
                    if (res && res.data && res.data.data && res.data.status_code == 200) {
                        defer.resolve(res.data.data);
                    }
                    else {
                        defer.reject(res);
                    }
                },
                function(err) {
                    defer.reject(err);
                });

        return defer.promise;
    };

    self.getDocumentLookupCode = function(category, params) {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/document_categories/'+ category +'/document_lookups', 'GET', params)
            .then(function(res) {
                    if (res && res.data && res.data.data && res.data.status_code == 200) {
                        defer.resolve(res.data.data['document_lookups']);
                    }
                    else {
                        defer.reject(res);
                    }
                },
                function(err) {
                    defer.reject(err);
                });

        return defer.promise;

    };

    self.sendDocuments = function(prospect, documents, source, employerMessage, syncTeam, is_internal_employee) {
        var defer = $q.defer();

        var data = {
            documents: documents,
            is_internal_employee: is_internal_employee
        };

        if(Array.isArray(prospect)) {
            data.prospects = prospect;
        }
        else {
            data.prospect = prospect;
        }

        if(source) {
            data.source = source;
        }

        if (employerMessage) {
            data.employer_message = employerMessage;
        }
        if(syncTeam){
            data.sync_team = syncTeam;
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'document', 'PUT', data)
            .then(function(res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                } else if (res?.status === 202) {
                     defer.resolve(res);
                }
                else {
                    defer.reject(res);
                }
            },
            function(err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.requestNewDocument = async (brandId, userId, documentCode, payload) => {
        try {
            const response = await _protected.request(`${publicConfiguration.OnboardingServerBaseURL}brands/${brandId}/users/${userId}/document_lookups/${documentCode}/documents/send`, 'POST' , payload);
            if (response?.data?.data && response.status === 200) {
                return response.data.data;
            } else {
                throw response;
            }
        } catch (err) {
            throw err;
        }
    }

    self.startTutorial = function (brandId, userId) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/e_verify/tutorials/start', 'POST', {user_id: userId})
            .then(function(res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.finishTutorial = function (brandId, userId) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/e_verify/tutorials/finish', 'POST', {user_id: userId})
            .then(function(res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getExam = function (brandId) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/e_verify/exam', 'GET')
            .then(function(res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.finishExam = function (brandId, examId, userId) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/e_verify/exam/' + examId + '/finish', 'POST', {user_id: userId})
            .then(function(res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.answerQuestion = function (brandId, examId, questionId, answerIds) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId +
                '/e_verify/exam/' + examId + '/questions/' + questionId + '/answer', 'POST', {option_ids: answerIds})
            .then(function(res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    /**
     * [load user js dashboard on-boarding tab]
     * @param params
     * @returns {deferred.promise|{then, always}|{then}}
     */
    self.getOnboardingUserDocuments = function (params) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'user/documents', 'GET', params)
            .then(function(res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUserDocuments = function(brandId, params) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/'+ brandId + '/users/documents', 'GET', params)
            .then(function(res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    } else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.getProspectsWelcomeVideos = function () {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'candidates/prospects/welcome_videos', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }).catch(function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    /**
     * Loads the end of service reasons
     */
    self.loadEndOfServiceReasons = function(){
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'reason_for_leaving_lookup', 'GET')
            .then(function(res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }
            },
            function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * End some candidate service on a specific position
     */
    self.endService = function (prospectId, data) {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'prospect/end_of_service/'+prospectId, 'POST', data).then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    /*
     * Delete Document
     *
     * @param documentId
     * @returns {*}
     */
    self.deleteDocument = function (documentId) {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'document/' + documentId, 'DELETE')
            .then(function (res) {
                defer.resolve(res);
            },
            function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.deleteProspectDocuments = function(data) {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'prospect_documents/withdraw', 'DELETE', data)
            .then(function(res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            },
            function(err) {
                defer.reject(err.data);
            });

        return defer.promise;
    };

    self.listDocuments = function(appId, prospectId, category, userId, includeNoTemplateDocuments, includeAllDocuments, lookupCode, actionId) {
        var defer = $q.defer();
        var data = {
            category: category || 'OFFER,ON_BOARDING,GFE,CANDIDATE_CUSTOM'
        };

        if (appId) {
            data.application_id = appId;
        }

        if (prospectId) {
            data.prospect_id = prospectId;
        }

        if (userId) {
            data.user_id = userId;
        }

        if(includeNoTemplateDocuments) {
            data.include_no_template_documents = true;
        }

        if(includeAllDocuments) {
            data.include_all_prospect_documents  = true;
        }

        // use this if you just need document and its information
        if (lookupCode) {
            data.lookup_code = lookupCode;
        }
        if (actionId) {
            data.subcategory_ids = [actionId];
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'prospect_documents', 'GET', data)
            .then(function(res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                }
                else {
                    defer.reject(res);
                }
            },
            function(err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.listBrandDocuments = function (groupId, brandId, category, includeNoTemplateDocuments, position_codes) {

        var defer = $q.defer();

        var payload = {
            category: category || 'OFFER,ON_BOARDING',
            brand_id: brandId,
            include_no_template_documents: includeNoTemplateDocuments
        };

        if (position_codes) {
            payload.position_codes = position_codes
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL +'groups/' + groupId + '/brand_lookups', 'GET', payload)
            .then(function(res) {
                if (res && res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                }
                else {
                    defer.reject(res);
                }
            },
            function(err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.retrieveSharedLocationsDocuments = (brandId, brandIds, position_codes) => {
        return new Promise((resolve, reject) => {
            const payload = {
                brand_ids: brandIds,
                categories: [self.DOCUMENTS_CATEGORIES.ON_BOARDING]
            };

            if (position_codes) {
                payload.position_codes = position_codes;
            }

            const url = `${publicConfiguration.OnboardingServerBaseURL}brands/${brandId}/document_lookups/retrieve`;

            _protected.request(url, 'POST', payload)
                .then(res => {
                    if (res?.data?.data && res.data.status_code === 200) {
                        resolve(res.data.data.document_lookups);
                    } else {
                        reject(res);
                    }
                })
                .catch(err => reject(err));
        });
    };

    self.getDocumentLink = function(docId) {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'get_signed_doc/' + docId, 'GET', {})
            .then(function(res) {
                if (res.data && res.data.status_code == 200 && res.data.data) {
                    defer.resolve(res.data.data);
                }
                else {
                    defer.reject(res);
                }
            },
            function(err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getDocumentLookups = function (brandId) {
        var defer = $q.defer();

        var url = publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/document_categories/GFE/brands/document_lookups';
        _protected.request(url, 'GET')
            .then(function (response) {
                if (response.data.data && response.data.status_code === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    }

    self.getLastGoodFaithEstimateDocMeta = function (brandId, userId) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/'+ brandId + '/users/'+ userId + '/good_faith_estimate/last_document', 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code === 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getLastGoodFaithEstimateDocLink = function (brandId, documentId) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/'+ brandId + '/good_faith_estimate/documents/'+ documentId + '/signed_url', 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code === 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.candidateDocAction = function(docId, action, meta, skipReason, rejectionReason, rtwCheckResults) {
        var defer = $q.defer();

        var data = {action: action};

        if (meta) {
            data['meta_data'] = meta;
        }

        if (skipReason) {
            data['skip_reason'] = skipReason;
        }
        if (rejectionReason) {
            data['rejection_reason'] = rejectionReason;
        }

        if (rtwCheckResults) {
            data['rtw_check_results'] = rtwCheckResults;
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'document_action/' + docId, 'POST', data)
            .then(function(res) {
                if (res && res.data && res.data.status_code == 200 && res.data.data) {
                    defer.resolve(res.data.data);
                }
                else {
                    defer.reject(res);
                }
            },
            function(err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.checkOnboardedByCarri = function (brandId, applicationId, prospectId){
        var defer = $q.defer();

        if (!brandId) {
            throw 'brand id is required';
        }
        else if (!applicationId && !prospectId) {
            throw 'application id or prospect id is required';
        }

        let payload = applicationId? "?application_ids=" + applicationId: "?ids=" + prospectId;

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/prospects' + payload, 'GET')
            .then(function (response) {
                if (response.data.data && response.data.status_code === 200) {
                    defer.resolve(response.data.data);
                }
            }, function (error) {
                defer.reject(error);
            });

        return defer.promise;
    }

    /***
     * Get Brand Non-Candidates
     *
     * @param brandId
     * @returns {deferred.promise|{then, always}}
     */
    self.getOnboardingNonCandidates = function(brandId, visibility, includeArchived){
        var payload = {};
        if (visibility) {
            payload.visibility = visibility
        }
        payload.include_archived = includeArchived;

        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'prospect/'+brandId, 'GET', payload).then(function(res) {
            if(res && res.data && res.data.data && res.data.status_code == 200){
                deferred.resolve(res.data.data);
            }else{
                deferred.reject(res);
            }
        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };


    /****
     * Create profile for non applicant user
     *
     * @param first_name
     * @param last_name
     * @param email
     * @returns {deferred.promise|{then, always}}
     */
    self.createNonApplicant = function (brandId, first_name, last_name, email, phone, received_applicant_consent) {
        var deferred = $q.defer();

        var requestPayload = {
            first_name: first_name,
            last_name: last_name,
            email: email,
            phone: window.intlTelInputUtils.formatNumber(phone),
            received_applicant_consent: !!received_applicant_consent
        };

        _protected.request("brands/" + brandId + "/non_applicant/create_user", 'PUT', requestPayload).then(function (result) {

            if (result && result.data && result.data.data && result.data.status_code == 200) {
                deferred.resolve(result.data.data);
            } else {
                deferred.reject(result);
            }

        }, function (err) {

            deferred.reject(err);
        });

        return deferred.promise;
    };

    /***
     * Create profile for non applicant user
     * @param brand_id
     * @param user_id
     * @param position_id
     * @param type
     * @returns {deferred.promise|{then, always}}
     */
    self.createProspect = function(brand_id,user_id,position_id,type, newHarriUser, applicantConsent){

        var deferred = $q.defer();

        newHarriUser = newHarriUser || false;

        var requestPayload = {
            brand_id: brand_id,
            user_id: user_id,
            position_id: position_id,
            type: type,
            new_harri_user: newHarriUser,
            received_applicant_consent: !!applicantConsent
        };

        _protected.request(publicConfiguration.OnboardingServerBaseURL + "prospect", 'PUT',requestPayload).then(function(result) {

            if(result && result.data && result.data.data && result.data.status_code == 200){
                deferred.resolve(result.data.data);
            }else{
                deferred.reject(result);
            }

        }, function (err) {

            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.documentReminder = function(documentId, reminderType, comments){

        var requestPayload = {
            document_id: documentId,
            reminder_type: reminderType,
            comments: comments
        };

        var deferred = $q.defer();
        _protected.request(publicConfiguration.OnboardingServerBaseURL + "document_action/reminder", 'PUT',requestPayload).then(function(result) {
            if(result && result.data && result.data.data && result.data.status_code == 200){
                deferred.resolve(result.data.data);
            }else{
                deferred.reject(result);
            }

        }, function (err) {

            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.documentPreview =  function(docCode, docData){

        var requestPayload = docData;

        var deferred = $q.defer();
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'document_preview/' + docCode, 'POST', requestPayload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200 && result.data.data.link) {
                    deferred.resolve(result.data.data.link);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {

                deferred.reject(err);
            });

        return deferred.promise;
    };

    /***
     * Update prospect visibility (hide, show)
     *
     * @param prospectId
     * @param visibility: HIDDEN, SHOWN
     * @returns {deferred.promise|{then, always}}
     */
    self.updateProspectVisibility =  function(prospectId, visibility){

        var requestPayload = {
            visibility: visibility
        };

        var deferred = $q.defer();
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'prospect_visibility/' + prospectId, 'POST', requestPayload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                }
                else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getLastDocMeta = function(docCode, docSet, brandId, returnEmptyObject){
        var deferred = $q.defer();

        var url = publicConfiguration.OnboardingServerBaseURL + "last_document_meta/";

        if (!docSet) {
            url = url + docCode;
        }
        else {
            url = url + docSet + '/' + docCode + '/' + brandId;
        }

        _protected.request(url, 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    delete result.data.data.candidate_signed;
                    deferred.resolve(result.data.data);
                } else {
                    if (returnEmptyObject) {
                        deferred.resolve({});
                    } else {
                        deferred.reject(result);
                    }
                }

            }, function (err) {
                if (returnEmptyObject) {
                    deferred.resolve({});
                } else {
                    deferred.reject(err);
                }
            });

        return deferred.promise;
    };


    /**
     * Delete Prospect
     *
     * @param prospectId
     * @returns {deferred.promise|{then, always}}
     */
    self.deleteProspect = function(prospectId){
        var deferred = $q.defer();

        var withdrawData = {
            prospects_ids: [prospectId],
            buckets: ["Offer", "OnBoard"]
        };

        OnBoardingAPI.deleteProspectDocuments(withdrawData)
            .then(function() {
                _protected.request(publicConfiguration.OnboardingServerBaseURL + "prospect/" + prospectId, 'DELETE')
                    .then(function (result) {
                        if (result && result.data && result.data.data && result.data.status_code == 200) {
                            deferred.resolve();
                        } else {
                            deferred.reject(result);
                        }
                    }, function (err) {
                        deferred.reject(err);
                    });
            },
            function(err) {
                deferred.reject(err);
            });


        return deferred.promise;
    };


    /**
     * Get employee reviews reminder for logged in employer
     *
     * @returns {deferred.promise|{then, always}}
     */
    self.getEmployeeReviewReminder = function (groupId) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL +"groups/" + groupId + "/employee_review_reminder", 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.notifyDocumentReviewed = function(documentId) {
        var deferred = $q.defer();
        _protected.request(publicConfiguration.OnboardingServerBaseURL + "candidate/document_reviewed/" + documentId, 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.getPayRollMetaData = function (payRollOptions) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + "payroll_meta", 'GET', payRollOptions)
            .then(function (result) {

                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get user details for payroll purposes
     * @param ids
     * @returns {deferred.promise|{then, always}}
     */
    self.getPayrollUserDetails = function (prospect_ids, application_ids) {
        var deferred = $q.defer();
        var params = {};

        var prospectIDs = prospect_ids.join(',');
        var applicationIDs = application_ids.join(',');

        if (prospect_ids && prospect_ids.length) {
            params['prospect_ids'] = prospectIDs;
        } else if (application_ids && application_ids.length) {
            params['application_ids'] = applicationIDs;
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + "prospects/payroll/info", 'GET', params)
            .then(function (result) {

                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    var prospects = result.data.data.prospects;
                    for (var i in prospects) {
                        var prospect = prospects[i];
                        if (prospect.documents_info) {
                            if (prospect.documents_info['AGREEMENT_DIRECT_DEPOSIT']) {
                                prospect.payment = prospect.documents_info['AGREEMENT_DIRECT_DEPOSIT']
                            }
                            if (prospect.documents_info['AGREEMENT_DIRECT_DEPOSIT_UNIVERSAL_PAYCARD']) {
                                prospect.payment = prospect.documents_info['AGREEMENT_DIRECT_DEPOSIT_UNIVERSAL_PAYCARD']
                            }
                            if (prospect.documents_info['W4']) {
                                prospect.w4_info = prospect.documents_info['W4']
                            }
                            if (prospect.documents_info['EMERGENCY']) {
                                prospect.emergency_info = prospect.documents_info['EMERGENCY']
                            }
                            if (prospect.documents_info['REZIDOR_EMERGENCY_CONTACT']) {
                                prospect.rezidor_emergency_info = prospect.documents_info['REZIDOR_EMERGENCY_CONTACT']
                            }
                            if (prospect.documents_info['EMPLOYEE_STARTER_FORM']) {
                                prospect.starter_form_info = prospect.documents_info['EMPLOYEE_STARTER_FORM']
                            }
                            if (prospect.documents_info['STARTER_CHECKLIST']) {
                                prospect.starter_checklist_info = prospect.documents_info['STARTER_CHECKLIST']
                            }
                            if (prospect.documents_info['EO_DATA_FORM']) {
                                prospect.uk_eo_data_info = prospect.documents_info['EO_DATA_FORM']
                            }
                            if (prospect.documents_info['state_w_info']) {
                                prospect.state_w_info = prospect.documents_info['state_w_info']
                            }
                            if (prospect.documents_info['CDG_EMPLOYEE_STARTER_FORM']) {
                                prospect.cdg_employee_starter_form_info = prospect.documents_info['CDG_EMPLOYEE_STARTER_FORM']
                            }
                            if (prospect.documents_info['BANK_ACCOUNT_DETAILS']) {
                                prospect.uk_bank_account_info = prospect.documents_info['BANK_ACCOUNT_DETAILS']
                            }
                            if (prospect.documents_info['CDG_BANK_ACCOUNT_DETAILS']) {
                                prospect.cdg_bank_account_details_info = prospect.documents_info['CDG_BANK_ACCOUNT_DETAILS']
                            }
                            if (prospect.documents_info['IRL_BANK_ACCOUNT_DETAILS']) {
                                prospect.irl_bank_account_details_info = prospect.documents_info['IRL_BANK_ACCOUNT_DETAILS']
                            }
                            if (prospect.documents_info['CDG_EMERGENCY']) {
                                prospect.cdg_emergency_info = prospect.documents_info['CDG_EMERGENCY']
                            }
                            if (prospect.documents_info['RADISSON_DENMARK_PERSONAL_DETAILS']) {
                                prospect.radisson_denmark_personal_info = prospect.documents_info['RADISSON_DENMARK_PERSONAL_DETAILS']
                            }
                            if (prospect.documents_info['RADISSON_NORWAY_PERSONAL_DETAILS']) {
                                prospect.radisson_norway_personal_info = prospect.documents_info['RADISSON_NORWAY_PERSONAL_DETAILS']
                            }
                            if (prospect.documents_info['RADISSON_EMEA_PERSONAL_LAUFZETTEL']) {
                                prospect.radisson_personal_laufzettel_info = prospect.documents_info['RADISSON_EMEA_PERSONAL_LAUFZETTEL']
                            }
                            if (
                                prospect.documents_info['PREZZO_SUPPORT_CONTRACT'] ||
                                prospect.documents_info['PREZZO_HOURLY_STANDARD_CONTRACT'] ||
                                prospect.documents_info['PREZZO_RESTAURANT_CONTRACT'] ||
                                prospect.documents_info['PREZZO_RESTAURANT_NEW_CONTRACT']
                            ) {
                                prospect.prezzo_contracts = (
                                    prospect.documents_info['PREZZO_SUPPORT_CONTRACT'] ||
                                    prospect.documents_info['PREZZO_HOURLY_STANDARD_CONTRACT'] ||
                                    prospect.documents_info['PREZZO_RESTAURANT_CONTRACT'] ||
                                    prospect.documents_info['PREZZO_RESTAURANT_NEW_CONTRACT']
                                );
                            }
                        }
                        else {
                            prospect.documents_info = {};
                        }
                    }
                    deferred.resolve(prospects);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.downloadProspectDocuments = function(groupId, prospect_ids, docTypes, format) {
        var deferred = $q.defer();

        var downloadData = {};
        docTypes = docTypes || [];

        if (!prospect_ids || prospect_ids.length == 0) {
            downloadData["all"] = true;
        } else {
            downloadData["prospect_ids"] = prospect_ids;
        }

        if (docTypes.length) {
            downloadData["document_lookup_codes"] = docTypes;
        }

        if (format) {
            downloadData["file_structure"] = format;
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL +"groups/"+ groupId + "/download_prospect_documents", 'PUT', downloadData)
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

	self.hireProspectBulk = function (prospect_ids) {
		var deferred = $q.defer();

		var params = {
			prospects: prospect_ids
		};

		_protected.request(publicConfiguration.OnboardingServerBaseURL + "prospect/hiring", 'PUT', params)
				.then(function (result) {
					if (result && result.data && result.data.data && result.data.status_code == 200) {
						deferred.resolve(result.data.data);
					} else {
						deferred.reject(result);
					}
				}, function (err) {
					deferred.reject(err);
				});

		return deferred.promise;
	};

    //Get prospect last document meta
    self.getProspectLastDocumentMeta = function (docCode, prospectId) {
        var deferred = $q.defer();
        _protected.request(publicConfiguration.OnboardingServerBaseURL + "prospect_last_document_meta/" + docCode + "?prospect_id=" + prospectId, 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getStateWithholdingDispatcherTemplate = function (prospectId, docId) {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + "prospects/" + prospectId + "/documents/" + docId + "/template", 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.checkEVerifyStatus = function (brandId, userId, docId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw 'Please send the brand id';
        } else if (!userId) {
            throw 'Please send the user id';
        } else if (!docId) {
            throw 'Please send the doc id';
        } else {
            _protected.request(publicConfiguration.OnboardingServerBaseURL + "brands/" + brandId + "/users/" + userId + "/documents/" + docId + "/e-verify/check", 'GET')
                .then(function (result) {
                    if (result && result.data && result.data.data && result.data.status_code == 200) {
                        deferred.resolve(result.data.data);
                    } else {
                        deferred.reject(result);
                    }
                }, function (err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    };

    self.checkEVerifyExamStatus = function () {
        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + "e_verify/exam/result", 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data.status);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteAttachment = function (attachmentId) {
        var deferred = $q.defer();

        _protected.request(`${publicConfiguration.OnboardingServerBaseURL.replace('v1', 'v2')}attachment/${attachmentId}`, 'DELETE')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data.status);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * This function used to archive candidates.
     *
     * @param prospect_id
     * @param application_id
     * @param reason
     */
    self.archiveCandidate = function (prospect_id, application_id, reason) {

        var defer = $q.defer();

        var data = {
            reason: reason
        };

        if(prospect_id){
            data.prospect_ids =  [prospect_id];
        }else{
            data.application_ids = [application_id];
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'prospects/archive', 'PUT', data)
            .then(function (response) {
                if(response && response.data && response.data.data && response.data.status_code == 200){
                    defer.resolve(response);
                }else{
                    defer.reject(response);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getOnboardingBrandSettings = function (brandId) {

        if (!brandId) {
            throw "Brand id is required for getOnboardingBrandSettings";
        }

        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/settings', 'GET')
            .then(function (response) {
                if (response && response.data && response.data.data && response.data.status_code == 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.moveEmployeeFromPositionToPosition = function (brandId, prospects) {
        if (!brandId) {
            throw "Brand id is required for moveEmployeeFromPositionToPosition";
        }

        var requestPayload = {
            prospects: prospects || []
        };

        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/prospects/positions/move', 'POST', requestPayload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                }
                else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.moveEmployeeFromProspectToLocation = function (brandId, toBrandId, prospects) {
        if (!brandId) {
            throw "Brand id is required for moveEmployeeFromProspectToLocation";
        }

        var requestPayload = {
            prospect_ids: prospects || [],
            to_brand_id: toBrandId
        };

        var deferred = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/prospects/locations/move', 'POST', requestPayload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.status_code == 200) {
                    deferred.resolve(result.data.data);
                }
                else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;

    };

    self.getUnifiedRightToWorkLatestCase = (brandId, userId, documentsCode) => {
        let defer = $q.defer();

        if (!brandId || !userId) {
            throw 'Brand id and user id are required';
        }

        _protected.request(`${publicConfiguration.OnboardingServerBaseURL}brands/${brandId}/users/${userId}/document_lookups/${documentsCode}/documents`, 'GET')
            .then((res) => {
                if (res.status === 200 && res.data) {
                    defer.resolve(res.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    }

    self.getRightToWorkDocuments = function (brandId, prospectId, applicationId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!prospectId && !applicationId) {
            throw "Either prospect id or application id must be sent";
        }

        var payload = prospectId ? {prospect_id: prospectId} : {application_id: applicationId}
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/categories/RIGHT_TO_WORK/prospects/documents', 'GET', payload).then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getCandidateDocuments = (documentsCode, params) => {
        let defer = $q.defer();

        _protected.request(`${publicConfiguration.OnboardingServerBaseURL}users/document_lookups/${documentsCode}/documents`, 'GET', params)
            .then((res) => {
                if (res.status === 200 && res.data?.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    }


    self.completeRTWImposterCheck = async (brandId, documentId, payload) => {
        try {
            if (!brandId) {
                throw "Brand id is required";
            }

            if (!documentId) {
                throw "document id must be sent";
            }

            const response = await _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/documents/' + documentId + '/imposter_checks', 'POST' , payload);
            if (response.data && response.data.data && response.status === 200) {
                return response.data.data;
            } else {
                throw response;
            }
        } catch (err) {
            throw err;
        }
    };

    self.getRightToWorkStatuses = function (brandId, userIds) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/categories/RIGHT_TO_WORK/users/statuses', 'GET', {user_ids: userIds}).then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getApplicationDocumentLastMeta = function (brandId, lookupCode, prospectId, applicationId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!lookupCode) {
            throw "Document lookup is required ";
        }

        if (!prospectId && !applicationId) {
            throw "Either prospect id or application id must be sent";
        }

        var payload = prospectId ? {prospect_id: prospectId} : {application_id: applicationId}

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/document_lookups/' + lookupCode + '/prospects/documents/latest', 'GET', payload).then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getJobLocations = function (brandId, prospectId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!prospectId) {
            throw "Prospect Id is required ";
        }

        var payload = {
            include_job_locations: true
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/prospects/' + prospectId + '/application', 'GET', payload).then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getBrandDocumentSets = function (brandId, includeChildren) {
        var defer = $q.defer();

        if (!brandId) {
            throw "Brand id is required ";
        }

        let payload = {
            include_children: includeChildren || false,
        };

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/document_sets', 'GET', payload)
            .then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            }
            else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getBlockedEmployeesList = function (brandId) {
        var defer = $q.defer();
        if (!brandId) {
            throw "brand id is required ";
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/blocked_users', 'GET').then(function (res) {
            if (res.data && res.data.data && res.data.data.users && res.data.status_code == 200) {
                defer.resolve(res.data.data.users);
            } else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getGFEAnticipatedBrands = function (brandId, template) {
        var defer = $q.defer();
        if (!brandId) {
            throw "brand id is required ";
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/document_lookups/'+  template + '/brands', 'GET').then(function (res) {
            if (res.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getTerminatedProspects = function (brandId) {
        var defer = $q.defer();
        if (!brandId) {
            throw "brand id is required ";
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/prospects/terminated', 'GET').then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getGFEAnticipatedBrands = function (brandId, template) {
        var defer = $q.defer();
        if (!brandId) {
            throw "brand id is required ";
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/document_lookups/'+  template + '/brands', 'GET').then(function (res) {
            if (res.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.removeBlockedEmployee = function (brandId, userId) {
        var defer = $q.defer();
        if (!brandId) {
            throw "brand id is required ";
        }

        if (!userId) {
            throw "user id is required ";
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/blocked_users/users/' + userId, 'DELETE').then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.addBlockedEmployee = function (brandId, prospectId) {
        var defer = $q.defer();
        if (!brandId) {
            throw "brand id is required ";
        }

        var params = {
            prospect_id: prospectId
        };
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/blocked_users', 'POST', params).then(function (res) {
            if (res.data && res.data.data && res.data.status_code == 200) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res);
            }
        }, function (err) {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getEndOfServiceReasons = function (type) {
        var defer = $q.defer();

        if (!type) {
            throw "end of service type is required ";
        }

        var payload = {
            type: type
        };

        var cached = false;

        if (type === OnBoardingAPI.SERVICE_END_REASONS.TERMINATION) {
            if (OnBoardingAPI.TERMINATE_REASONS.length) {
                defer.resolve(angular.copy(OnBoardingAPI.TERMINATE_REASONS));
                cached = true;
            }
        } else if (type === OnBoardingAPI.SERVICE_END_REASONS.ARCHIVING) {
            // need to empty the static variable to be used as cache: OnBoardingAPI.ARCHIVE_REASONS
            // this code always give back static reasons
            if (OnBoardingAPI.ARCHIVE_REASONS.length) {
                defer.resolve(angular.copy(OnBoardingAPI.ARCHIVE_REASONS));
                cached = true;
            }
        }

        if (!cached) {
            _protected.request(publicConfiguration.OnboardingServerBaseURL + 'service_end_reasons', 'GET', payload)
                .then(function (res) {
                    if (res.data && res.data.data && res.data.data.service_end_reasons && res.data.status_code == 200) {
                        var response = angular.copy(res.data.data.service_end_reasons);
                        if (type === OnBoardingAPI.SERVICE_END_REASONS.TERMINATION) {
                            OnBoardingAPI.TERMINATE_REASONS = response;
                            defer.resolve(OnBoardingAPI.TERMINATE_REASONS);
                        } else if (type === OnBoardingAPI.SERVICE_END_REASONS.ARCHIVING) {
                            OnBoardingAPI.ARCHIVE_REASONS = response;
                            defer.resolve(OnBoardingAPI.ARCHIVE_REASONS);
                        }
                    } else {
                        defer.reject(res);
                    }
                })
                .catch(function (err) {
                    defer.reject(err);
                });
        }

        return defer.promise;
    };

    self.rehireEmployee = function (brandId, userId, hireDate, positionCode) {
        var defer = $q.defer();

        if (!brandId) {
            throw "Brand id is required ";
        }

        if (!userId) {
            throw "User id is required ";
        }

        if (!hireDate) {
            throw "Hire Date is required ";
        }

        if (!positionCode) {
            throw "Position Code is required ";
        }

        var payload = {
            user_id: userId,
            hire_date: hireDate,
            position: {
                code: positionCode
            }
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/prospects/rehire', 'POST', payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getProspectsByUserIds = function (brandId, userIds, hiringStates, checkIsBlocked) {
        var defer = $q.defer();

        if (!brandId) {
            throw "Brand id is required ";
        }

        if (!userIds.length) {
            throw "User Ids is required ";
        }

        if (!hiringStates.length) {
            throw "User Ids is required ";
        }

        var payload = {
            user_ids: userIds,
            hiring_states: hiringStates
        }

        if (checkIsBlocked != undefined && checkIsBlocked != null) {
            payload.check_is_blocked = checkIsBlocked;
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/users/prospects', 'GET', payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.data.users && res.data.status_code === 200) {
                    defer.resolve(res.data.data.users);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.reOnboardEmployee = function (brandId, userId, positionCode) {
        let defer = $q.defer();

        if (!brandId) {
            throw "Brand id is required";
        }

        if (!userId) {
            throw "User id is required";
        }

        if (!positionCode) {
            throw "Position Code is required";
        }

        let payload = {
            user_id: userId,
            position: {
                code: positionCode
            }
        }

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/prospects/reonboard', 'POST', payload)
            .then(function (res) {
                if (res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.ExportAllCSV = function (brandId, selectedGroupFilter) {
        let defer = $q.defer();

        if (!brandId) {
            throw 'Brand id is required';
        }

        let params = selectedGroupFilter? {type: selectedGroupFilter} : {};

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/prospects/export', 'POST',  params)
            .then(function (res) {
                if (res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                }
                else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    };

    self.getBrandProspectsByIds = function (brandId, prospectIds, applicationIds) {
        var defer = $q.defer();
        if (!brandId) {
            throw "Brand id is required ";
        }
        if (!prospectIds.length && !applicationIds.length) {
            throw "No prospect or application ids";
        }

        var params = {}
        if (prospectIds.length > 0) {
            params = {ids: prospectIds};
        } else if (applicationIds.length > 0) {
            params = {application_ids : applicationIds};
        }
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'brands/' + brandId + '/prospects', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    }

    self.getCandidatesLink = function(payload) {
        var defer = $q.defer();

        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'export_team_info', 'POST', payload)
            .then(function (res) {
                if (res.data && res.status == 200) {
                    defer.resolve(res.data);
                } else {
                    defer.reject(res);
                }
            }).catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getDocumentLookupUploadUrl = function (documentId, lookupId, fileName) {
        var defer = $q.defer();
        var params = {file_name: fileName};
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'candidates/documents/' + documentId + '/referenced_lookups/' + lookupId + '/upload/presigned_url', 'GET', params)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    }

    self.uploadDocumentLookup = function (documentId, lookupId, data) {
        var defer = $q.defer();
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'candidates/documents/' + documentId + '/referenced_lookups/' + lookupId + '/upload', 'POST', data)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    }

    self.getReferencedGroupDocuments = function (documentId, groupId) {
        var defer = $q.defer();
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'candidates/documents/' + documentId + '/referenced_groups/' + groupId + '/document_lookups', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    }

    self.getReportsPreSignedURL = function () {
        var defer = $q.defer();
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'reports/presigned_url', 'GET')
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    }

    self.reportExport = function (payload) {
        var defer = $q.defer();
        _protected.request(publicConfiguration.OnboardingServerBaseURL + 'reports/export', 'POST', payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    }

    self.getApplicationDocuments = function (brandId, payload, source) {
        var defer = $q.defer();
        const request = source === 'ams' ? publicConfiguration.OnboardingServerBaseURL.replace('v1', 'v2') : publicConfiguration.OnboardingServerBaseURL
        _protected.request(request + 'brands/' + brandId + '/prospects/documents', 'GET', payload)
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code === 200) {
                    defer.resolve(res.data.data.documents);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    }
});

/**
 *
 * [document status]
 */
OnBoardingAPI.appStatuses = {
    REQUESTED: "REQUESTED",
    SIGNED: "SIGNED",
    C_REJECTED: "C_REJECTED",
    PENDING_APPROVAL: "PENDING_APPROVAL",
    PENDING_CANDIDATE_UPLOAD: "PENDING_CANDIDATE_UPLOAD",
    APPROVED: "APPROVED",
    PENDING_MANAGER_APPROVAL: "SIGNED_DOUBLE_C_E",
    SKIPPED: "SKIPPED",
    HIRED: "HIRED",
    OFFER_SENDING: "OFFER_SENDING",
    CORRECTION_RESENT: "CORRECTION_RESENT",
    UPLOADED: "UPLOADED",
    WITHDRAWN: 'WITHDRAWN',
};

OnBoardingAPI.DOCS_CATEGORIES = {
    BRAND_CUSTOM: "BRAND_CUSTOM",
};

/**
 *
 * [custom document type for mydocs document expiration filter]
 */
OnBoardingAPI.customDocumentTypes = {
    i9_expirations: "i9_expirations",
    rtw_expiration_dates: "rtw_expiration_dates",
    food_certification_expirations: "food_certification_expirations",
    alcohol_certification_expirations: "alcohol_certification_expirations",
    insurance_registration_expirations: "insurance_registration_expirations",
    motor_vehicle_record_expirations: "motor_vehicle_record_expirations",
    driver_license_expirations: "driver_license_expirations",
    nmc_expiration_dates: "nmc_expiration_dates",
    minor_work_documentation: "minor_work_documentation",
    minor_work_documentation_age_certificate_expirations: "minor_work_documentation_age_certificate_expirations",
    minor_work_documentation_work_permit_expirations: "minor_work_documentation_work_permit_expirations",
    minor_work_documentation_expirations: "minor_work_documentation_expirations",
    rtw_passport_expirations: "rtw_passport_expirations",
    rtw_id_card_expirations: "rtw_id_card_expirations",
    rtw_visa_expirations: "rtw_visa_expirations",
};

/**
 *
 * [custom document type]
 */
OnBoardingAPI.CUSTOM_DOCUMENT_TYPES = [
    "CUSTOM_DOCUMENT",
    "FOOD_CERTIFICATION",
    "ALCOHOL_CERTIFICATION",
    "MINOR_WORK_DOCUMENTATION",
    "MINOR_WORK_DOCUMENTATION_WORK_PERMIT",
    "MINOR_WORK_DOCUMENTATION_AGE_CERTIFICATE",
    "VACCINATION_CARD",
    "DRIVER_LICENSE",
    "NMC_PIN",
    "INSURANCE_REGISTRATION",
    "MOTOR_VEHICLE_RECORD",
    "CANDIDATE_CUSTOM",
];

OnBoardingAPI.CUSTOM_DOCUMENT_TYPES_TEXT = {
    i9_expirations: "I-9 " + $filter("translate")("Expiration"),
    food_certification_expirations: $filter("translate")("Food Certification"),
    rtw_expiration_dates: $filter("translate")("Right to work"),
    minor_work_documentation: $filter("translate")("Minor Work Documentation"),
    minor_work_documentation_age_certificate_expirations: $filter("translate")("Age certificate"),
    minor_work_documentation_work_permit_expirations: $filter("translate")("Work permit"),
    minor_work_documentation_expirations: $filter("translate")("Others"),
    alcohol_certification_expirations: $filter("translate")("Alcohol Certification"),
    insurance_registration_expirations: $filter("translate")("Insurance Registration"),
    motor_vehicle_record_expirations: $filter("translate")("Motor Vehicle Record"),
    driver_license_expirations: $filter("translate")("Driver License"),
    nmc_expiration_dates: $filter("translate")("NMC Pin"),
    rtw_passport_expirations: $filter("translate")("Passport"),
    rtw_id_card_expirations: $filter("translate")("ID Card"),
    rtw_visa_expirations: $filter("translate")("Visa"),
};

OnBoardingAPI.APP_STATUSES_TEXT = {
    REQUESTED: {
        label: $filter("translate")("Pending employee e-Sign"),
        code: "REQUESTED"
    },
    SIGNED: {
        label: $filter("translate")("Signed"),
        code: "SIGNED"
    },
    C_REJECTED: {
        label: $filter("translate")("Rejected"),
        code: "C_REJECTED"
    },
    APPROVED: {
        label: $filter("translate")("Approved by manager"),
        code: "APPROVED"
    },
    PENDING_MANAGER_APPROVAL: {
        label: $filter("translate")("Pending manager approval"),
        code: "SIGNED_DOUBLE_C_E"
    },
    SKIPPED: {
        label: $filter("translate")("Skipped"),
        code: "SKIPPED"
    },
    CORRECTION_RESENT: {
        label: $filter("translate")("Resent for correction"),
        code: "CORRECTION_RESENT"
    },
    UPLOADED: {
        label: $filter("translate")("Document Uploaded"),
        code: "UPLOADED"
    }
};

/**
 * [document type]
 */
OnBoardingAPI.DOCUMENT_TYPE = {
    I9: "I9",
    W4: "W4",
    OFFER: "OFFER",
    RESUME: "RESUME",
    APPLICATION_DOCUMENT: "APPLICATION_DOCUMENT",
    PING_PONG_CONTRACT: "PING_PONG_CONTRACT",
    MCD_UK_EMPLOYEE_ID: "MCD_UK_EMPLOYEE_ID",
    STICK_SUSHI_CHANGE_EMPLOYMENT_AFLOSER: "STICK_SUSHI_CHANGE_EMPLOYMENT_AFLOSER",
    STICK_SUSHI_CHANGE_EMPLOYMENT_HOURS_SALARY: "STICK_SUSHI_CHANGE_EMPLOYMENT_HOURS_SALARY",
    FAZENDA_CONTRACT: "FAZENDA_CONTRACT",
    YOUNGS_LIVE_IN_OUT_CONTRACT: "YOUNGS_LIVE_IN_OUT_CONTRACT",
    KFC_GB_NEW_STARTER_FORM: "KFC_GB_NEW_STARTER_FORM",
    RADISSON_BELGIUM_INFORMATION_AND_ENROLMENT_FORM: "RADISSON_BELGIUM_INFORMATION_AND_ENROLMENT_FORM",
    FAZENDA_HEAD_OFFICE_CONTRACT: "FAZENDA_HEAD_OFFICE_CONTRACT",
    PING_PONG_CHILDREN_CONTRACT: "PING_PONG_CHILDREN_CONTRACT",
    ENOTECA_DA_LUCA_CONTRACT: "ENOTECA_DA_LUCA_CONTRACT",
    FRANKIE_BENNY_MONITORING_QUESTIONNAIRE: "FRANKIE_BENNY_MONITORING_QUESTIONNAIRE",
    BKUK_WORKING_TIME_OPT_OUT: "BKUK_WORKING_TIME_OPT_OUT",
    PIZZA_PILGIRMS_OPT_OUT: "PIZZA_PILGIRMS_OPT_OUT",
    BRASSERIE_BAR_WORKING_TIME_REGULATION: "BRASSERIE_BAR_WORKING_TIME_REGULATION",
    TNT_OPT_OUT_FORMS: "TNT_OPT_OUT_FORMS",
    DIGITAL_APPLICATION: "DIGITAL_APPLICATION",
    DIGITAL_APPLICATION_OB: "DIGITAL_APPLICATION_OB",
    RUM_KITCHEN_CONTRACT: "RUM_KITCHEN_CONTRACT",
    MINOR_WORK_DOCUMENTATION: "MINOR_WORK_DOCUMENTATION",
    GENERATOR_NETHERLANDS_CONTRACT: "GENERATOR_NETHERLANDS_CONTRACT",
    MINOR_WORK_DOCUMENTATION_WORK_PERMIT: "MINOR_WORK_DOCUMENTATION_WORK_PERMIT",
    MINOR_WORK_DOCUMENTATION_AGE_CERTIFICATE: "MINOR_WORK_DOCUMENTATION_AGE_CERTIFICATE",
    VACCINATION_CARD: "VACCINATION_CARD",
    STATE_W_NY: "STATE_W_NY",
    STATE_W_CA: "STATE_W_CA",
    RADISSON_FRANCE_PERSONAL_DETAILS: "RADISSON_FRANCE_PERSONAL_DETAILS",
    TAX_CREDIT: "TAX_CREDIT",
    EEO: "EEO",
    EMERGENCY: "EMERGENCY",
    RADISSON_BELGIUM_FAMILY_DECLARATION_FR: "RADISSON_BELGIUM_FAMILY_DECLARATION_FR",
    RADISSON_BELGIUM_FAMILY_DECLARATION_NL: "RADISSON_BELGIUM_FAMILY_DECLARATION_NL",
    RADISSON_BELGIUM_PERSONAL_DETAILS: "RADISSON_BELGIUM_PERSONAL_DETAILS",
    HARTS_EMERGENCY: "HARTS_EMERGENCY",
    SAFETY_TRAINING: "SAFETY_TRAINING",
    HANDBOOK: "HANDBOOK",
    TIP_POLICY: "TIP_POLICY",
    PAY_RATE: "PAY_RATE",
    END_OF_SERVICE: "END_OF_SERVICE",
    POST_HIRE: "POST_HIRE",
    HR_ACTION: "HR_ACTION",
    BRAND_CUSTOM: 'BRAND_CUSTOM',
    IRS_8850: "IRS_8850",
    NOTICE_EMPLOYEE_GENERAL: "NOTICE_EMPLOYEE_GENERAL",
    NOTICE_EMPLOYEE_NY: "NOTICE_EMPLOYEE_NY",
    CAFUA_NOTICE_OF_PAY: "CAFUA_NOTICE_OF_PAY",
    NOTICE_EMPLOYEE_NY_HOURLY: "NOTICE_EMPLOYEE_NY_HOURLY",
    NOTICE_EMPLOYEE_NY_MULTI_RATE: "NOTICE_EMPLOYEE_NY_MULTI_RATE",
    NOTICE_EMPLOYEE_NY_SALARY: "NOTICE_EMPLOYEE_NY_SALARY",
    NOTICE_EMPLOYEE_CA: "NOTICE_EMPLOYEE_CA",
    UPHAM_ACCOMMODATION_AGREEMENT: "UPHAM_ACCOMMODATION_AGREEMENT",
    BURGER_LOBSTER_CONTRACT: "BURGER_LOBSTER_CONTRACT",
    BURGER_LOBSTER_HO_CONTRACT: "BURGER_LOBSTER_HO_CONTRACT",
    GOODMANS_CONTRACT: "GOODMANS_CONTRACT",
    GOODMANS_HO_CONTRACT: "GOODMANS_HO_CONTRACT",
    AGREEMENT_DIRECT_DEPOSIT: "AGREEMENT_DIRECT_DEPOSIT",
    AGREEMENT_DIRECT_DEPOSIT_CA: "AGREEMENT_DIRECT_DEPOSIT_CA",
    WISELY_WAGE_PAYMENT: "WISELY_WAGE_PAYMENT",
    KRICKET_EMPLOYMENT_LETTER: "KRICKET_EMPLOYMENT_LETTER",
    CUSTOM_DOCUMENT: "CUSTOM_DOCUMENT",
    AGREEMENT_DIRECT_DEPOSIT_UNIVERSAL_PAYCARD: "AGREEMENT_DIRECT_DEPOSIT_UNIVERSAL_PAYCARD",
    FOOD_CERTIFICATION: "FOOD_CERTIFICATION",
    ZETTER_CONTRACT: "ZETTER_CONTRACT",
    COTE_CONTRACT: "COTE_CONTRACT",
    "CARLUCCIOS_N_CONTRACT": "CARLUCCIOS_N_CONTRACT",
    ALCOHOL_CERTIFICATION: "ALCOHOL_CERTIFICATION",
    INSURANCE_REGISTRATION: "INSURANCE_REGISTRATION",
    MOTOR_VEHICLE_RECORD: "MOTOR_VEHICLE_RECORD",
    DRIVER_LICENSE: "DRIVER_LICENSE",
    NMC_PIN: "NMC_PIN",
    TENPIN_CONTRACT: "TENPIN_CONTRACT",
    TENPIN_SUPPORT_CONTRACT: "TENPIN_SUPPORT_CONTRACT",
    EMPLOYEE_AVAILABILITY: "EMPLOYEE_AVAILABILITY",
    EMPLOYEE_STARTER: "EMPLOYEE_STARTER_FORM",
    IRL_EMPLOYEE_STARTER_FORM: "IRL_EMPLOYEE_STARTER_FORM",
    US_CAN_MIN_STARTER_FORM:"US_CAN_MIN_STARTER_FORM",
    HOUSE_CAFE_HEALTH_QUESTIONNAIRE: "HOUSE_CAFE_HEALTH_QUESTIONNAIRE",
    IRL_HEALTH_QUESTIONNAIRE: "IRL_HEALTH_QUESTIONNAIRE",
    "NEWFOUNDLAND_AND_LABRADOR_TAX": "NEWFOUNDLAND_AND_LABRADOR_TAX",
    ARTFARM_EEO: "ARTFARM_EEO",
    SASKATCHEWAN_TAX: "SASKATCHEWAN_TAX",
    NEW_BRUNSWICK_TAX:"NEW_BRUNSWICK_TAX",
    NOVA_SCOTIA_TAX: "NOVA_SCOTIA_TAX",
    NORTHWEST_TERRITORIES_TAX:"NORTHWEST_TERRITORIES_TAX",
    PRINCE_EDWARD_ISLAND_TAX:"PRINCE_EDWARD_ISLAND_TAX",
    YUKON_TAX:"YUKON_TAX",
    EEO_UK: "EEO_UK",
    EEO_CA: "EEO_CA",
    ALBERTA_TAX: "ALBERTA_TAX",
    STATE_W_MA: "STATE_W_MA",
    STATE_W_MN: "STATE_W_MN",
    NOTICE_EMPLOYEE_MN: "NOTICE_EMPLOYEE_MN",
    STATE_W_MD: "STATE_W_MD",
    STATE_W_MS: "STATE_W_MS",
    STATE_W_OK: "STATE_W_OK",
    STATE_W_OR: "STATE_W_OR",
    STATE_W_AL: "STATE_W_AL",
    STATE_W_MT: "STATE_W_MT",
    STATE_W_VA: "STATE_W_VA",
    STATE_W_DC: "STATE_W_DC",
    STATE_W_NJ: "STATE_W_NJ",
    STATE_W_IL: "STATE_W_IL",
    STATE_W_KY: "STATE_W_KY",
    STATE_W_IN: "STATE_W_IN",
    STATE_W_OH: "STATE_W_OH",
    STATE_W_PR: "STATE_W_PR",
    STATE_W_DC_NON_RESIDENCE: "STATE_W_DC_NON_RESIDENCE",
    STATE_W_GA: "STATE_W_GA",
    STATE_W_IA: "STATE_W_IA",
    STATE_W_HI: "STATE_W_HI",
    STATE_W_ID: "STATE_W_ID",
    STATE_W_SC: "STATE_W_SC",
    STATE_W_NE: "STATE_W_NE",
    STATE_W_CO: "STATE_W_CO",
    MD_MW507M: "MD_MW507M",
    BENEFITS_NOTICE: "BENEFITS_NOTICE",
    DISCLOSURE_AUTH: "DISCLOSURE_AUTH",
    NOTICE_OF_HIRE: "NOTICE_OF_HIRE",
    HEALTH_QUESTIONNAIRE: "HEALTH_QUESTIONNAIRE",
    BRASSERIE_HEALTH_QUESTIONNAIRE: "BRASSERIE_HEALTH_QUESTIONNAIRE",
    TRAINING_SCHEDULE: "TRAINING_SCHEDULE",
    COMMUTER_BENEFITS: "COMMUTER_BENEFITS",
    COMMUTER_BENEFITS_DOUBLE: "COMMUTER_BENEFITS_DOUBLE",
    COMMUTER_BENEFITS_DOUBLE_NJ: "COMMUTER_BENEFITS_DOUBLE_NJ",
    DC_COMMUTER_BENEFITS: "DC_COMMUTER_BENEFITS",
    MEATBALL_SHOP_DC_COMMUTER_BENEFITS: "MEATBALL_SHOP_DC_COMMUTER_BENEFITS",
    IRL_DOUBLE_EMPLOYMENT_FORM: "IRL_DOUBLE_EMPLOYMENT_FORM",
    WAIVE_MEAL_PERIODS: "WAIVE_MEAL_PERIODS",
    STARTER_CHECKLIST: "STARTER_CHECKLIST",
    CAFUA_DIRECT_DEPOSIT: "CAFUA_DIRECT_DEPOSIT",
    CAFUA_NH_DIRECT_DEPOSIT: "CAFUA_NH_DIRECT_DEPOSIT",
    CAFUA_DIRECT_DEPOSIT_DEFAULT: "CAFUA_DIRECT_DEPOSIT_DEFAULT",
    WAIVER_GROUP_INSURANCE_PLAN: "WAIVER_GROUP_INSURANCE_PLAN",
    MINOR_AGE_AGREEMENT_OH: "MINOR_AGE_AGREEMENT_OH",
    RESIDENCY_CERTIFICATION: "RESIDENCY_CERTIFICATION",
    TRANSIT_CHECK: "TRANSIT_CHECK",
    TRANSIT_CHECK_ESP: "TRANSIT_CHECK_ESP",
    COMMUTER_BENEFITS_ENROLLMENT: "COMMUTER_BENEFITS_ENROLLMENT",
    NOTICE_EMPLOYEE_CHANGE_RELATIONSHIP: "NOTICE_EMPLOYEE_CHANGE_RELATIONSHIP",
    CONFIDENTIAL_SEPARATION_AGREEMENT_RELEASE: "CONFIDENTIAL_SEPARATION_AGREEMENT_RELEASE",
    EMPLOYEE_TERMINATION_NY: "EMPLOYEE_TERMINATION_NY",
    REZIDOR_BENEFICIARY_DETAILS: "REZIDOR_BENEFICIARY_DETAILS",
    AT_NOMINATION_OF_BENEFICIARY:"AT_NOMINATION_OF_BENEFICIARY",
    E2_PAY_RATE: "E2_PAY_RATE",
    EO_DATA_FORM: "EO_DATA_FORM",
    FOURTH_EO_DATA_FORM: "FOURTH_EO_DATA_FORM",
    RADISSON_ITALY_EMPLOYEE_RECORD: "RADISSON_ITALY_EMPLOYEE_RECORD",
    FIRE_HEALTH_SAFETY_DECLARATION: "FIRE_HEALTH_SAFETY_DECLARATION",
    REZIDOR_HEALTH_QUESTIONNAIRE: "REZIDOR_HEALTH_QUESTIONNAIRE",
    DEEP_BLUE_HEALTH_QUESTIONNAIRE:"DEEP_BLUE_HEALTH_QUESTIONNAIRE",
    PIZZA_HUT_EXPRESSION_OF_WISH:"PIZZA_HUT_EXPRESSION_OF_WISH",
    PIZZA_HUT_DVLA_MANDATE:"PIZZA_HUT_DVLA_MANDATE",
    THE_CONDUIT_STARTER_FORM:"THE_CONDUIT_STARTER_FORM",
    ZUMA_FICHA_DE_EMPLEO: "ZUMA_FICHA_DE_EMPLEO",
    PAPA_JOHNS_DRIVER_VEHICLE_FORM:"PAPA_JOHNS_DRIVER_VEHICLE_FORM",
    CREATIVE_CULINARY_HEALTH_INSURANCE_SURVEY:"CREATIVE_CULINARY_HEALTH_INSURANCE_SURVEY",
    STICK_SUSHI_DK_STARTER_FORM:"STICK_SUSHI_DK_STARTER_FORM",
    EPS_STARTER_FORM: "EPS_STARTER_FORM",
    CONTRACT: "CONTRACT",
    ANDREW_BROWNSWORD_CONTRACT: "ANDREW_BROWNSWORD_CONTRACT",
    ANDREW_BROWNSWORD_ACCOMMODATION: "ANDREW_BROWNSWORD_ACCOMMODATION",
    THE_BATH_PRIORY_CONTRACT: "THE_BATH_PRIORY_CONTRACT",
    GENERATOR_SPAIN_CONTRACT: "GENERATOR_SPAIN_CONTRACT",
    GENERATOR_DENMARK_CONTRACT: "GENERATOR_DENMARK_CONTRACT",
    VILAGE_EAST_CONTRACT: "VILAGE_EAST_CONTRACT",
    RIDING_HOUSE_CAFE_CONTRACT: "RIDING_HOUSE_CAFE_CONTRACT",
    RAILHOUSE_CAFE_CONTRACT: "RAILHOUSE_CAFE_CONTRACT",
    RIDING_HOUSE_CAFE_HQ_CONTRACT: "RIDING_HOUSE_CAFE_HQ_CONTRACT",
    JOB_DESCRIPTION: "JOB_DESCRIPTION",
    POSITION_DOCS: "POSITION_DOCS",
    DOCUMENTS_CONTAINER: "DOCUMENTS_CONTAINER",
    YO_SUSHI_CONTRACT: "YO_SUSHI_CONTRACT",
    YO_SUSHI_REFERENCE_DETAILS: "YO_SUSHI_REFERENCE_DETAILS",
    TFG_REFERRAL_BONUS_PROGRAM: "TFG_REFERRAL_BONUS_PROGRAM",
    ARF_WAIVER_COVERAGE_FORM: "ARF_WAIVER_COVERAGE_FORM",
    SJB_WAIVER_COVERAGE_FORM: "SJB_WAIVER_COVERAGE_FORM",
    CREATIVE_CULINARY_MANAGEMENT_HANDBOOK: "CREATIVE_CULINARY_MANAGEMENT_HANDBOOK",
    MANITOBA_TAX: "MANITOBA_TAX",
    APPLEBEES_TL_CANNON_EMPLOYMENT_APPLICATION: "APPLEBEES_TL_CANNON_EMPLOYMENT_APPLICATION",
    THE_ONE_CODE_OF_CONDUCT: "THE_ONE_CODE_OF_CONDUCT",
    STICK_SUSHI_DE_STARTER_FORM: "STICK_SUSHI_DE_STARTER_FORM",
    REAL_RESTAURANT_SICK_FORM: "REAL_RESTAURANT_SICK_FORM",
    BKUK_REFERENCE_FORM: "BKUK_REFERENCE_FORM",
    REZIDOR_NIGHT_WORKERS: "REZIDOR_NIGHT_WORKERS",
    REZIDOR_FOOD_HANDLERS_DECLARATION: "REZIDOR_FOOD_HANDLERS_DECLARATION",
    REZIDOR_PENSION_SCHEME: "REZIDOR_PENSION_SCHEME",
    STATE_W_NC: "STATE_W_NC",
    YO_SUSHI_TEAM_MEMBER_CONTRACT: "YO_SUSHI_TEAM_MEMBER_CONTRACT",
    STATE_W_CT: "STATE_W_CT",
    STATE_W_WI: "STATE_W_WI",
    STATE_W_WV: "STATE_W_WV",
    STATE_W_LS: "STATE_W_LS",
    STATE_W_KS: "STATE_W_KS",
    STATE_W_VT: "STATE_W_VT",
    STATE_W_ME: "STATE_W_ME",
    STATE_W_DE: "STATE_W_DE",
    STATE_W_MO: "STATE_W_MO",
    LA_OWCA: "LA_OWCA",
    STATE_W_AZ: "STATE_W_AZ",
    STATE_W_AR: "STATE_W_AR",
    WESTCHESTER_EARNED_SICK_LEAVE: "WESTCHESTER_EARNED_SICK_LEAVE",
    HARBOUR_UNIFORM: "HARBOUR_UNIFORM",
    QUEBEC_TAX: "QUEBEC_TAX",
    ART_CLUB_DUBAI_BANK_ACCOUNT_DETAILS: "ART_CLUB_DUBAI_BANK_ACCOUNT_DETAILS",
    BRITISH_COLUMBIA_TAX: "BRITISH_COLUMBIA_TAX",
    STATE_W_MI: "STATE_W_MI",
    E2_PAY_RATE_SALARY: "E2_PAY_RATE_SALARY",
    CATCH_HOSPITALITY_ARBITRATION_AGREEMENT: "CATCH_HOSPITALITY_ARBITRATION_AGREEMENT",
    REZIDOR_BLU_EXECUTIVE_CONTRACT: "REZIDOR_BLU_EXECUTIVE_CONTRACT",
    REZIDOR_JERSEY_CONTRACT: "REZIDOR_JERSEY_CONTRACT",
    REZIDOR_JERSEY_EXECUTIVE_CONTRACT: "REZIDOR_JERSEY_EXECUTIVE_CONTRACT",
    REZIDOR_PARK_EXECUTIVE_CONTRACT: "REZIDOR_PARK_EXECUTIVE_CONTRACT",
    DIRTY_BONES_CONTRACT: "DIRTY_BONES_CONTRACT",
    REZIDOR_WORKING_TIME: "REZIDOR_WORKING_TIME",
    BANK_ACCOUNT_DETAILS: "BANK_ACCOUNT_DETAILS",
    WORKS_BANK_ACCOUNT_DETAILS: "WORKS_BANK_ACCOUNT_DETAILS",
    IRL_BANK_ACCOUNT_DETAILS: "IRL_BANK_ACCOUNT_DETAILS",
    NANDOS_BG_CHECK: "NANDOS_BG_CHECK",
    REZIDOR_ELIGIBLE_EMPLOYEES: "REZIDOR_ELIGIBLE_EMPLOYEES",
    REZIDOR_POSTPONEMENT_NOTICE: "REZIDOR_POSTPONEMENT_NOTICE",
    REZIDOR_SCOTTISH_WIDOW_GROUP: "REZIDOR_SCOTTISH_WIDOW_GROUP",
    RADISSON_SCOTTISH_WIDOW_GROUP: "RADISSON_SCOTTISH_WIDOW_GROUP",
    PREZZO_SUPPORT_CONTRACT: "PREZZO_SUPPORT_CONTRACT",
    PREZZO_HEALTH_QUESTIONNAIRE: "PREZZO_HEALTH_QUESTIONNAIRE",
    PREZZO_RESTAURANT_CONTRACT: "PREZZO_RESTAURANT_CONTRACT",
    PREZZO_RESTAURANT_NEW_CONTRACT: "PREZZO_RESTAURANT_NEW_CONTRACT",
    PREZZO_HOURLY_STANDARD_CONTRACT: "PREZZO_HOURLY_STANDARD_CONTRACT",
    ETM_CONTRACT: "ETM_CONTRACT",
    BISCUITEERS_STAFF_MEDICAL_SCREENING: "BISCUITEERS_STAFF_MEDICAL_SCREENING",
    SAN_DIEGO_SICK_AND_WAGE: "SAN_DIEGO_SICK_AND_WAGE",
    LANCASTER_CONTRACT: "LANCASTER_CONTRACT",
    WYBOSTON_LAKES_CONTRACT: "WYBOSTON_LAKES_CONTRACT",
    LANCASTER_EVENTS_OP_CONTRACT: "LANCASTER_EVENTS_OP_CONTRACT",
    LANCASTER_FB_CONTRACT: "LANCASTER_FB_CONTRACT",
    LANCASTER_MANAGEMENT_CONTRACT: "LANCASTER_MANAGEMENT_CONTRACT",
    MARKET_HALL_MENTAL_HEALTH: "MARKET_HALL_MENTAL_HEALTH",
    CAVA_GRILL_HEALTH_CONDITION: "CAVA_GRILL_HEALTH_CONDITION",
    GRAND_BRIGHTON_CONTRACT: "GRAND_BRIGHTON_CONTRACT",
    HONEST_BURGERS_CONTRACT: "HONEST_BURGERS_CONTRACT",
    DARK_KITCHEN_CONTRACT: "DARK_KITCHEN_CONTRACT",
    PIZZA_PILGRIMS_CONTRACT: "PIZZA_PILGRIMS_CONTRACT",
    PIZZA_PILGRIMS_CHILD_CONTRACT: "PIZZA_PILGRIMS_CHILD_CONTRACT",
    PIZZA_PILGRIMS_CHILD_WITH_TRONC_CONTRACT: "PIZZA_PILGRIMS_CHILD_WITH_TRONC_CONTRACT",
    SLIM_CHICKENS_NEW_CONTRACT: "SLIM_CHICKENS_NEW_CONTRACT",
    CARLUCCIOS_NEW_CONTRACT: "CARLUCCIOS_NEW_CONTRACT",
    CINNAMON_CONTRACT: "CINNAMON_CONTRACT",
    HONEST_BURGERS_HEAD_OFFICE_CONTRACT: "HONEST_BURGERS_HEAD_OFFICE_CONTRACT",
    HONEST_BURGERS_CONTRACT_HOURLY_ONLY: "HONEST_BURGERS_CONTRACT_HOURLY_ONLY",
    LANCASTER_LANDMARK_DISCLOSURE: "LANCASTER_LANDMARK_DISCLOSURE",
    LANCASTER_LANDMARK_MEDICAL_QUESTIONNAIRE: "LANCASTER_LANDMARK_MEDICAL_QUESTIONNAIRE",
    DOMINOS_PIZZA_PARTNERS_FOUNDATION: "DOMINOS_PIZZA_PARTNERS_FOUNDATION",
    LANCASTER_LANDMARK_REFERENCES: "LANCASTER_LANDMARK_REFERENCES",
    LANCASTER_LANDMARK_DEATH_ASSURANCE: "LANCASTER_LANDMARK_DEATH_ASSURANCE",
    LANCASTER_LANDMARK_EEO: "LANCASTER_LANDMARK_EEO",
    LANDMARK_CONTRACT: "LANDMARK_CONTRACT",
    IRL_REFERENCE_FORM: "IRL_REFERENCE_FORM",
    TRANSPORTATION_BENEFIT_FORM: "TRANSPORTATION_BENEFIT_FORM",
    CANDIDATE_ACCEPTANCE_FORM: "CANDIDATE_ACCEPTANCE_FORM",
    STATE_W_DISPATCHER: "STATE_W_DISPATCHER",
    IDENTITY_DOCUMENT: "IDENTITY_DOCUMENT",
    ASCOTT_CONTRACT: "ASCOTT_CONTRACT",
    MAWGLI_CONTRACT: "MAWGLI_CONTRACT",
    THE_LOWRY_CONTRACT: "THE_LOWRY_CONTRACT",
    COTE_OPT_OUT: "COTE_OPT_OUT",
    DEEP_BLUE_CONTRACT: "DEEP_BLUE_CONTRACT",
    APOS_ACCOMMODATION_AGREEMENT: "APOS_ACCOMMODATION_AGREEMENT",
    CW_ACCOMMODATION_AGREEMENT: "CW_ACCOMMODATION_AGREEMENT",
    COMBINED_DISCLOSURE_AUTHORIZATION: "COMBINED_DISCLOSURE_AUTHORIZATION",
    LOCKER_LOCK_AGREEMENT: "LOCKER_LOCK_AGREEMENT",
    NOHO_TRANSIT_CARD: "NOHO_TRANSIT_CARD",
    AOK_CONTRACT: "AOK_CONTRACT",
    ART_CLUB_CONTRACT: "ART_CLUB_CONTRACT",
    WAGAMAMA_MANAGER_CONTRACT: "WAGAMAMA_MANAGER_CONTRACT",
    WAGAMAMA_HEAD_OFFICE_CONTRACT: "WAGAMAMA_HEAD_OFFICE_CONTRACT",
    WAGAMAMA_TEAM_CONTRACT: "WAGAMAMA_TEAM_CONTRACT",
    PARIS_BAGUETTE_WAGE_PAYMENT_FORM: "PARIS_BAGUETTE_WAGE_PAYMENT_FORM",
    ART_CLUB_CONTRACT_JUNIOR: "ART_CLUB_CONTRACT_JUNIOR",
    TRUMP_UK_UNIFORM_SIZE_SHEET: "TRUMP_UK_UNIFORM_SIZE_SHEET",
    BLAKENEY_UNIFORM_SIZE: "BLAKENEY_UNIFORM_SIZE",
    IVY_HEALTH_QUESTIONNAIRE: "IVY_HEALTH_QUESTIONNAIRE",
    ARABICA_RETURN_TO_WORK_CORONA: "ARABICA_RETURN_TO_WORK_CORONA",
    BICOS_APPLICANT_STATEMENT: "BICOS_APPLICANT_STATEMENT",
    FARMER_BOYS_MEAL_WAIVER_AGREEMENT: "FARMER_BOYS_MEAL_WAIVER_AGREEMENT",
    US_FEDERAL_FORM_1_A: "US_FEDERAL_FORM_1_A",
    HARRYS_DOLCI_HEALTH_QUESTIONNAIRE: "HARRYS_DOLCI_HEALTH_QUESTIONNAIRE",
    GRANARY_SQUARE_HEALTH_QUESTIONNAIRE: "GRANARY_SQUARE_HEALTH_QUESTIONNAIRE",
    EAST_COAST_HEALTH_QUESTIONNAIRE: "EAST_COAST_HEALTH_QUESTIONNAIRE",
    LITTLE_GEMS_FOOD_HANDLERS_QUESTIONNAIRE: "LITTLE_GEMS_FOOD_HANDLERS_QUESTIONNAIRE",
    GUACHO_HEALTH_QUESTIONNAIRE: "GUACHO_HEALTH_QUESTIONNAIRE",
    STEAK_N_SHAKE_W2_FORM: "STEAK_N_SHAKE_W2_FORM",
    STEAK_N_SHAKE_ASSOCIATE_EMERGENCY: "STEAK_N_SHAKE_ASSOCIATE_EMERGENCY",
    TATTU_COV19_VULNERABILITY_ASSESSMENT: "TATTU_COV19_VULNERABILITY_ASSESSMENT",
    ABC_BENEFIT_ELECTION_SWIPE_N_SAVE: "ABC_BENEFIT_ELECTION_SWIPE_N_SAVE",
    ST_AUSTELL_HEALTH_QUESTIONNAIRE: "ST_AUSTELL_HEALTH_QUESTIONNAIRE",
    MICHAEL_CAINES_HEALTH_QUESTIONNAIRE: "MICHAEL_CAINES_HEALTH_QUESTIONNAIRE",
    BOPARAN_HEALTH_QUESTIONNAIRE: "BOPARAN_HEALTH_QUESTIONNAIRE",
    PJ_ALL_DELIVERY_DRIVER_INFO: "PJ_ALL_DELIVERY_DRIVER_INFO",
    ST_AUSTELL_PERSONAL_FORM: "ST_AUSTELL_PERSONAL_FORM",
    FRONT_BURNER_NEW_HIRE_FORM: "FRONT_BURNER_NEW_HIRE_FORM",
    REV_419_EX_FORM: "REV_419_EX_FORM",
    GUACHO_COVID_HEALTH_QUESTIONNAIRE: "GUACHO_COVID_HEALTH_QUESTIONNAIRE",
    IVY_STORE_APPROVAL_FORM: "IVY_STORE_APPROVAL_FORM",
    CHARLES_EMPLOYEE_DETAILS_FORM: "CHARLES_EMPLOYEE_DETAILS_FORM",
    AT_STAFF_ACCEPTANCE_FORM: "AT_STAFF_ACCEPTANCE_FORM",
    GUACHO_TIME_OPT_OUT: "GUACHO_TIME_OPT_OUT",
    ART_CLUB_HEALTH_QUESTIONNAIRE: "ART_CLUB_HEALTH_QUESTIONNAIRE",
    PIZZA_HUT_HEALTHCARE_PLAN: "PIZZA_HUT_HEALTHCARE_PLAN",
    WYNDHAM_STARTER_FORM: "WYNDHAM_STARTER_FORM",
    KFC_WELCOME_LETTER: "KFC_WELCOME_LETTER",
    KFC_PENNIES_FOR_CHANGE: "KFC_PENNIES_FOR_CHANGE",
    KFC_EXPRESSION_OF_WISH: "KFC_EXPRESSION_OF_WISH",
    ARTFARM_HEALTH_QUESTIONNAIRE: "ARTFARM_HEALTH_QUESTIONNAIRE",
    AHH_MEDIA_CONSENT: "AHH_MEDIA_CONSENT",
    NORTHERN_MANAGEMENT_MEDICAL_LEAVE_NOTICE_WEST: "NORTHERN_MANAGEMENT_MEDICAL_LEAVE_NOTICE_WEST",
    NORTHERN_MANAGEMENT_MEDICAL_LEAVE_NOTICE_EAST: "NORTHERN_MANAGEMENT_MEDICAL_LEAVE_NOTICE_EAST",
    AHH_WORKING_TIME_REGULATIONS_OPT_OUT: "AHH_WORKING_TIME_REGULATIONS_OPT_OUT",
    WYNDHAM_MATERIALS_EQUIPMENT: "WYNDHAM_MATERIALS_EQUIPMENT",
    ART_CLUB_DUBAI_IMMIGRATION_FORM: "ART_CLUB_DUBAI_IMMIGRATION_FORM",
    RBM_MEAL_TIME_WAIVER: "RBM_MEAL_TIME_WAIVER",
    FMI_PRIDE_FUND_ENROLLMENT: "FMI_PRIDE_FUND_ENROLLMENT",
    STREET_GUYS_COMMUTER_BENEFITS: "STREET_GUYS_COMMUTER_BENEFITS",
    JERSY_MIKES_WC_INFORMATION_FORM: "JERSY_MIKES_WC_INFORMATION_FORM",
    JERSY_MIKES_WC_NOTIFICATION_FORM: "JERSY_MIKES_WC_NOTIFICATION_FORM",
    KFC_EEO_FORM: "KFC_EEO_FORM",
    JIMBBQ_FAMILY_FUND_PAYROLL_DEDUCTION_AUTHORIZATION: "JIMBBQ_FAMILY_FUND_PAYROLL_DEDUCTION_AUTHORIZATION",
    BRINDISA_HEALTH_QUESTIONNAIRE: "BRINDISA_HEALTH_QUESTIONNAIRE",
    COYA_CONTRACT: "COYA_CONTRACT",
    HUDSON_WOTC_TAX_CREDIT_QUESTIONNAIRE: "HUDSON_WOTC_TAX_CREDIT_QUESTIONNAIRE",
    MERAKI_STARTER_FORM: "MERAKI_STARTER_FORM",
    WORKS_INCOME_TAX: "WORKS_INCOME_TAX",
    HUDSON_NY_YOUTH_QUESTIONNAIRE: "HUDSON_NY_YOUTH_QUESTIONNAIRE",
    BASTION_EMPLOYEE_NOTICE_FAMILY_LEAVE: "BASTION_EMPLOYEE_NOTICE_FAMILY_LEAVE",
    WAFELS_DINGES_MVR_RELEASE_FORM: "WAFELS_DINGES_MVR_RELEASE_FORM",
    ISLAND_POKE_EMPLOYEE_STARTER_FORM: "ISLAND_POKE_EMPLOYEE_STARTER_FORM",
    FISHWORKS_CONTRACT: "FISHWORKS_CONTRACT",
    GENERATOR_GELON_CONTRACT: "GENERATOR_GELON_CONTRACT",
    GENERATOR_GENHQ_CONTRACT: "GENERATOR_GENHQ_CONTRACT",
    GBK_CENTRAL_CONTRACT: "GBK_CENTRAL_CONTRACT",
    GBK_UK_RESTAURANT_CONTRACT: "GBK_UK_RESTAURANT_CONTRACT",
    GBK_IR_RESTAURANT_CONTRACT: "GBK_IR_RESTAURANT_CONTRACT",
    GBK_MANAGEMENT_CONTRACT: "GBK_MANAGEMENT_CONTRACT",
    QUBIC_MANAGEMENT_CONTRACT: "QUBIC_MANAGEMENT_CONTRACT",
    FRONT_BURNER_COMPENSATION_ACKNOWLEDGEMENT: "FRONT_BURNER_COMPENSATION_ACKNOWLEDGEMENT",
    GRABTHAI_CONTRACT: "GRABTHAI_CONTRACT",
    BELFRY_NOMINATION_OF_BENEFICIARY: "BELFRY_NOMINATION_OF_BENEFICIARY",
    CW_MANAGED_HOUSE_CONTRACT: "CW_MANAGED_HOUSE_CONTRACT",
    ARTS_CLUB_REVISED_OFFER: "ARTS_CLUB_REVISED_OFFER",
    CW_APOSTROPHE_GM_CONTRACT: "CW_APOSTROPHE_GM_CONTRACT",
    CW_APOSTROPHE_CONTRACT: "CW_APOSTROPHE_CONTRACT",
    TENPIN_LIVE_ASSURANCE_FORM: "TENPIN_LIVE_ASSURANCE_FORM",
    CW_PIZZA_POT_CONTRACT:"CW_PIZZA_POT_CONTRACT",
    CW_PIZZA_POT_GM_CONTRACT:"CW_PIZZA_POT_GM_CONTRACT",
    CW_MASTER_CONTRACT: "CW_MASTER_CONTRACT",
    ISLAND_POKE_CONTRACT: "ISLAND_POKE_CONTRACT",
    HARBOUR_CONTRACT: "HARBOUR_CONTRACT",
    WYNDHAM_MEDICAL_QUESTIONNAIRE: "WYNDHAM_MEDICAL_QUESTIONNAIRE",
    WYNDHAM_DECLARATION: "WYNDHAM_DECLARATION",
    CW_MASTER_WEEKLY_CONTRACT: "CW_MASTER_WEEKLY_CONTRACT",
    CW_MASTER_MONTHLY_CONTRACT: "CW_MASTER_MONTHLY_CONTRACT",
    CW_MANAGED_HOUSE_SALARIED_CONTRACT: "CW_MANAGED_HOUSE_SALARIED_CONTRACT",
    CW_MANAGED_HOUSE_HOURLY_CONTRACT: "CW_MANAGED_HOUSE_HOURLY_CONTRACT",
    FRONTIER_PUBS_CONTRACT: "FRONTIER_PUBS_CONTRACT",
    FISHWORKS_CHILDREN_CONTRACT: "FISHWORKS_CHILDREN_CONTRACT",
    BREAKFAST_CLUB_CONTRACT: 'BREAKFAST_CLUB_CONTRACT',
    PETERSHAM_CONTRACT: 'PETERSHAM_CONTRACT',
    PREZZO_RESTAURANT_TEAM_CONTRACT: 'PREZZO_RESTAURANT_TEAM_CONTRACT',
    PREZZO_SUPPORT_CENTER_CONTRACT: 'PREZZO_SUPPORT_CENTER_CONTRACT',
    WYNDHAM_GRAND_CONTRACT: 'WYNDHAM_GRAND_CONTRACT',
    CSDK_COE_CONTRACT: 'CSDK_COE_CONTRACT',
    DD_LONDON_CONTRACT: 'DD_LONDON_CONTRACT',
    DD_HEAD_OFFICE_CONTRACT: 'DD_HEAD_OFFICE_CONTRACT',
    BREAKFAST_CLUB_CONTRACT_HOURLY: 'BREAKFAST_CLUB_CONTRACT_HOURLY',
    GOLD_CONTRACT: 'GOLD_CONTRACT',
    IVY_COLLECTION_HEAD_OFFICE_CONTRACT: "IVY_COLLECTION_HEAD_OFFICE_CONTRACT",
    IVY_COLLECTION_GM_SALARIED_CONTRACT: "IVY_COLLECTION_GM_SALARIED_CONTRACT",
    IVY_COLLECTION_GM_SALARIED_2_CONTRACT: "IVY_COLLECTION_GM_SALARIED_2_CONTRACT",
    IVY_COLLECTION_BRASSERIE_GM_SALARIED_CONTRACT: "IVY_COLLECTION_BRASSERIE_GM_SALARIED_CONTRACT",
    BARTLETT_MITCHELL_CONTRACT: "BARTLETT_MITCHELL_CONTRACT",
    M_RESTAURANT_TRONC_LETTER: "M_RESTAURANT_TRONC_LETTER",
    KRICKET_TRONC_INVITE:"KRICKET_TRONC_INVITE",
    BRASSERIE_LIGHT_GM_SALARIED_CONTRACT: "BRASSERIE_LIGHT_GM_SALARIED_CONTRACT",
    HARRYS_DOLCI_GM_SALARIED_CONTRACT: "HARRYS_DOLCI_GM_SALARIED_CONTRACT",
    GRANARY_SQUARE_GM_SALARIED_CONTRACT: "GRANARY_SQUARE_GM_SALARIED_CONTRACT",
    COTE_RESTAURANT_MERGED_CONTRACT: "COTE_RESTAURANT_MERGED_CONTRACT",
    COTE_RESTAURANT_CONTRACTS: "COTE_RESTAURANT_CONTRACTS",
    LIMEYARD_CONTRACT: "LIMEYARD_CONTRACT",
    GREYHOUND_CAFE_CONTRACT: "GREYHOUND_CAFE_CONTRACT",
    JACKSON_CONTRACT: "JACKSON_CONTRACT",
    COTE_HEALTH_QUESTIONNAIRE: "COTE_HEALTH_QUESTIONNAIRE",
    CG_HEALTH_QUESTIONNAIRE: "CG_HEALTH_QUESTIONNAIRE",
    COMPASSIONATE_CARE_FULL_OB: "COMPASSIONATE_CARE_FULL_OB",
    JEAN_GEORGES_HEALTH_INSURANCE_WAIVER: "JEAN_GEORGES_HEALTH_INSURANCE_WAIVER",
    JEAN_GEORGES_HEALTH_INSURANCE_WAIVER_DOUBLE: "JEAN_GEORGES_HEALTH_INSURANCE_WAIVER_DOUBLE",
    IVY_COLLECTION_CONTRACT: "IVY_COLLECTION_CONTRACT",
    BOXPARK_CONTRACT: "BOXPARK_CONTRACT",
    IVY_MARKET_GRILL_CONTRACT: "IVY_MARKET_GRILL_CONTRACT",
    BKUK_UNIFORM_ORDER: "BKUK_UNIFORM_ORDER",
    JOLLIBEE_VACCINATION_FORM: "JOLLIBEE_VACCINATION_FORM",
    AZUMI_EQUALITY_DIVERSITY_FOOD_HANDLERS: "AZUMI_EQUALITY_DIVERSITY_FOOD_HANDLERS",
    ART_CLUB_BENEFICIARY_NOMINATION: "ART_CLUB_BENEFICIARY_NOMINATION",
    THE_IVY_NEW_HIRE: "THE_IVY_NEW_HIRE",
    STANDARD_EU_STARTER_FORM: "STANDARD_EU_STARTER_FORM",
    JM_BIOMETRIC_DATA_POLICY_FORM: "JM_BIOMETRIC_DATA_POLICY_FORM",
    IVY_COLLECTION_BRASSERIE_CONTRACT: "IVY_COLLECTION_BRASSERIE_CONTRACT",
    BRASSERIE_LIGHT_CONTRACT: "BRASSERIE_LIGHT_CONTRACT",
    HARRYS_DOLCI_CONTRACT: "HARRYS_DOLCI_CONTRACT",
    BLACK_SHEEP_CONTRACT: "BLACK_SHEEP_CONTRACT",
    BLACK_SHEEP_CHILDREN_CONTRACT: "BLACK_SHEEP_CHILDREN_CONTRACT",
    GRANARY_SQUARE_CONTRACT: "GRANARY_SQUARE_CONTRACT",
    CAPRICE_EMPLOYEE_WISHES_FORM: "CAPRICE_EMPLOYEE_WISHES_FORM",
    CRAVEABLE_TRANSITCHECK: "CRAVEABLE_TRANSITCHECK",
    BURGER_KING_EXPRESSION_OF_WISH: "BURGER_KING_EXPRESSION_OF_WISH",
    CAPRICE_NOK_FORM: "CAPRICE_NOK_FORM",
    IVY_SUIT_ORDER: "IVY_SUIT_ORDER",
    ROSSOBLU_NEW_HIRE_SHEET: "ROSSOBLU_NEW_HIRE_SHEET",
    TRUMP_UK_HEALTH_QUESTIONNAIRE: "TRUMP_UK_HEALTH_QUESTIONNAIRE",
    RADISSON_MEDICAL_HISTORY: "RADISSON_MEDICAL_HISTORY",
    RADISSON_HEALTH_CHECK: "RADISSON_HEALTH_CHECK",
    RADISSON_EMEA_PERSONAL_LAUFZETTEL: "RADISSON_EMEA_PERSONAL_LAUFZETTEL",
    RADISSON_GERMANY_DECLARATION_FOR_WORK: "RADISSON_GERMANY_DECLARATION_FOR_WORK",
    BREAKFAST_CLUB_ONBOARDING_DOCS: "BREAKFAST_CLUB_ONBOARDING_DOCS",
    BREAKFAST_CLUB_STATEMENT_OF_WORK: "BREAKFAST_CLUB_STATEMENT_OF_WORK",
    BREAKFAST_CLUB_HEALTH_QUESTIONNAIRE: "BREAKFAST_CLUB_HEALTH_QUESTIONNAIRE",
    TRUMP_UK_STARTER_FORM: "TRUMP_UK_STARTER_FORM",
    ROCKFISH_STARTER_FORM: "ROCKFISH_STARTER_FORM",
    ROCKFISH_HEALTH_QUESTIONNAIRE: "ROCKFISH_HEALTH_QUESTIONNAIRE",
    BOWERY_COMMUTER_BENEFITS: "BOWERY_COMMUTER_BENEFITS",
    WENDY_PERMIT_TO_EMPLOY: "WENDY_PERMIT_TO_EMPLOY",
    AHH_NIGHT_HEALTH_QUESTIONNAIRE: "AHH_NIGHT_HEALTH_QUESTIONNAIRE",
    AHH_EMPLOYMENT_HEALTH_QUESTIONNAIRE: "AHH_EMPLOYMENT_HEALTH_QUESTIONNAIRE",
    CONDITIONAL_EMPLOYEE_INTERVIEW: "CONDITIONAL_EMPLOYEE_INTERVIEW",
    RADISSON_SWITZERLAND_PERSONAL_LAUFZETTEL: "RADISSON_SWITZERLAND_PERSONAL_LAUFZETTEL",
    RADISSON_PERSONALSTAMMBLATT_AT: "RADISSON_PERSONALSTAMMBLATT_AT",
    JEAN_GEORGES_HEALTH_INSURANCE: "JEAN_GEORGES_HEALTH_INSURANCE",
    MH_WORKING_HOURS_AGREEMENT: "MH_WORKING_HOURS_AGREEMENT",
    WORKERS_COMPENSATION_NOTICE_CA: "WORKERS_COMPENSATION_NOTICE_CA",
    TRUMP_UK_PHOTOGRAPHY_CONSENT: "TRUMP_UK_PHOTOGRAPHY_CONSENT",
    ROCKFISH_MEDICAL_QUESTIONNAIRE: "ROCKFISH_MEDICAL_QUESTIONNAIRE",
    PAPA_JOHNS_MEDICAL_QUESTIONNAIRE: "PAPA_JOHNS_MEDICAL_QUESTIONNAIRE",
    RITZ_LONDON_MEDICAL_QUESTIONNAIRE: "RITZ_LONDON_MEDICAL_QUESTIONNAIRE",
    BELFRY_HEALTH_QUESTIONNAIRE: "BELFRY_HEALTH_QUESTIONNAIRE",
    JERSY_MIKE_EMPLOYEE_AUTHORIZATION: "JERSY_MIKE_EMPLOYEE_AUTHORIZATION",
    PJ_FL_DELIVERY_DRIVER_POLICIES: "PJ_FL_DELIVERY_DRIVER_POLICIES",
    PJ_DMD_DELIVERY_DRIVER_POLICIES: "PJ_DMD_DELIVERY_DRIVER_POLICIES",
    CHESTERFORD_MEDICAL_QUESTIONNAIRE: "CHESTERFORD_MEDICAL_QUESTIONNAIRE",
    HERTFORD_STREET_MEDICAL_QUESTIONNAIRE: "HERTFORD_STREET_MEDICAL_QUESTIONNAIRE",
    HERTFORD_STREET_PO_MEDICAL_QUESTIONNAIRE:"HERTFORD_STREET_PO_MEDICAL_QUESTIONNAIRE",
    ROTI_KING_MENTAL_HEALTH: "ROTI_KING_MENTAL_HEALTH",
    RICK_STEIN_BIOMETRIC_FORM: "RICK_STEIN_BIOMETRIC_FORM",
    THE_RESTAURANT_MEDICAL_QUESTIONNAIRE: "THE_RESTAURANT_MEDICAL_QUESTIONNAIRE",
    ANDREW_BROWNSWORD_EMPLOYEE_DETAILS: "ANDREW_BROWNSWORD_EMPLOYEE_DETAILS",
    ANDREW_BROWNSWORD_EMERGENCY: "ANDREW_BROWNSWORD_EMERGENCY",
    ANDREW_BROWNSWORD_INFECTION: "ANDREW_BROWNSWORD_INFECTION",
    RADISSON_EMEA_LOW_PAID_QUESTIONNAIRE: "RADISSON_EMEA_LOW_PAID_QUESTIONNAIRE",
    WAFELS_DINGES_WAIVER_COVERAGE: "WAFELS_DINGES_WAIVER_COVERAGE",
    ANDREW_BROWNSWORD_NIGHT_WORKER: "ANDREW_BROWNSWORD_NIGHT_WORKER",
    AUBAINE_WORKING_TIME_REGULATIONS: "AUBAINE_WORKING_TIME_REGULATIONS",
    AUBAINE_MEDICAL_QUESTIONNAIRE: "AUBAINE_MEDICAL_QUESTIONNAIRE",
    AUBAINE_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE: "AUBAINE_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE",
    UPHAM_HEALTH_QUESTIONNAIRE: "UPHAM_HEALTH_QUESTIONNAIRE",
    FRANCO_HEALTH_BOOKLET: "FRANCO_HEALTH_BOOKLET",
    VIVA_CHICKEN_PHOTO_FORM: "VIVA_CHICKEN_PHOTO_FORM",
    WILTONS_HEALTH_BOOKLET: "WILTONS_HEALTH_BOOKLET",
    AUBAINE_EQUAL_OPPORTUNITIES_FORM: "AUBAINE_EQUAL_OPPORTUNITIES_FORM",
    MIGUELS_PHOTO_FORM: "MIGUELS_PHOTO_FORM",
    DD_EEO: "DD_EEO",
    AUBAINE_FOOD_HANDLERS_HYGIENE: "AUBAINE_FOOD_HANDLERS_HYGIENE",
    AUBAINE_UNIFORM_AGREEMENT: "AUBAINE_UNIFORM_AGREEMENT",
    MCD_CREW_UNIFORM_AGREEMENT: "MCD_CREW_UNIFORM_AGREEMENT",
    CAPRICE_HEALTH_QUESTIONNAIRE: "CAPRICE_HEALTH_QUESTIONNAIRE",
    RADISSON_EMEA_DISTANCE_TO_WORK: "RADISSON_EMEA_DISTANCE_TO_WORK",
    ABC_HEALTH_BENEFITS_WAIVER_FORM:"ABC_HEALTH_BENEFITS_WAIVER_FORM",
    CAPRICE_CONTRACT: "CAPRICE_CONTRACT",
    KANADA_YA_CONTRACT: "KANADA_YA_CONTRACT",
    COAL_KITCHEN_CONTRACT: "COAL_KITCHEN_CONTRACT",
    HOME_HOUSE_CONTRACT: "HOME_HOUSE_CONTRACT",
    HOME_HOUSE_HG_CONTRACT: "HOME_HOUSE_HG_CONTRACT",
    MARKET_HALL_CONTRACT: "MARKET_HALL_CONTRACT",
    GENERATOR_IRELAND_CONTRACT: "GENERATOR_IRELAND_CONTRACT",
    TRISHNA_TRONC_LETTER: "TRISHNA_TRONC_LETTER",
    HUMBLE_GRAPE_SALARIED_CONTRACT: "HUMBLE_GRAPE_SALARIED_CONTRACT",
    HUMBLE_GRAPE_HOURLY_CONTRACT: "HUMBLE_GRAPE_HOURLY_CONTRACT",
    BISTROTHEQUE_CONTRACT: "BISTROTHEQUE_CONTRACT",
    IVY_COLLECTION_CONTRACT_SALARIED: "IVY_COLLECTION_CONTRACT_SALARIED",
    IVY_COLLECTION_BRASSERIE_CONTRACT_SALARIED: "IVY_COLLECTION_BRASSERIE_CONTRACT_SALARIED",
    BRASSERIE_LIGHT_CONTRACT_SALARIED: "BRASSERIE_LIGHT_CONTRACT_SALARIED",
    JAMES_HEALTH_ASSESSMENT: "JAMES_HEALTH_ASSESSMENT",
    WAHACA_HEALTH_QUESTIONNAIRE: "WAHACA_HEALTH_QUESTIONNAIRE",
    SUMMER_OPS_EMPLOYEE_NOTICE: "SUMMER_OPS_EMPLOYEE_NOTICE",
    WAHACA_CONTRACT: "WAHACA_CONTRACT",
    BURGERS_COCKTAILS_CONTRACT: "BURGERS_COCKTAILS_CONTRACT",
    BURGERS_COCKTAILS_CHILDREN_CONTRACT: "BURGERS_COCKTAILS_CHILDREN_CONTRACT",
    PIEMINISTER_CONTRACT: "PIEMINISTER_CONTRACT",
    PIEMINISTER_ALL_CONTRACT: "PIEMINISTER_ALL_CONTRACT",
    BACKGROUND_GROUP_CONTRACT:"BACKGROUND_GROUP_CONTRACT",
    YOUNGS_CONTRACT:"YOUNGS_CONTRACT",
    CDG_CONTRACT: "CDG_CONTRACT",
    CDG_MANAGER_CONTRACT: "CDG_MANAGER_CONTRACT",
    CDG_TEAM_MEMBER_2_CONTRACT: "CDG_TEAM_MEMBER_2_CONTRACT",
    ROCKFISH_CONTRACT: "ROCKFISH_CONTRACT",
    SEAHORSE_CONTRACT: "SEAHORSE_CONTRACT",
    ROCKFISH_CASUAL_CONTRACT: "ROCKFISH_CASUAL_CONTRACT",
    ROCKFISH_MANAGEMENT_CONTRACT: "ROCKFISH_MANAGEMENT_CONTRACT",
    EMILY_ESTATE_CONTRACT: "EMILY_ESTATE_CONTRACT",
    BEDS_BARS_CONTRACT: "BEDS_BARS_CONTRACT",
    CRAFT_LOCALS_CONTRACT: "CRAFT_LOCALS_CONTRACT",
    ISLAND_POKE_NEW_CONTRACT: "ISLAND_POKE_NEW_CONTRACT",
    SAN_CARLO_CONTRACT: "SAN_CARLO_CONTRACT",
    BREAKFAST_CLUB_LETTER_CONTRACT: "BREAKFAST_CLUB_LETTER_CONTRACT",
    BREAKFAST_CLUB_NEW_CONTRACT: "BREAKFAST_CLUB_NEW_CONTRACT",
    MARRIOTT_CONTRACT: "MARRIOTT_CONTRACT",
    PLATFORM_CONTRACT: "PLATFORM_CONTRACT",
    WRIGHT_BROTHERS_CONTRACT: "WRIGHT_BROTHERS_CONTRACT",
    THE_NEWT_CONTRACT: "THE_NEWT_CONTRACT",
    HAWKSMOOR_CONTRACT: "HAWKSMOOR_CONTRACT",
    BERKELEY_INNS_CONTRACT: "BERKELEY_INNS_CONTRACT",
    HAWKSMOOR_EDINBURGH_CONTRACT: "HAWKSMOOR_EDINBURGH_CONTRACT",
    HALAL_GUYS_CONTRACT: "HALAL_GUYS_CONTRACT",
    WINGSTOP_CONTRACT:  "WINGSTOP_CONTRACT",
    ARABICA_BOROUGH_CONTRACT: "ARABICA_BOROUGH_CONTRACT",
    ARABICA_FOOD_SPICE_CONTRACT: "ARABICA_FOOD_SPICE_CONTRACT",
    ARABICA_FOOD_LIMTED_CONTRACT: "ARABICA_FOOD_LIMTED_CONTRACT",
    ARABICA_KX_CONTRACT: "ARABICA_KX_CONTRACT",
    MERCER_STREET_HANDBOOK:"MERCER_STREET_HANDBOOK",
    UPHAM_CONTRACT: "UPHAM_CONTRACT",
    JEAN_GEORGES_HANDBOOK:"JEAN_GEORGES_HANDBOOK",
    LANSDOWNE_CONTRACT:"LANSDOWNE_CONTRACT",
    LOCKETS_CONTRACT:"LOCKETS_CONTRACT",
    ETM_BOTANIST_CONTRACT:"ETM_BOTANIST_CONTRACT",
    NOTICE_OF_TERMINATION_JUST_CAUSE:"NOTICE_OF_TERMINATION_JUST_CAUSE",
    YARDBIRD_TERMINATION_CHECKLIST:"YARDBIRD_TERMINATION_CHECKLIST",
    SEPARATION_NOTICE_GA:"SEPARATION_NOTICE_GA",
    KBK_CONTRACT:"KBK_CONTRACT",
    SMF_CONTRACT:"SMF_CONTRACT",
    VILLAGE_HOTELS_EXPRESSION_OF_WISHES:"VILLAGE_HOTELS_EXPRESSION_OF_WISHES",
    ROYAL_LANCASTER_EXPRESSIONS_OF_WISHES:"ROYAL_LANCASTER_EXPRESSIONS_OF_WISHES",
    ACADEMY_HS_INDUCTION_PACK_RARE:"ACADEMY_HS_INDUCTION_PACK_RARE",
    JERSY_MIKE_DIRECT_DEPOSIT:"JERSY_MIKE_DIRECT_DEPOSIT",
    M_RESTAURANTS_HS_INDUCTION_PACK_HOURLY:"M_RESTAURANTS_HS_INDUCTION_PACK_HOURLY",
    GAUCHO_HS_INDUCTION_PACK_HOURLY:"GAUCHO_HS_INDUCTION_PACK_HOURLY",
    GOOD_FAITH_ESTIMATE_SCHEDULE_EXPRESS : "GOOD_FAITH_ESTIMATE_SCHEDULE_EXPRESS",
    GOOD_FAITH_ESTIMATE_SCHEDULE_OREGON : "GOOD_FAITH_ESTIMATE_SCHEDULE_OREGON",
    GOOD_FAITH_ESTIMATE_SCHEDULE_CHICAGO : "GOOD_FAITH_ESTIMATE_SCHEDULE_CHICAGO",
    GOOD_FAITH_ESTIMATE_SCHEDULE_SAN_FRANCISCO : "GOOD_FAITH_ESTIMATE_SCHEDULE_SAN_FRANCISCO",
    GOOD_FAITH_ESTIMATE_SCHEDULE_LITE : "GOOD_FAITH_ESTIMATE_SCHEDULE_LITE",
    GOOD_FAITH_ESTIMATE_SCHEDULE_BERKELEY: "GOOD_FAITH_ESTIMATE_SCHEDULE_BERKELEY",
    GOOD_FAITH_ESTIMATE_SCHEDULE_EVANSTON: "GOOD_FAITH_ESTIMATE_SCHEDULE_EVANSTON",
    GOOD_FAITH_ESTIMATE_SCHEDULE_PHILADELPHIA : "GOOD_FAITH_ESTIMATE_SCHEDULE_PHILADELPHIA",
    GOOD_FAITH_ESTIMATE_SCHEDULE_SEATTLE: "GOOD_FAITH_ESTIMATE_SCHEDULE_SEATTLE",
    GOOD_FAITH_ESTIMATE_SCHEDULE_EMERYVILLE: "GOOD_FAITH_ESTIMATE_SCHEDULE_EMERYVILLE",
    GOOD_FAITH_ESTIMATE_SCHEDULE_LOS_ANGELES: "GOOD_FAITH_ESTIMATE_SCHEDULE_LOS_ANGELES",
    QBIC_CONTRACT:"QBIC_CONTRACT",
    VAGABOND_HQ_CONTRACT :"VAGABOND_HQ_CONTRACT",
    VAGABOND_CONTRACT:"VAGABOND_CONTRACT",
    RED_CAT_CONTRACT:"RED_CAT_CONTRACT",
    ART_CLUB_DUBAI_LETTER_OF_INTENT:"ART_CLUB_DUBAI_LETTER_OF_INTENT",
    EGGSLUT_CONTRACT:"EGGSLUT_CONTRACT",
    SEV_CONTRACT:"SEV_CONTRACT",
    TAMATANGA_CONTRACT:"TAMATANGA_CONTRACT",
    BOSTON_TEA_CONTRACT:"BOSTON_TEA_CONTRACT",
    NZR_GROUP_CONTRACT:"NZR_GROUP_CONTRACT",
    WULF_LAMB_CONTRACT_AMENDMENT:"WULF_LAMB_CONTRACT_AMENDMENT",
    WULF_LAMB_CONTRACT:"WULF_LAMB_CONTRACT",
    BLAKENEY_HOTEL_CONTRACT:"BLAKENEY_HOTEL_CONTRACT",
    BERBERE_ITALY_CONTRACT:"BERBERE_ITALY_CONTRACT",
    KOH_THAI_CONTRACT:"KOH_THAI_CONTRACT",
    PARK_INN_NORTHAMPTON_CONTRACT:"PARK_INN_NORTHAMPTON_CONTRACT",
    PAPA_JOHNS_QCC_CONTRACT:"PAPA_JOHNS_QCC_CONTRACT",
    PAPA_JOHNS_CONTRACT:"PAPA_JOHNS_CONTRACT",
    EAT_PITTA_CONTRACT:"EAT_PITTA_CONTRACT",
    SEFTON_CONTRACT:"SEFTON_CONTRACT",
    NOBLE_INNS_CONTRACT:"NOBLE_INNS_CONTRACT",
    NOBLE_INNS_TRONC_LETTER:"NOBLE_INNS_TRONC_LETTER",
    GRIND_TRONC_LETTER:"GRIND_TRONC_LETTER",
    LANGAN_CHUCS_TRONC_LETTER:"LANGAN_CHUCS_TRONC_LETTER",
    ARTFARM_CONTRACT:"ARTFARM_CONTRACT",
    SCARPETTA_CONTRACT:"SCARPETTA_CONTRACT",
    IBERICA_CONTRACT:"IBERICA_CONTRACT",
    LIBERATION_UK_CONTRACT:"LIBERATION_UK_CONTRACT",
    LIBERATION_ZERO_HOUR_CONTRACT:"LIBERATION_ZERO_HOUR_CONTRACT",
    LIBERATION_CONTRACT:"LIBERATION_CONTRACT",
    LIBERATION_GROUP_UK_CONTRACT:"LIBERATION_GROUP_UK_CONTRACT",
    LIBERATION_GROUP_JERSEY_CONTRACT:"LIBERATION_GROUP_JERSEY_CONTRACT",
    LIBERATION_GROUP_GUERNSEY_CONTRACT:"LIBERATION_GROUP_GUERNSEY_CONTRACT",
    WELLS_CO_ACCOMMODATION_AGREEMENT:"WELLS_CO_ACCOMMODATION_AGREEMENT",
    LIBERATION_JERSEY_CONTRACT:"LIBERATION_JERSEY_CONTRACT",
    LIBERATION_GUERNSEY_CONTRACT:"LIBERATION_GUERNSEY_CONTRACT",
    ARCHIES_CONTRACT:"ARCHIES_CONTRACT",
    NOTICE_OF_HOURS_REDUCTION_JUST_CAUSE:"NOTICE_OF_HOURS_REDUCTION_JUST_CAUSE",
    COTE_TEAM_MEMBER_CONTRACTS:"COTE_TEAM_MEMBER_CONTRACTS",
    GENERATOR_SWEDEN_CONTRACT: "GENERATOR_SWEDEN_CONTRACT",
    COTE_AGM_CONTRACTS:"COTE_AGM_CONTRACTS",
    FARM_GIRL_CONTRACT:"FARM_GIRL_CONTRACT",
    GENERATOR_ITALY_CONTRACT:"GENERATOR_ITALY_CONTRACT",
    OVER_UNDER_COFFEE_CONTRACT:"OVER_UNDER_COFFEE_CONTRACT",
    HALL_WOODHOUSE_CONTRACT:"HALL_WOODHOUSE_CONTRACT",
    SISBAN_UK_CONTRACT:"SISBAN_UK_CONTRACT",
    URBAN_FRESH_BURGERS_CONTRACT:"URBAN_FRESH_BURGERS_CONTRACT",
    COACHING_INN_CONTRACT:"COACHING_INN_CONTRACT",
    COACHING_INN_CO_CONTRACT:"COACHING_INN_CO_CONTRACT",
    ANNABELS_CONTRACT:"ANNABELS_CONTRACT",
    BIG_EASY_CONTRACT: "BIG_EASY_CONTRACT",
    BRUNCHCO_UK_CONTRACT: "BRUNCHCO_UK_CONTRACT",
    HARRYS_BAR_CONTRACT:"HARRYS_BAR_CONTRACT",
    MARKS_CLUB_CONTRACT:"MARKS_CLUB_CONTRACT",
    BATH_RACQUETS_CONTRACT:"BATH_RACQUETS_CONTRACT",
    BIRLEY_HO_CONTRACT:"BIRLEY_HO_CONTRACT",
    YARD_SALE_CONTRACT:"YARD_SALE_CONTRACT",
    DISCOVERY_ADVENTURE_CONTRACT:"DISCOVERY_ADVENTURE_CONTRACT",
    BART_TAYLOR_CONTRACT:"BART_TAYLOR_CONTRACT",
    ARCHIES_HO_CONTRACT:"ARCHIES_HO_CONTRACT",
    NOTICE_OF_LAYOFF_ECONOMIC_REASON:"NOTICE_OF_LAYOFF_ECONOMIC_REASON",
    KNOOPS_CONTRACT:"KNOOPS_CONTRACT",
    JULIENNE_BRUNO_CONTRACT:"JULIENNE_BRUNO_CONTRACT",
    PLANT_HUSTLER_CONTRACT:"PLANT_HUSTLER_CONTRACT",
    CHESTERFORD_JOY_BRAND_CONTRACT:"CHESTERFORD_JOY_BRAND_CONTRACT",
    BVLGARI_HOTEL_LONDON_CONTRACT:"BVLGARI_HOTEL_LONDON_CONTRACT",
    BOCCA_DI_LUPO_CONTRACT:"BOCCA_DI_LUPO_CONTRACT",
    AHH_CONTRACT:"AHH_CONTRACT",
    AZUMI_CONTRACT:"AZUMI_CONTRACT",
    WESTBEACH_CONTRACT:"WESTBEACH_CONTRACT",
    BIMS_CONTRACT:"BIMS_CONTRACT",
    XP_FACTORY_CONTRACT: "XP_FACTORY_CONTRACT",
    BUBALA_CONTRACT:"BUBALA_CONTRACT",
    HERTFORD_5_STREET_CONTRACT:"HERTFORD_5_STREET_CONTRACT",
    GASTRONOMY_CONTRACT:"GASTRONOMY_CONTRACT",
    BEEFY_BOYS_CONTRACT:"BEEFY_BOYS_CONTRACT",
    BOPARAN_STARTER_WELCOME_VOUCHER:"BOPARAN_STARTER_WELCOME_VOUCHER",
    BLOOMSBURY_CONTRACT:"BLOOMSBURY_CONTRACT",
    SUPERMARKET_OF_DREAMS_CONTRACT:"SUPERMARKET_OF_DREAMS_CONTRACT",
    FULLER_SMITH_TURNER_CONTRACT:"FULLER_SMITH_TURNER_CONTRACT",
    COTSWOLD_FARM_CONTRACT:"COTSWOLD_FARM_CONTRACT",
    TATTU_CONTRACT:"TATTU_CONTRACT",
    WINGMANS_CONTRACT: "WINGMANS_CONTRACT",
    KITCHEN_VENTURES_RESTRICTIVE_COVENANT:"KITCHEN_VENTURES_RESTRICTIVE_COVENANT",
    KITCHEN_VENTURES_CONTRACT:"KITCHEN_VENTURES_CONTRACT",
    SWINGERS_CRAZY_GOLF_NDIAA:"SWINGERS_CRAZY_GOLF_NDIAA",
    BONE_DADDIES_CONTRACT:"BONE_DADDIES_CONTRACT",
    BONE_DADDIES_TRONC_LETTER:"BONE_DADDIES_TRONC_LETTER",
    TAPATAPA_CONTACT:"TAPATAPA_CONTACT",
    BODMIN_JAIL_HOTEL_CONTRACT:"BODMIN_JAIL_HOTEL_CONTRACT",
    EAST_LONDON_PUB_CONTRACT:"EAST_LONDON_PUB_CONTRACT",
    TATTU_AGE_VERIFICATION_POLICY:"TATTU_AGE_VERIFICATION_POLICY",
    BOO_CONTRACT:"BOO_CONTRACT",
    KERB_CONTRACT: "KERB_CONTRACT",
    BIRLEY_CLUBS_OFFER_LETTER:"BIRLEY_CLUBS_OFFER_LETTER",
    SHEPHERD_NEAME_CONTRACT:"SHEPHERD_NEAME_CONTRACT",
    NURST_UK_CONTRACT:"NURST_UK_CONTRACT",
    PAPA_JOHNS_NEW_FEDERAL_REG_TIPPED:"PAPA_JOHNS_NEW_FEDERAL_REG_TIPPED",
    QFM_CONTRACT:"QFM_CONTRACT",
    RITZ_LONDON_CONTRACT:"RITZ_LONDON_CONTRACT",
    YOTEL_UK_CONTRACT: "YOTEL_UK_CONTRACT",
    YOTEL_NETHERLANDS_CONTRACT: "YOTEL_NETHERLANDS_CONTRACT",
    BARACK_HOLDINGS_CONTRACT: "BARACK_HOLDINGS_CONTRACT",
    COTE_GREENFIELDS_CONTRACT: "COTE_GREENFIELDS_CONTRACT",
    FIRMDALE_CONTRACT: "FIRMDALE_CONTRACT",
    RAREBIRDS_CONTRACT: "RAREBIRDS_CONTRACT",
    COTE_SO_CONTRACT: "COTE_SO_CONTRACT",
    COTE_RESTAURANTS_CONTRACT: "COTE_RESTAURANTS_CONTRACT",
    ZOOM1HR_CONTRACT:"ZOOM1HR_CONTRACT",
    CARLUCCIOS_DAWSON_CONTRACT:"CARLUCCIOS_DAWSON_CONTRACT",
    CROCUS_CONTRACT:"CROCUS_CONTRACT",
    CROCUS_MANAGEMENT_CONTRACT:"CROCUS_MANAGEMENT_CONTRACT",
    DARJEELING_CONTRACT:"DARJEELING_CONTRACT",
    EPOCH_GROUP_CONTRACT:"EPOCH_GROUP_CONTRACT",
    PAN_PACIFIC_CONTRACT:"PAN_PACIFIC_CONTRACT",
    POPEYES_CONTRACT: "POPEYES_CONTRACT",
    PALL_MALL_67_CONTRACT: "PALL_MALL_67_CONTRACT",
    DONER_SUMMER_CONTRACT: "DONER_SUMMER_CONTRACT",
    NNA_CONTRACT: "NNA_CONTRACT",
    BT_CONTRACT: "BT_CONTRACT",
    BTG_CONTRACT: "BTG_CONTRACT",
    CHIKN_CONTRACT:"CHIKN_CONTRACT",
    EPOCH_GROUP_HO_CONTRACT:"EPOCH_GROUP_HO_CONTRACT",
    HAUS_HOLDNIG_CONTRACT: "HAUS_HOLDNIG_CONTRACT",
    HAUS_HOLDNIG_N_CONTRACT: "HAUS_HOLDNIG_N_CONTRACT",
    ROMET_GROUP_CONTRACT:"ROMET_GROUP_CONTRACT",
    NOTICE_OF_HOURS_REDUCTION_ECONOMIC_REASON:"NOTICE_OF_HOURS_REDUCTION_ECONOMIC_REASON",
    BAKER_HOSPITALITY_CHURCH_STREET_CONTRACT:"BAKER_HOSPITALITY_CHURCH_STREET_CONTRACT",
    NICI_HOTELS_CONTRACT: "NICI_HOTELS_CONTRACT",
    BAKER_HOSPITALITY_THE_SUN_CONTRACT:"BAKER_HOSPITALITY_THE_SUN_CONTRACT",
    BISTROTHEQUE_PROPERTY_ISSUE_FORM:"BISTROTHEQUE_PROPERTY_ISSUE_FORM",
    ARCHIES_STAFF_EQUIPMENTS_CHECKLIST:"ARCHIES_STAFF_EQUIPMENTS_CHECKLIST",
    THE_GOOD_EGG_CONTRACT:"THE_GOOD_EGG_CONTRACT",
    ALLBRIGHT_OPERATION_CONTRACT:"ALLBRIGHT_OPERATION_CONTRACT",
    ALLBRIGHT_CENTRAL_CONTRACT:"ALLBRIGHT_CENTRAL_CONTRACT",
    EDIN_HOTELS_CONTRACT:"EDIN_HOTELS_CONTRACT",
    PIANO_WORKS_CONTRACT:"PIANO_WORKS_CONTRACT",
    MARTHA_CONTRACT:"MARTHA_CONTRACT",
    HARTS_CONTRACT :"HARTS_CONTRACT",
    HARTS_CHILDREN_CONTRACT: "HARTS_CHILDREN_CONTRACT",
    OLE_STEEN_CONTRACT:"OLE_STEEN_CONTRACT",
    ABSOLUTE_TASTE_CONTRACT:"ABSOLUTE_TASTE_CONTRACT",
    JERSY_MIKE_NEW_HIRE:"JERSY_MIKE_NEW_HIRE",
    KRICKET_CONTRACT:"KRICKET_CONTRACT",
    BISCUITEERS_HEALTH_QUESTIONNAIRE:"BISCUITEERS_HEALTH_QUESTIONNAIRE",
    SEPARATION_NOTICE_TN: "SEPARATION_NOTICE_TN",
    SEPARATION_NOTICE_NJ: "SEPARATION_NOTICE_NJ",
    BIRD_CONTRACT:"BIRD_CONTRACT",
    BLACKLOCK_CONTRACT: "BLACKLOCK_CONTRACT",
    FLOR_CONTRACT: "FLOR_CONTRACT",
    CARLUCCIOS_CONTRACT: "CARLUCCIOS_CONTRACT",
    CDG_SALARIED_CONTRACT: "CDG_SALARIED_CONTRACT",
    CDG_TEAM_MEMBER_CONTRACT: "CDG_TEAM_MEMBER_CONTRACT",
    CDG_CONCESSIONS_CONTRACT: "CDG_CONCESSIONS_CONTRACT",
    CDG_CONCESSIONS_MANAGEMENT_CONTRACT: "CDG_CONCESSIONS_MANAGEMENT_CONTRACT",
    CDG_CONCESSIONS_TEAM_MEMBER_CONTRACT: "CDG_CONCESSIONS_TEAM_MEMBER_CONTRACT",
    DD_DISCLOSURE_CIVIL_DECLARATION: "DD_DISCLOSURE_CIVIL_DECLARATION",
    AT_HEALTH_QUESTIONNAIRE:"AT_HEALTH_QUESTIONNAIRE",
    STATE_W_RI: "STATE_W_RI",
    WORKING_HOURS_OPTION_FORM: "WORKING_HOURS_OPTION_FORM",
    BLAKENEY_WORKING_HOURS_OPTION: "BLAKENEY_WORKING_HOURS_OPTION",
    CRIMINAL_RECORD_FORM: "CRIMINAL_RECORD_FORM",
    EXPRESSION_OF_WISH: "EXPRESSION_OF_WISH",
    IVY_DUBLIN_CONTRACT: "IVY_DUBLIN_CONTRACT",
    LIVELYHOOD_CONTRACT: "LIVELYHOOD_CONTRACT",
    HOME_HOUSE_HEALTH_ASSESMENT: "HOME_HOUSE_HEALTH_ASSESMENT",
    REZIDOR_EMERGENCY_CONTACT: "REZIDOR_EMERGENCY_CONTACT",
    TRUMP_UK_EQUAL_OPPORTUNITY: "TRUMP_UK_EQUAL_OPPORTUNITY",
    JKS_REGULAR_ALL_CONTRACT: "JKS_REGULAR_ALL_CONTRACT",
    JKS_FOH_KT_CONTRACT: "JKS_FOH_KT_CONTRACT",
    JKS_ZERO_ALL_CONTRACT: "JKS_ZERO_ALL_CONTRACT",
    JKS_SALARIED_ALL_CONTRACT: "JKS_SALARIED_ALL_CONTRACT",
    JKS_HOURLY_ALL_CONTRACT: "JKS_HOURLY_ALL_CONTRACT",
    JKS_ZERO_LYLES_CONTRACT: "JKS_ZERO_LYLES_CONTRACT",
    JKS_REGULAR_LYLES_CONTRACT: "JKS_REGULAR_LYLES_CONTRACT",
    JKS_MANAGEMENT_BAO_CONTRACT: "JKS_MANAGEMENT_BAO_CONTRACT",
    JKS_MANAGEMENT_B_KT_CONTRACT: "JKS_MANAGEMENT_B_KT_CONTRACT",
    JKS_MANAGEMENT_CONTRACT: "JKS_MANAGEMENT_CONTRACT",
    BRUTTO_CONTRACT: "BRUTTO_CONTRACT",
    RICK_STEIN_CONTRACT: "RICK_STEIN_CONTRACT",
    RICK_STEIN_CONTRAC_V2: "RICK_STEIN_CONTRAC_V2",
    JKS_MANAGEMENT_XU_CONTRACT: "JKS_MANAGEMENT_XU_CONTRACT",
    JKS_MANAGEMENT_LYLES_CONTRACT: "JKS_MANAGEMENT_LYLES_CONTRACT",
    DRAKE_MORGAN_HOURLY_CONTRACT: "DRAKE_MORGAN_HOURLY_CONTRACT",
    DRAKE_MORGAN_FIXED_TERM_CONTRACT: "DRAKE_MORGAN_FIXED_TERM_CONTRACT",
    DRAKE_MORGAN_SALARIED_CONTRACT: "DRAKE_MORGAN_SALARIED_CONTRACT",
    GYMBOX_CONTRACT: "GYMBOX_CONTRACT",
    WYBOSTON_LAKES_TEAM_MEMBER_CONTRACT: "WYBOSTON_LAKES_TEAM_MEMBER_CONTRACT",
    MB_RETAIL_STAFF_AGREEMENT: "MB_RETAIL_STAFF_AGREEMENT",
    PITA_MEAL_TIME_WAIVER:"PITA_MEAL_TIME_WAIVER",
    MB_MEDICAL_QUESTIONNAIRE: "MB_MEDICAL_QUESTIONNAIRE",
    MARKS_CLUB_OFFER_LETTER: "MARKS_CLUB_OFFER_LETTER",
    TIME_OF_HIRE_PAMPHLET_CA: "TIME_OF_HIRE_PAMPHLET_CA",
    EDS_MANAGEMENT_CONTRACT: "EDS_MANAGEMENT_CONTRACT",
    GIRAFFE_STOP_CONTRACT: "GIRAFFE_STOP_CONTRACT",
    GIRAFFE_STOP_HOURLY_CONTRACT: "GIRAFFE_STOP_HOURLY_CONTRACT",
    EDS_HOURLY_CONTRACT: "EDS_HOURLY_CONTRACT",
    GIRAFFE_CONTRACT: "GIRAFFE_CONTRACT",
    JP_RESTAURANTS_CONTRACT: "JP_RESTAURANTS_CONTRACT",
    GIRAFFE_CHILDREN_CONTRACT: "GIRAFFE_CHILDREN_CONTRACT",
    GC_MALLEN_CONTRACT: "GC_MALLEN_CONTRACT",
    M_RESTAURANT_CONTRACT: "M_RESTAURANT_CONTRACT",
    SOURCED_MARKET_CONTRACT : "SOURCED_MARKET_CONTRACT",
    CUBITT_HOUSE_CONTRACT: "CUBITT_HOUSE_CONTRACT",
    CUBITT_HOUSE_HOURLY_CONTRACT: "CUBITT_HOUSE_HOURLY_CONTRACT",
    INAMO_KEY_FOB_RESPONSIBILITY_FORM: "INAMO_KEY_FOB_RESPONSIBILITY_FORM",
    CHARLES_WTR_FORM: "CHARLES_WTR_FORM",
    CHARLES_LIFE_ASSURANCE_BENEFICIARY_FORM: "CHARLES_LIFE_ASSURANCE_BENEFICIARY_FORM",
    CHARLES_STARTERS_FORM: "CHARLES_STARTERS_FORM",
    EAST_COAST_CONTRACT: "EAST_COAST_CONTRACT",
    KITOPI_CONTRACT :"KITOPI_CONTRACT",
    MELROSE_MORGAN_CONTRACT: "MELROSE_MORGAN_CONTRACT",
    MEGANS_CONTRACT: "MEGANS_CONTRACT",
    HARRYS_BAR_OFFER_LETTER: "HARRYS_BAR_OFFER_LETTER",
    MEGANS_CHILD_CONTRACT: "MEGANS_CHILD_CONTRACT",
    SENOR_CEVICHE_CONTRACT: "SENOR_CEVICHE_CONTRACT",
    KOREAN_DINNER_PARTY_CONTRACT: "KOREAN_DINNER_PARTY_CONTRACT",
    MERCATO_METROPOLITANO_CONTRACT: "MERCATO_METROPOLITANO_CONTRACT",
    HQ_THEATER_CONTRACT: "HQ_THEATER_CONTRACT",
    MERCATO_METROPOLITANO_N_CONTRACT: "MERCATO_METROPOLITANO_N_CONTRACT",
    COMPASSIONATE_CARE_COMMUNITY_CONTRACT: "COMPASSIONATE_CARE_COMMUNITY_CONTRACT",
    COMPASSIONATE_CARE_SUPPORT_CONTRACT: "COMPASSIONATE_CARE_SUPPORT_CONTRACT",
    COMPASSIONATE_CARE_HO_CONTRACT: "COMPASSIONATE_CARE_HO_CONTRACT",
    BIRLEY_HO_OFFER_LETTER: "BIRLEY_HO_OFFER_LETTER",
    BARONS_EDEN_CONTRACT: "BARONS_EDEN_CONTRACT",
    FARMER_J_CONTRACT: "FARMER_J_CONTRACT",
    BATH_RACQUETS_OFFER_LETTER: "BATH_RACQUETS_OFFER_LETTER",
    GRINDCO_CONTRACT:"GRINDCO_CONTRACT",
    GRINDCO_SUPPORT_CONTRACT:"GRINDCO_SUPPORT_CONTRACT",
    HERTFORD_STREET_CONTRACT: "HERTFORD_STREET_CONTRACT",
    THE_WAVE_CONTRACT: "THE_WAVE_CONTRACT",
    BRINDISA_CONTRACT: "BRINDISA_CONTRACT",
    BRINDISA_GM_CONTRACT:"BRINDISA_GM_CONTRACT",
    BRINDISA_HO_CONTRACT:"BRINDISA_HO_CONTRACT",
    STICK_SUSHI_DE_CONTRACT:"STICK_SUSHI_DE_CONTRACT",
    STICK_SUSHI_FLEX_CONTRACT: "STICK_SUSHI_FLEX_CONTRACT",
    STICK_SUSHI_MANAGEMENT_CONTRACT:"STICK_SUSHI_MANAGEMENT_CONTRACT",
    KFC_DEMIPOWER_CONTRACT: "KFC_DEMIPOWER_CONTRACT",
    KFC_DEMIPOWER_HO_CONTRACT: "KFC_DEMIPOWER_HO_CONTRACT",
    KFC_DEMIPOWER_HOURLY_CONTRACT: "KFC_DEMIPOWER_HOURLY_CONTRACT",
    RICHMOND_HILL_CONTRACT: "RICHMOND_HILL_CONTRACT",
    THE_IVY_MANAGEMENT_CONTRACT: "THE_IVY_MANAGEMENT_CONTRACT",
    THE_IVY_TEAM_MEMBER_CONTRACT: "THE_IVY_TEAM_MEMBER_CONTRACT",
    CAPRICE_MANAGEMENT_CONTRACT: "CAPRICE_MANAGEMENT_CONTRACT",
    CAPRICE_TEAM_MEMBER_CONTRACT: "CAPRICE_TEAM_MEMBER_CONTRACT",
    BALTHAZAR_MANAGEMENT_CONTRACT: "BALTHAZAR_MANAGEMENT_CONTRACT",
    DUNKIN_NMG_MA_DATA_PROTECTION_TRAINING: "DUNKIN_NMG_MA_DATA_PROTECTION_TRAINING",
    B_TOGETHER_CONTRACT: "B_TOGETHER_CONTRACT",
    GENERATOR_FRANCE_CONTRACT: "GENERATOR_FRANCE_CONTRACT",
    BALTHAZAR_TEAM_MEMBER_CONTRACT: "BALTHAZAR_TEAM_MEMBER_CONTRACT",
    WENDY_CONTRACT: "WENDY_CONTRACT",
    KFC_RSC_CONTRACT:"KFC_RSC_CONTRACT",
    VECTOR_CONTRACT: "VECTOR_CONTRACT",
    CHEESE_BAR_CONTRACT: "CHEESE_BAR_CONTRACT",
    SLIM_CHICKENS_CONTRACT: "SLIM_CHICKENS_CONTRACT",
    BLEECKER_BURGER_CONTRACT: "BLEECKER_BURGER_CONTRACT",
    MUSTARD_CATERING_CONTRACT: "MUSTARD_CATERING_CONTRACT",
    SLIM_CHICKENS_HOURLY_CONTRACT: "SLIM_CHICKENS_HOURLY_CONTRACT",
    PROPER_REFERENCE_AUTHORIZATION: "PROPER_REFERENCE_AUTHORIZATION",
    MKD_HOLDINGS_CONTRACT: "MKD_HOLDINGS_CONTRACT",
    LUXURY_FAMILY_HOTELS_CONTRACT: "LUXURY_FAMILY_HOTELS_CONTRACT",
    THE_BELFRY_CONTRACT: "THE_BELFRY_CONTRACT",
    ST_JAMES_CONTRACT: "ST_JAMES_CONTRACT",
    VARIOS_EATERIES_CONTRACT: "VARIOS_EATERIES_CONTRACT",
    MICHAEL_CAINES_CONTRACT: "MICHAEL_CAINES_CONTRACT",
    PAPA_JOHNS_GB_CONTRACT: "PAPA_JOHNS_GB_CONTRACT",
    ST_JAMES_SJH_CONTRACT: "ST_JAMES_SJH_CONTRACT",
    ANNABELS_OFFER_LETTER: "ANNABELS_OFFER_LETTER",
    ST_AUSTELL_BREWERY_CONTRACT: "ST_AUSTELL_BREWERY_CONTRACT",
    SAMBA_GARDEN_CONTRACT: "SAMBA_GARDEN_CONTRACT",
    INCIPIO_CONTRACT: "INCIPIO_CONTRACT",
    SAMBA_LONDON_CONTRACT: "SAMBA_LONDON_CONTRACT",
    THE_PAROGON_CONTRACT: "THE_PAROGON_CONTRACT",
    SAMBA_CRIMINAL_CONVICTION: "SAMBA_CRIMINAL_CONVICTION",
    SAMBA_HEALTH_QUESTIONNAIRE: "SAMBA_HEALTH_QUESTIONNAIRE",
    SAMBA_REFERENCE_FORM: "SAMBA_REFERENCE_FORM",
    SAMBA_TRONC_LETTER: "SAMBA_TRONC_LETTER",
    WH_380_E_FORM: "WH_380_E_FORM",
    ORANGE_TRONC_LETTER: "ORANGE_TRONC_LETTER",
    PIZZA_HUT_DRIVER_HEALTH_QUESTIONNAIRE: "PIZZA_HUT_DRIVER_HEALTH_QUESTIONNAIRE",
    COTE_HO_CONTRACTS: "COTE_HO_CONTRACTS",
    SHIVA_CONTRACT:"SHIVA_CONTRACT",
    STICK_SUSHI_ONBOARDING_FISH: "STICK_SUSHI_ONBOARDING_FISH",
    COTE_HO_HOURLY_CONTRACTS: "COTE_HO_HOURLY_CONTRACTS",
    FUGGLES_CONTRACT: "FUGGLES_CONTRACT",
    ARCHIES_OFFER_LETTER: "ARCHIES_OFFER_LETTER",
    STICK_SUSHI_OFFBOARDING_FISH: "STICK_SUSHI_OFFBOARDING_FISH",
    ORANGE_MANAGEMENT_TRONC_LETTER: "ORANGE_MANAGEMENT_TRONC_LETTER",
    BADIANI_1932_CONTRACT: "BADIANI_1932_CONTRACT",
    WYNDHAM_PAUSE_LAUNCH: "WYNDHAM_PAUSE_LAUNCH",
    SEASONS_SEAHAM_CONTRACT: "SEASONS_SEAHAM_CONTRACT",
    PIZZA_HUT_HEALTH_QUESTIONNAIRE: "PIZZA_HUT_HEALTH_QUESTIONNAIRE",
    PIZZA_HUT_PENSION_PLAN: "PIZZA_HUT_PENSION_PLAN",
    PIZZA_HUT_CONTRACT: "PIZZA_HUT_CONTRACT",
    VE_RARE_BIRD_HOTELS_CONTRACT: "VE_RARE_BIRD_HOTELS_CONTRACT",
    SEASONS_OPERATIONS_CONTRACT: "SEASONS_OPERATIONS_CONTRACT",
    SEASONS_SALES_CONTRACT: "SEASONS_SALES_CONTRACT",
    PIZZA_HUT_RSC_CONTRACT: "PIZZA_HUT_RSC_CONTRACT",
    BURGER_KING_CONTRACT: "BURGER_KING_CONTRACT",
    BROTHER_MARCUS_CONTRACT: "BROTHER_MARCUS_CONTRACT",
    FARMER_BOYS_CHANGE_RELATIONSHIP: "FARMER_BOYS_CHANGE_RELATIONSHIP",
    UNEMPLOYMENT_ELIGIBILITY_NY: "UNEMPLOYMENT_ELIGIBILITY_NY",
    CHILLED_PUBS_CONTRACT: "CHILLED_PUBS_CONTRACT",
    CHESTERFORD_FISH_CONTRACT: "CHESTERFORD_FISH_CONTRACT",
    CHESTERFORD_GROUP_CONTRACT: "CHESTERFORD_GROUP_CONTRACT",
    DD_CONTRACT: "DD_CONTRACT",
    BILLS_CONTRACT: "BILLS_CONTRACT",
    BILLS_HOURLY_CONTRACT: "BILLS_HOURLY_CONTRACT",
    ICF_WORK_OPPORTUNITY_TAX_CREDIT: "ICF_WORK_OPPORTUNITY_TAX_CREDIT",
    FIGHT_CLUB_CONTRACT: "FIGHT_CLUB_CONTRACT",
    TATTU_TRAINING_HEALTH_SAFETY_BOOKLET: "TATTU_TRAINING_HEALTH_SAFETY_BOOKLET",
    RED_ENGINE_CONTRACT: "RED_ENGINE_CONTRACT",
    CENTURION_CONTACT: "CENTURION_CONTACT",
    PJ_ARBITRATION_AGREEMENT: "PJ_ARBITRATION_AGREEMENT",
    PJ_PZ_CAROLINA_ARBITRATION_AGREEMENT: "PJ_PZ_CAROLINA_ARBITRATION_AGREEMENT",
    PJ_PERFECT_TN_ARBITRATION_AGREEMENT: "PJ_PERFECT_TN_ARBITRATION_AGREEMENT",
    PJ_PIE_GUYS_ARBITRATION_AGREEMENT : "PJ_PIE_GUYS_ARBITRATION_AGREEMENT",
    PJ_STANZEL_ARBITRATION_AGREEMENT : "PJ_STANZEL_ARBITRATION_AGREEMENT",
    HC_5_EMPLOYEE_NOTIFICATION: "HC_5_EMPLOYEE_NOTIFICATION",
    HALL_WOODHOUSE_GM_FINANCE_CHECK: "HALL_WOODHOUSE_GM_FINANCE_CHECK",
    CATCH_WAGE_NOTIFICATION_FORM: "CATCH_WAGE_NOTIFICATION_FORM",
    BROTHER_MARCUS_TRONC_LETTER: "BROTHER_MARCUS_TRONC_LETTER",
    GENTLEMEN_BARISTAS_CONTRACT: "GENTLEMEN_BARISTAS_CONTRACT",
    SHOOT_THE_BULL_CONTRACT: "SHOOT_THE_BULL_CONTRACT",
    THE_BATH_BUP_CONTRACT: "THE_BATH_BUP_CONTRACT",
    LANGAN_CHUCS_CONTRACT: "LANGAN_CHUCS_CONTRACT",
    ADVENTURE_PARC_CONTRACT: "ADVENTURE_PARC_CONTRACT",
    SQUARE_GRILL_CONTRACT: "SQUARE_GRILL_CONTRACT",
    TATTU_RISK_ASSESSMENT_TRAINING_RECORD: "TATTU_RISK_ASSESSMENT_TRAINING_RECORD",
    BOPARAN_BANK_DETAILS_VERIFICATION: "BOPARAN_BANK_DETAILS_VERIFICATION",
    NY_WAGE_NOTICE: "NY_WAGE_NOTICE",
    CAL_SAVERS_OPT_OUT: "CAL_SAVERS_OPT_OUT",
    ROTIKING_CONTRACT: "ROTIKING_CONTRACT",
    THE_WORKS_EIRE_CONTRACT: "THE_WORKS_EIRE_CONTRACT",
    THE_WORKS_ISLE_CONTRACT: "THE_WORKS_ISLE_CONTRACT",
    THE_WORKS_NIR_CONTRACT: "THE_WORKS_NIR_CONTRACT",
    THE_WORKS_UK_CONTRACT: "THE_WORKS_UK_CONTRACT",
    THE_WORKS_UK_PROMOTION_CONTRACT: "THE_WORKS_UK_PROMOTION_CONTRACT",
    ELECTRIC_SHUFFLE_CONTRACT: "ELECTRIC_SHUFFLE_CONTRACT",
    HALL_WOODHOUSE_SALARIED_EXPRESSION_OF_WISH: "HALL_WOODHOUSE_SALARIED_EXPRESSION_OF_WISH",
    RITZ_LONDON_NOMINATION_OF_BENEFICIARY: "RITZ_LONDON_NOMINATION_OF_BENEFICIARY",
    FIGHT_CLUB_MANAGEMENT_CONTRACT: "FIGHT_CLUB_MANAGEMENT_CONTRACT",
    SAVOY_MEDICAL_QUESTIONNAIRE: "SAVOY_MEDICAL_QUESTIONNAIRE",
    PAPA_JOHNS_AIO_DRIVER_MANAGER: "PAPA_JOHNS_AIO_DRIVER_MANAGER",
    PAPA_JOHNS_AIO_INSIDER: "PAPA_JOHNS_AIO_INSIDER",
    CHALKPIT_CONTRACT: "CHALKPIT_CONTRACT",
    STRADA_CONTRACT: "STRADA_CONTRACT",
    ST_JAMES_IMOLOTT_CONTRACT: "ST_JAMES_IMOLOTT_CONTRACT",
    SABOR_CONTRACT: "SABOR_CONTRACT",
    BONE_BURGER_CONTRACT: "BONE_BURGER_CONTRACT",
    BRASSERIE_BAR_CONTRACT: "BRASSERIE_BAR_CONTRACT",
    SEASONS_STARTER_FORM: "SEASONS_STARTER_FORM",
    ACE_HOTEL_CONTRACT: "ACE_HOTEL_CONTRACT",
    COTE_RESTAURANT_MANAGER_CONTRACTS: "COTE_RESTAURANT_MANAGER_CONTRACTS",
    COTE_RESTAURANT_HOURLY_ALL_CONTRACTS: "COTE_RESTAURANT_HOURLY_ALL_CONTRACTS",
    COTE_RESTAURANT_HOURLY_CONTRACTS: "COTE_RESTAURANT_HOURLY_CONTRACTS",
    COTE_RESTAURANT_TEAM_HOURLY_CONTRACTS: "COTE_RESTAURANT_TEAM_HOURLY_CONTRACTS",
    THUNDERBIRD_CONTRACT: "THUNDERBIRD_CONTRACT",
    MONTE_FORTE_CONTRACT: "MONTE_FORTE_CONTRACT",
    BRASSERIE_BAR_TEAM_MEMBER_CONTRACT: "BRASSERIE_BAR_TEAM_MEMBER_CONTRACT",
    BISTROT_PIERRE_HOURLY_CONTRACT: "BISTROT_PIERRE_HOURLY_CONTRACT",
    BISTROT_PIERRE_SALARIED_CONTRACT: "BISTROT_PIERRE_SALARIED_CONTRACT",
    BISTROT_PIERRE_GM_CONTRACT: "BISTROT_PIERRE_GM_CONTRACT",
    ALMOND_FAMILY_PUBS_CONTRACT: "ALMOND_FAMILY_PUBS_CONTRACT",
    ARCADE_THEATRE_CONTRACT: "ARCADE_THEATRE_CONTRACT",
    THE_CONDUIT_CONTRACT: "THE_CONDUIT_CONTRACT",
    RC_GROUP_CONTRACT: "RC_GROUP_CONTRACT",
    CARAVAN_CCR_CONTRACT: "CARAVAN_CCR_CONTRACT",
    CARAVAN_GM_CONTRACT: "CARAVAN_GM_CONTRACT",
    CARAVAN_CONTRACT: "CARAVAN_CONTRACT",
    VEL_CONTRACT: "VEL_CONTRACT",
    VARIOUS_EATERIES_CONTRACT: "VARIOUS_EATERIES_CONTRACT",
    TOMAHAWK_CONTRACT: "TOMAHAWK_CONTRACT",
    URBAN_LEISURE_CONTRACT: "URBAN_LEISURE_CONTRACT",
    BIRLEY_CLUB_CONTRACT: "BIRLEY_CLUB_CONTRACT",
    FLAT_IRON_CONTRACT: "FLAT_IRON_CONTRACT",
    ANNABELS_TRONC_LETTER: "ANNABELS_TRONC_LETTER",
    GALETA_CONTRACT: "GALETA_CONTRACT",
    MJMK_CONTRACT: "MJMK_CONTRACT",
    GUESTHOUSE_CONTRACT: "GUESTHOUSE_CONTRACT",
    WEBBER_TIP_CREDIT_NOTICE: "WEBBER_TIP_CREDIT_NOTICE",
    NZR_GROUP_UNIFORM_EQUIPMENT_ISSUE_FORM: "NZR_GROUP_UNIFORM_EQUIPMENT_ISSUE_FORM",
    CJB_TERMS_CONDITIONS_OF_EMPLOYMENT: "CJB_TERMS_CONDITIONS_OF_EMPLOYMENT",
    TATTU_LIQUOR_INDEMNITY_EMPLOYEE_DECLARATION: "TATTU_LIQUOR_INDEMNITY_EMPLOYEE_DECLARATION",
    CARAVAN_PRIVACY_NOTICE: "CARAVAN_PRIVACY_NOTICE",
    SWAN_INN_CONTRACT: "SWAN_INN_CONTRACT",
    COUNTRY_CREATURES_CONTRACT: "COUNTRY_CREATURES_CONTRACT",
    GET_FOOD_CONTRACT: "GET_FOOD_CONTRACT",
    VINOTECA_CONTRACT: "VINOTECA_CONTRACT",
    CHEQUERS_INN_CONTRACT: "CHEQUERS_INN_CONTRACT",
    WATCH_HOUSE_CONTRACT: "WATCH_HOUSE_CONTRACT",
    WATCH_HOUSE_HO_CONTRACT: "WATCH_HOUSE_HO_CONTRACT",
    BKUK_CHANGE_OF_DETAILS: "BKUK_CHANGE_OF_DETAILS",
    LKN_MARKETS_CONTRACT: "LKN_MARKETS_CONTRACT",
    SNOOZE_GETTING_TO_KNOW_YOU: "SNOOZE_GETTING_TO_KNOW_YOU",
    SNOOZE_DIRECT_DEPOSIT: "SNOOZE_DIRECT_DEPOSIT",
    DOS_TOROS_DISPUTE_AGREEMENT: "DOS_TOROS_DISPUTE_AGREEMENT",
    CHOPT_DISPUTE_AGREEMENT: "CHOPT_DISPUTE_AGREEMENT",
    HONEST_BURGER_BANK_ACCOUNT_NI_FORM: "HONEST_BURGER_BANK_ACCOUNT_NI_FORM",
    HUMBLE_GRAPE_ONBOARDING_QA: "HUMBLE_GRAPE_ONBOARDING_QA",
    COPPA_CLUB_PENSION_LETTER: "COPPA_CLUB_PENSION_LETTER",
    CC_COV19_VACCINE_QUESTIONNAIRE: "CC_COV19_VACCINE_QUESTIONNAIRE",
    COVID_VACCINATION_QUESTIONNAIRE: "COVID_VACCINATION_QUESTIONNAIRE",
    JG_COV19_VACCINE_QUESTIONNAIRE: "JG_COV19_VACCINE_QUESTIONNAIRE",
    ABC_EMPLOYEE_HEALTH_PLAN: "ABC_EMPLOYEE_HEALTH_PLAN",
    GOTHAM_BENEFIT_INFORMATION: "GOTHAM_BENEFIT_INFORMATION",
    GOTHAM_BENEFIT_INFORMATION_DOUBLE: "GOTHAM_BENEFIT_INFORMATION_DOUBLE",
    MFG_FAMILY_MEAL_ELECTION: "MFG_FAMILY_MEAL_ELECTION",
    WOLFGANG_PUCK_TIP_AGREEMENT: "WOLFGANG_PUCK_TIP_AGREEMENT",
    MERAKI_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE: "MERAKI_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE",
    MICHAEL_CAINS_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE: "MICHAEL_CAINS_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE",
    MICHIGAN_TAX_WITHHOLDING: "MICHIGAN_TAX_WITHHOLDING",
    HAWKSMOOR_LIFE_ASSURANCE_FORM: "HAWKSMOOR_LIFE_ASSURANCE_FORM",
    PAPA_JOHNS_ENROLLMENT_FORM: "PAPA_JOHNS_ENROLLMENT_FORM",
    DAVE_CONFIDENTIALITY_AGREEMENT:"DAVE_CONFIDENTIALITY_AGREEMENT",
    HALL_WOODHOUSE_VISITOR_CENTER_MY_REWARDS:"HALL_WOODHOUSE_VISITOR_CENTER_MY_REWARDS",
    HALL_WOODHOUSE_SALARIED_MY_REWARDS:"HALL_WOODHOUSE_SALARIED_MY_REWARDS",
    VILLAGE_HOTELS_CRIMINAL_REFERENCE:"VILLAGE_HOTELS_CRIMINAL_REFERENCE",
    PITA_VOLUNTARY_ARBITRATION_AGREEMENT:"PITA_VOLUNTARY_ARBITRATION_AGREEMENT",
    RECEIPT_ACK_EMPLOYEE_HANDBOOK:"RECEIPT_ACK_EMPLOYEE_HANDBOOK",
    NORTHERN_MANAGEMENT_EMPLOYEE_HANDBOOK_POLICY_ACK:"NORTHERN_MANAGEMENT_EMPLOYEE_HANDBOOK_POLICY_ACK",
    FMI_CA_DISPUTE_RESOLUTION:"FMI_CA_DISPUTE_RESOLUTION",
    SF_CITY_OPTION_FORM:"SF_CITY_OPTION_FORM",
    DONER_SUMMER_HEALTH_DECLARATION:"DONER_SUMMER_HEALTH_DECLARATION",
    DAVE_PERSONAL_ACTION_FORM:"DAVE_PERSONAL_ACTION_FORM",
    MCD_PROGRESSIVE_DISCIPLINARY_ACTION_FORM:"MCD_PROGRESSIVE_DISCIPLINARY_ACTION_FORM",
    PREZZO_LIFE_BENEFICIARY_FORM:"PREZZO_LIFE_BENEFICIARY_FORM",
    LIBERATION_GROUP_STARTER_FORM: "LIBERATION_GROUP_STARTER_FORM",
    NJ_COMMUTER_BENEFITS_PARTICIPATION_FORM: "NJ_COMMUTER_BENEFITS_PARTICIPATION_FORM",
    BPA_BIOMETRIC_DATA_POLICY:"BPA_BIOMETRIC_DATA_POLICY",
    YELLOWSTONE_PROPERTY_DRIVING_AGREEMENT: "YELLOWSTONE_PROPERTY_DRIVING_AGREEMENT",
    ART_CLUB_DUBAI_PRE_EMPLOYMENT_MEDICAL_FORM : "ART_CLUB_DUBAI_PRE_EMPLOYMENT_MEDICAL_FORM",
    LACOSTE_ARBITRATION_AGREEMENT: "LACOSTE_ARBITRATION_AGREEMENT",
    WENDY_EXPRESSION_OF_WISH: "WENDY_EXPRESSION_OF_WISH",
    CIRRUS_INNS_HEALTH_QUESTIONNAIRE: "CIRRUS_INNS_HEALTH_QUESTIONNAIRE",
    MCDONALDS_CONDITIONAL_FOOD_INTERVIEW: "MCDONALDS_CONDITIONAL_FOOD_INTERVIEW",
    CIRRUS_INNS_POLICIES: "CIRRUS_INNS_POLICIES",
    SEAC_CERTIFICATE_QUESTIONNAIRE: "SEAC_CERTIFICATE_QUESTIONNAIRE",
    BIG_TABLE_EXPRESS_OF_WISH: "BIG_TABLE_EXPRESS_OF_WISH",
    BIG_TABLE_EMPLOYMENT_DECLARATION: "BIG_TABLE_EMPLOYMENT_DECLARATION",
    BIG_TABLE_EEO: "BIG_TABLE_EEO",
    BIG_TABLE_HO_CONTRACT: "BIG_TABLE_HO_CONTRACT",
    SEAC_FOOD_SAFETY_POLICIES: "SEAC_FOOD_SAFETY_POLICIES",
    SEAC_CONSENT_FORM: "SEAC_CONSENT_FORM",
    SEAC_MEDICAL_QUESTIONNAIRE: "SEAC_MEDICAL_QUESTIONNAIRE",
    SEAC_WORKING_TIME_REGULATIONS: "SEAC_WORKING_TIME_REGULATIONS",
    GAUCHO_POLICIES_BIRMINGHAM: "GAUCHO_POLICIES_BIRMINGHAM",
    GAUCHO_POLICIES_EDINBURGH: "GAUCHO_POLICIES_EDINBURGH",
    GAUCHO_POLICIES_LEEDS: "GAUCHO_POLICIES_LEEDS",
    GAUCHO_POLICIES_LONDON_MANCHESTER: "GAUCHO_POLICIES_LONDON_MANCHESTER",
    RADISSON_DENMARK_PERSONAL_DETAILS:"RADISSON_DENMARK_PERSONAL_DETAILS",
    RADISSON_SWEDEN_PERSONAL_DETAILS:"RADISSON_SWEDEN_PERSONAL_DETAILS",
    NORTH_COUNTRY_PIZZA_DRIVER_AGREEMENT:"NORTH_COUNTRY_PIZZA_DRIVER_AGREEMENT",
    RADISSON_NORWAY_PERSONAL_DETAILS:"RADISSON_NORWAY_PERSONAL_DETAILS",
    RADISSON_BRUSSEL_PERSONAL_DETAILS:"RADISSON_BRUSSEL_PERSONAL_DETAILS",
    RADISSON_MADRID_PERSONAL_DETAILS:"RADISSON_MADRID_PERSONAL_DETAILS",
    RADISSON_SPAIN_PERSONAL_DETAILS: "RADISSON_SPAIN_PERSONAL_DETAILS",
    AT_PERSONAL_DETAILS_FORM:"AT_PERSONAL_DETAILS_FORM",
    YELLOWSTONE_SKI_PASS_AGREEMENT: "YELLOWSTONE_SKI_PASS_AGREEMENT",
    SF_HEALTH_CARE_WAIVER_FORM:"SF_HEALTH_CARE_WAIVER_FORM",
    TOG_MEAL_WAIVER_FORM:"TOG_MEAL_WAIVER_FORM",
    COPPA_CLUB_CONTRACT: "COPPA_CLUB_CONTRACT",
    COPPA_CLUB_CHILDREN_CONTRACT: "COPPA_CLUB_CHILDREN_CONTRACT",
    CG_WORKING_TIME_REGULATION: "CG_WORKING_TIME_REGULATION",
    BELOW_CONTRACT: "BELOW_CONTRACT",
    VURGER_CO_CONTRACT: "VURGER_CO_CONTRACT",
    WILTON_HOLDINGS_CONTRACT: "WILTON_HOLDINGS_CONTRACT",
    FRANCO_HOLDINGS_CONTRACT: "FRANCO_HOLDINGS_CONTRACT",
    BELOW_CHILDREN_CONTRACT: "BELOW_CHILDREN_CONTRACT",
    AUBAINE_CONTRACT: "AUBAINE_CONTRACT",
    GAUCHO_CONTRACT: "GAUCHO_CONTRACT",
    GAUCHO_HEAD_OFFICE_CONTRACT: "GAUCHO_HEAD_OFFICE_CONTRACT",
    DISHOOM_CONTRACT: "DISHOOM_CONTRACT",
    MULINO_PERSONAL_INFO: "MULINO_PERSONAL_INFO",
    DEEP_BLUE_OPT_OUT:"DEEP_BLUE_OPT_OUT",
    PJ_DMD_CHILD_LABOR_LAW_NOTICE:"PJ_DMD_CHILD_LABOR_LAW_NOTICE",
    PJ_FL_CHILD_LABOR_LAW_NOTICE:"PJ_FL_CHILD_LABOR_LAW_NOTICE",
    DAVES_TWC_INSURANCE_FORM:"DAVES_TWC_INSURANCE_FORM",
    VIVA_CARES_AUTHORIZATION_FORM:"VIVA_CARES_AUTHORIZATION_FORM",
    NORTHSTAR_REFERRAL_FORM:"NORTHSTAR_REFERRAL_FORM",
    NORTHSTAR_REFERRAL_FORM_V2:"NORTHSTAR_REFERRAL_FORM_V2",
    SMASHBURGER_MEAL_WAIVER_FORM:"SMASHBURGER_MEAL_WAIVER_FORM",
    SMASHBURGER_CWOPA_NEW_HIRE_FORM:"SMASHBURGER_CWOPA_NEW_HIRE_FORM",
    JOLIBEE_EMPLOYEMENT_ELIGIBITLITY_VERIFICATION:"JOLIBEE_EMPLOYEMENT_ELIGIBITLITY_VERIFICATION",
    BREAKFAST_CLUB_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE:"BREAKFAST_CLUB_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE",
    TATTU_FOOD_HANDLER_QUESTIONNAIRE:"TATTU_FOOD_HANDLER_QUESTIONNAIRE",
    WORKS_NOK_FORM:"WORKS_NOK_FORM",
    CHESTERFORD_EXPRESSION_OF_WISH:"CHESTERFORD_EXPRESSION_OF_WISH",
    LORE_HOTELS_PERSONAL_FORM: "LORE_HOTELS_PERSONAL_FORM",
    LORE_PERSONAL_DETAILS_FORM: "LORE_PERSONAL_DETAILS_FORM",
    MIGUELS_UNIFORM_AUTHORIZATION: "MIGUELS_UNIFORM_AUTHORIZATION",
    WELLS_CO_TIPS_DECLARATION: "WELLS_CO_TIPS_DECLARATION",
    IVY_DAWOSN_OFFER_LETTER: "IVY_DAWOSN_OFFER_LETTER",
    CIRRUS_INNS_PERSONAL_DETAILS: "CIRRUS_INNS_PERSONAL_DETAILS",
    ARTIST_RESIDENCE_CONTRACT: "ARTIST_RESIDENCE_CONTRACT",
    AUBAINE_FRANCAIS_CONTRACT: "AUBAINE_FRANCAIS_CONTRACT",
    AUBAINE_SUPPORT_CONTRACT: "AUBAINE_SUPPORT_CONTRACT",
    WR_LINA_STORE_CONTRACT: "WR_LINA_STORE_CONTRACT",
    WR_KYMS_CONTRACT: "WR_KYMS_CONTRACT",
    MERAKI_CONTRACT: "MERAKI_CONTRACT",
    MAGNOLIA_PAY_RATE_NOTICE: "MAGNOLIA_PAY_RATE_NOTICE",
    AHH_EMPLOYEE_REQUIREMENTS: "AHH_EMPLOYEE_REQUIREMENTS",
    MULINO_ACK_PAY_RATE_NY: "MULINO_ACK_PAY_RATE_NY",
    MULINO_ACK_PAY_RATE_IL: "MULINO_ACK_PAY_RATE_IL",
    LITTLE_GEMS_ACCOMMODATION_AGREEMENT: "LITTLE_GEMS_ACCOMMODATION_AGREEMENT",
    DRAKE_MORGAN_EMPLOYMENT_CONFIRMATION: "DRAKE_MORGAN_EMPLOYMENT_CONFIRMATION",
    HARRY_RAMSDEN_CONTRACT: "HARRY_RAMSDEN_CONTRACT",
    HARRY_RAMSDEN_HOURLY_CONTRACT: "HARRY_RAMSDEN_HOURLY_CONTRACT",
    HARRY_RAMSDEN_EU_HOURLY_CONTRACT: "HARRY_RAMSDEN_EU_HOURLY_CONTRACT",
    HARRY_RAMSDEN_IRELAND_CONTRACT: "HARRY_RAMSDEN_IRELAND_CONTRACT",
    PROPER_EMPLOYMENT_APPLICATION: "PROPER_EMPLOYMENT_APPLICATION",
    LDV_EMPLOYMENT_APPLICATION: "LDV_EMPLOYMENT_APPLICATION",
    JEAN_GEORGES_TRANSITCHECK_DEDUCTION: "JEAN_GEORGES_TRANSITCHECK_DEDUCTION",
    RED_CARNATION_HEALTH_QUESTIONNAIRE: "RED_CARNATION_HEALTH_QUESTIONNAIRE",
    THE_WORKS_UNIFORM_ORDER: "THE_WORKS_UNIFORM_ORDER",
    SCHEDULE_AVAILABILITY_FORM: "SCHEDULE_AVAILABILITY_FORM",
    DAVES_CHICKEN_ARBITRATION_AGREEMENT: "DAVES_CHICKEN_ARBITRATION_AGREEMENT",
    PAPA_JOHNS_VEHICLE_INSPECTION: "PAPA_JOHNS_VEHICLE_INSPECTION",
    FARMERS_BOYS_EMPLOYEE_INFO: "FARMERS_BOYS_EMPLOYEE_INFO",
    COTE_PERSONAL_OPT_OUT: "COTE_PERSONAL_OPT_OUT",
    AUBAINE_PERSONAL_DETAILS_SINGLE: "AUBAINE_PERSONAL_DETAILS_SINGLE",
    COTE_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE: "COTE_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE",
    I9_REVERIFICATION_SECTION_3: "I9_REVERIFICATION_SECTION_3",
    ANDREW_BROWNSWORD_HEALTH_ASSESSMENT: "ANDREW_BROWNSWORD_HEALTH_ASSESSMENT",
    HARTS_EMPLOYEE_STARTER_FORM: "HARTS_EMPLOYEE_STARTER_FORM",
    KRICKET_STARTER_FORM: "KRICKET_STARTER_FORM",
    CHARLES_REFERENCE_FORM: "CHARLES_REFERENCE_FORM",
    FOOD_HANDLERS_HEALTH_DECLARATION: "FOOD_HANDLERS_HEALTH_DECLARATION",
    CDG_BANK_ACCOUNT_DETAILS: "CDG_BANK_ACCOUNT_DETAILS",
    CDG_EMERGENCY: "CDG_EMERGENCY",
    CDG_EMPLOYEE_STARTER_FORM: "CDG_EMPLOYEE_STARTER_FORM",
    CDG_CRIMINAL_RECORD_FORM: "CDG_CRIMINAL_RECORD_FORM",
    CDG_REFERENCE_REQUEST_FORM: "CDG_REFERENCE_REQUEST_FORM",
    CDG_PERSONAL_LICENSE: "CDG_PERSONAL_LICENSE",
    ANTI_SEXUAL_HARASSMENT_NY: "ANTI_SEXUAL_HARASSMENT_NY",
    FEDERAL_TD1: "FEDERAL_TD1",
    ONTARIO_TAX: "ONTARIO_TAX",
    CG_TUTTONS_CONTRACT: "CG_TUTTONS_CONTRACT",
    CG_FIRE_STONE_CONTRACT: "CG_FIRE_STONE_CONTRACT",
    CG_DIRTY_MARTINI_CONTRACT: "CG_DIRTY_MARTINI_CONTRACT",
    CG_HEAD_OFFICE_CONTRACT: "CG_HEAD_OFFICE_CONTRACT",
    CUBITT_HOUSE_SET_TRONC: "CUBITT_HOUSE_SET_TRONC",
    CUBITT_HOUSE_VARIANCE_TRONC: "CUBITT_HOUSE_VARIANCE_TRONC",
    OLE_STEEN_MEDICAL_QUESTIONNAIRE: "OLE_STEEN_MEDICAL_QUESTIONNAIRE",
    LDV_ARBITRATION_AGREEMENT: "LDV_ARBITRATION_AGREEMENT",
    RARE_BIRD_CONTRACT: "RARE_BIRD_CONTRACT",
    INAMO_CONTRACT: "INAMO_CONTRACT",
    RED_CARNATION_CONTRACT: "RED_CARNATION_CONTRACT",
    GENERATOR_GERMANY_CONTRACT: "GENERATOR_GERMANY_CONTRACT",
    JP_TAX_RESIDENTIAL_STATUS: "JP_TAX_RESIDENTIAL_STATUS",
    MARKS_CLUB_TRONC_LETTER: "MARKS_CLUB_TRONC_LETTER",
    BUNDOBUST_CONTRACT: "BUNDOBUST_CONTRACT",
    VILLAGE_HOTELS_TM_CONTRACT: "VILLAGE_HOTELS_TM_CONTRACT",
    VILLAGE_HOTELS_HOD_CONTRACT: "VILLAGE_HOTELS_HOD_CONTRACT",
    SEAFOOD_PUB_CONTRACT: "SEAFOOD_PUB_CONTRACT",
    SEAFOOD_BAR_CONTRACT: "SEAFOOD_BAR_CONTRACT",
    FOLIE_CONTRACT: "FOLIE_CONTRACT",
    BIG_SMOKE_CONTRACT: "BIG_SMOKE_CONTRACT",
    MORGAN_PUB_CONTRACT: "MORGAN_PUB_CONTRACT",
    VQ_RESTAURANT_CONTRACT: "VQ_RESTAURANT_CONTRACT",
    GENERATOR_HEALTH_QUESTIONNAIRE: "GENERATOR_HEALTH_QUESTIONNAIRE",
    GENERATOR_STARTER_ACCEPTANCE_FORM: "GENERATOR_STARTER_ACCEPTANCE_FORM",
    RED_CARNATION_ADDITIONAL_DOCS: "RED_CARNATION_ADDITIONAL_DOCS",
    ROYAL_LANCASTER_CONTRACT: "ROYAL_LANCASTER_CONTRACT",
    FARMER_BOYS_LOF_MEAL_WAIVER: "FARMER_BOYS_LOF_MEAL_WAIVER",
    FARMER_BOYS_IRIS_MEAL_WAIVER: "FARMER_BOYS_IRIS_MEAL_WAIVER"
};

OnBoardingAPI.GOOD_FAITH_ESTIMATE_GROUP = [
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_EXPRESS,
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_OREGON,
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_CHICAGO,
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_SAN_FRANCISCO,
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_LITE,
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_PHILADELPHIA,
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_SEATTLE,
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_EMERYVILLE,
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_LOS_ANGELES,
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_EVANSTON,
    OnBoardingAPI.DOCUMENT_TYPE.GOOD_FAITH_ESTIMATE_SCHEDULE_BERKELEY,
];

OnBoardingAPI.DOC_TYPE_TEXT = {
    OFFER:                                          "Employment Offer",
    I9:                                             "Employment Eligibility (I9)",
    W4:                                             "Federal Withholding (W4)",
    DIGITAL_APPLICATION:                            "Digital Application",
    DIGITAL_APPLICATION_OB:                         "Digital Application",
    MINOR_WORK_DOCUMENTATION:                       "Minor Work Documentation",
    MINOR_WORK_DOCUMENTATION_WORK_PERMIT:           "Work Permit",
    MINOR_WORK_DOCUMENTATION_AGE_CERTIFICATE:       "Age Certificate",
    YOUNGS_LIVE_IN_OUT_CONTRACT:                    "Employment contract",
    KFC_GB_NEW_STARTER_FORM:                        "KFC New Starter Form",
    RADISSON_BELGIUM_INFORMATION_AND_ENROLMENT_FORM:"Information and enrolment form hospitalisation plan Belgium",
    MCD_UK_EMPLOYEE_ID:                             "My McDonald’s Employee Number",
    STATE_W_NY:                                      "New York State Withholding Form",
    STATE_W_CA:                                      "California State Withholding Form",
    TAX_CREDIT:                                     "Tax Credit Eligibility Form",
    EEO:                                            "Equal Employment Opportunity (EEO)",
    HARTS_EMERGENCY:                                "Emergency Contact",
    EMERGENCY:                                      "Emergency Contact",
    RADISSON_BELGIUM_FAMILY_DECLARATION_FR:         "WE Belgium Family Declaration FR",
    RADISSON_BELGIUM_FAMILY_DECLARATION_NL:         "WE Belgium Family Declaration NL",
    TNT_OPT_OUT_FORMS:                              "Opt-Out Forms",
    SAFETY_TRAINING:                                "Employee Safety Training",
    HANDBOOK:                                       "Handbook",
    TIP_POLICY:                                     "Tip Policy",
    PAY_RATE:                                       "Pay Rate Notice",
    END_OF_SERVICE:                                 "End of Service",
    IRS_8850:                                       "IRS (Form 8850)",
    CAFUA_NOTICE_OF_PAY:                            "Cafua Notice of Pay and Pay Day",
    NOTICE_EMPLOYEE_GENERAL:                        "Notice and Acknowledgement of Pay Rate and Payday",
    NOTICE_EMPLOYEE_NY:                             "Notice and Acknowledgement of Pay Rate and Payday",
    NOTICE_EMPLOYEE_NY_HOURLY:                      "Notice and Acknowledgement of Pay Rate and Payday (Hourly Rate Employees)",
    NOTICE_EMPLOYEE_NY_MULTI_RATE:                  "Notice and Acknowledgement of Pay Rate and Payday (Multiple Hourly Rate Employees)",
    NOTICE_EMPLOYEE_NY_SALARY:                      "Notice and Acknowledgement of Pay Rate and Payday (Salary)",
    NOTICE_EMPLOYEE_CA:                             "Notice to Employee",
    BURGER_LOBSTER_CONTRACT:                        "Employment Contract",
    BURGER_LOBSTER_HO_CONTRACT:                     "Head Office Contract",
    GOODMANS_CONTRACT:                              "Employment Contract",
    GOODMANS_HO_CONTRACT:                           "Head Office Contract",
    AGREEMENT_DIRECT_DEPOSIT:                       "Authorization Agreement for Direct Deposit",
    AGREEMENT_DIRECT_DEPOSIT_CA:                    "Authorization Agreement for Direct Deposit",
    WISELY_WAGE_PAYMENT:                            "Wage Payment Election Consent Form",
    EMPLOYEE_STARTER_FORM:                          "Employee Starter Form",
    AGREEMENT_DIRECT_DEPOSIT_UNIVERSAL_PAYCARD:     "Authorization Agreement for Direct Deposit",
    ZETTER_CONTRACT:                                "Employment Contract",
    GENERATOR_NETHERLANDS_CONTRACT:                 "Employment Contract",
    COTE_CONTRACT:                                  "Employment Contracts",
    CARLUCCIOS_N_CONTRACT:                          "Employment Contract",
    IRL_EMPLOYEE_STARTER_FORM:                      "Employee Starter Form",
    US_CAN_MIN_STARTER_FORM:                        "Starter Form",
    HOUSE_CAFE_HEALTH_QUESTIONNAIRE:                "Health Questionnaire",
    ST_AUSTELL_PERSONAL_FORM:                       "Personal Details Form",
    FRONT_BURNER_NEW_HIRE_FORM:                     "New Hire FORM",
    IRL_HEALTH_QUESTIONNAIRE:                       "Health Questionnaire",
    CATCH_HOSPITALITY_ARBITRATION_AGREEMENT:        "Arbitration Agreement",
    ARTFARM_EEO:                                    "Equal Opportunities Monitoring Form",
    KRICKET_EMPLOYMENT_LETTER:                      "Employment Letter",
    TENPIN_CONTRACT:                                "Employment Contract",
    TENPIN_SUPPORT_CONTRACT:                        "Employment Contract",
    STATE_W_AL:                                     "Alabama State Withholding Form",
    UPHAM_ACCOMMODATION_AGREEMENT:                  "Accommodation Contract",
    ALBERTA_TAX:                                    "Alberta Personal Tax Credit Return",
    EEO_UK:                                         "Equal Employment Opportunity (EEO)",
    EMPLOYEE_AVAILABILITY:                          "Employee Availability",
    NEWFOUNDLAND_AND_LABRADOR_TAX:                  "Newfoundland and Labrador Personal Tax Credits Return",
    EEO_CA:                                         "Equal Employment Opportunity (EEO)",
    SASKATCHEWAN_TAX:                               "Saskatchewan Personal Tax Credit Return",
    NEW_BRUNSWICK_TAX:                              "New Brunswick Personal Tax Credits Return",
    NOVA_SCOTIA_TAX:                                "Nova Scotia Personal Tax Credits Return",
    PRINCE_EDWARD_ISLAND_TAX:                       "Prince Edward Island Personal Tax Credits Return",
    NORTHWEST_TERRITORIES_TAX:                      "Northwest Territories Personal Tax Credits Return",
    YUKON_TAX:                                       "Yukon Personal Tax Credits Return",
    STATE_W_MA:                                     "Massachusetts State Withholding form",
    STATE_W_OH:                                     "Ohio State Withholding Form",
    STATE_W_MN:                                     "Minnesota State Withholding Form",
    NOTICE_EMPLOYEE_MN:                             "Minnesota Employee Notice",
    STATE_W_MD:                                     "Maryland State Withholding Form",
    STATE_W_KY:                                     "Kentucky State Withholding Form",
    STATE_W_MS:                                     "Mississippi State Withholding Form",
    STATE_W_OK:                                     "Oklahoma State Withholding Form",
    STATE_W_OR:                                     "Oregon State Withholding Form",
    STATE_W_MT:                                     "Montana State Withholding Form",
    STATE_W_VA:                                     "Virginia State Withholding Form",
    STATE_W_IL:                                     "Illinois State Withholding Form",
    STATE_W_IN:                                     "Indiana State Withholding Form",
    STATE_W_NJ:                                     "New Jersey State Withholding Form",
    STATE_W_DC:                                     "DC State Withholding Form",
    STATE_W_DC_NON_RESIDENCE:                       "DC Certificate of Nonresidence (D-4A)",
    STATE_W_GA:                                     "Georgia State Withholding Form",
    STATE_W_IA:                                     "Iowa State Withholding",
    STATE_W_HI:                                     "Hawaii State Withholding Form",
    STATE_W_ID:                                     "Idaho State Withholding Form",
    STATE_W_SC:                                     "South Carolina State Withholding Form",
    STATE_W_NE:                                     "Nebraska State Withholding Form",
    STATE_W_CO:                                     "Colorado Employee Withholding Certificate",
    MD_MW507M:                                      "Maryland MW507M",
    BENEFITS_NOTICE:                                "Notice of Benefits",
    CANDIDATE_ACCEPTANCE_FORM:                      "Candidate Acceptance Form",
    DISCLOSURE_AUTH:                                "Disclosure and Authorization Form",
    NOTICE_OF_HIRE:                                 "DC Notice Of Hire",
    STARTER_CHECKLIST:                              "Starter Checklist (P46)",
    CAFUA_DIRECT_DEPOSIT:                           "Wage Payment and Consent Form_NY",
    CAFUA_NH_DIRECT_DEPOSIT:                        "Wage Payment and Consent Form_NH",
    CAFUA_DIRECT_DEPOSIT_DEFAULT:                   "Wage Payment and Consent Form_MA/VT/ME/FL/RI",
    COMMUTER_BENEFITS:                              "Offer of Commuter Benefits",
    COMMUTER_BENEFITS_DOUBLE:                       "Offer of Commuter Benefits",
    COMMUTER_BENEFITS_DOUBLE_NJ:                     "Offer of Commuter Benefits",
    DC_COMMUTER_BENEFITS:                           "Offer of Commuter Benefits",
    MEATBALL_SHOP_DC_COMMUTER_BENEFITS:             "Offer of Commuter Benefits",
    IRL_DOUBLE_EMPLOYMENT_FORM:                     "Double Employment Form",
    WAIVE_MEAL_PERIODS:                             "Employee Agreement to Waive Meal Periods",
    HEALTH_QUESTIONNAIRE:                           "Health Questionnaire",
    BRASSERIE_HEALTH_QUESTIONNAIRE:                 "Health Questionnaire",
    WAIVER_GROUP_INSURANCE_PLAN:                    "Waiver of Group Insurance Plan",
    MINOR_AGE_AGREEMENT_OH:                         "Minor Wage Agreement",
    TRAINING_SCHEDULE:                              "Training Schedule form",
    RESIDENCY_CERTIFICATION:                        "Residency Certification Form",
    TRANSIT_CHECK:                                  "Transitcheck Commuter Employee Enrollment Form",
    TRANSIT_CHECK_ESP:                              "Transitcheck Commuter Employee Enrollment Form(Spanish)",
    COMMUTER_BENEFITS_ENROLLMENT:                   "Commuter Benefits Account Enrollment",
    NOTICE_EMPLOYEE_CHANGE_RELATIONSHIP:            "Notice to employee as to change in relationship",
    CONFIDENTIAL_SEPARATION_AGREEMENT_RELEASE:      "Confidential separation agreement and release",
    EMPLOYEE_TERMINATION_NY:                        "New York Employee Termination",
    REZIDOR_BENEFICIARY_DETAILS:                    "Nomination of Beneficiary Form",
    AT_NOMINATION_OF_BENEFICIARY:                   "Nomination of Beneficiary Form",
    E2_PAY_RATE:                                    "Notice of Pay Rates and Pay Day",
    ZUMA_FICHA_DE_EMPLEO:                           "ZUMA - Ficha de empleo",
    EO_DATA_FORM:                                   "Equal Opportunity Data Form",
    FOURTH_EO_DATA_FORM:                            "Equal Opportunity Data Form - Fourth",
    RADISSON_ITALY_EMPLOYEE_RECORD:                 "Informazioni personali del dipendente / Employee Record",
    FIRE_HEALTH_SAFETY_DECLARATION:                 "Fire/Health & Safety Declaration Form",
    REZIDOR_HEALTH_QUESTIONNAIRE:                   "Health Check Questionnaire & Declaration",
    DEEP_BLUE_HEALTH_QUESTIONNAIRE:                 "Health Questionnaire",
    PIZZA_HUT_EXPRESSION_OF_WISH:                   "Expression of Wish Form",
    PIZZA_HUT_DVLA_MANDATE:                         "DVLA Mandate",
    THE_CONDUIT_STARTER_FORM:                       "Starter form",
    PAPA_JOHNS_DRIVER_VEHICLE_FORM:                 "Driver - Vehicle Year, Make , Model",
    CREATIVE_CULINARY_HEALTH_INSURANCE_SURVEY:      "Health Insurance Survey",
    STICK_SUSHI_DK_STARTER_FORM:                    "DK Starter Form",
    EPS_STARTER_FORM:                               "EPS Starter Form",
	CONTRACT:                                       "Employment Contract",
	JOB_DESCRIPTION:                                "Job Description",
    POSITION_DOCS:                                  "Position Specific Documents",
    YO_SUSHI_CONTRACT:                              "Employment Contract",
    RICK_STEIN_CONTRACT:                            "Employment Contract",
    RICK_STEIN_CONTRAC_V2:                          "Employment Contract",
    YO_SUSHI_REFERENCE_DETAILS:                     "Reference Details Form",
    TFG_REFERRAL_BONUS_PROGRAM:                     "TFG Referral Bonus Program",
    ARF_WAIVER_COVERAGE_FORM:                       "Waiver of Coverage Form",
    SJB_WAIVER_COVERAGE_FORM:                       "Waiver of Coverage Form",
    CREATIVE_CULINARY_MANAGEMENT_HANDBOOK:          "Handbook Acknowledgment of Receipt & Agreement",
    MANITOBA_TAX:                                   "Manitoba Personal Tax Credit Return",
    THE_ONE_CODE_OF_CONDUCT:                        "Code of Conduct and Business Ethics",
    REAL_RESTAURANT_SICK_FORM:                      "Custom Sick Form",
    BKUK_REFERENCE_FORM:                            "BKUK Reference Form",
    REZIDOR_NIGHT_WORKERS:                          "Night Workers Medical Assessment",
    STICK_SUSHI_DE_STARTER_FORM:                    "DE Starter Form",
    REZIDOR_FOOD_HANDLERS_DECLARATION:              "Food Handlers Declaration",
    REZIDOR_PENSION_SCHEME:                         "Pension scheme document",
    STATE_W_NC:                                     "North Carolina State Withholding Form",
    YO_SUSHI_TEAM_MEMBER_CONTRACT:                  "Team Member Contract",
    APPLEBEES_TL_CANNON_EMPLOYMENT_APPLICATION:     "Applebees TL Cannon Employment Application",
    E2_PAY_RATE_SALARY:                             "Salary pay rate notice form",
    STATE_W_CT:                                     "Connecticut State Withholding Form",
    STATE_W_WI:                                     "Wisconsin State Withholding Form",
    STATE_W_WV:                                     "West Virginia State Withholding Form",
    STATE_W_LS:                                     "Louisiana State Withholding Form",
    STATE_W_KS:                                     "Kansas State Withholding Form",
    STATE_W_VT:                                     "Vermont State Withholding Form",
    STATE_W_ME:                                     "Maine State Withholding Form",
    STATE_W_DE:                                     "Delaware State Withholding Form",
    STATE_W_MO:                                     "Missouri State Withholding Form",
    LA_OWCA:                                        "LA OWCA Second Injury Board Knowledge Questionnaire",
    STATE_W_AZ:                                     "Arizona State Withholding Form",
    STATE_W_AR:                                     "Arkansas State Withholding Form",
    WESTCHESTER_EARNED_SICK_LEAVE:                  "Westchester County’s Earned Sick Leave",
    HARBOUR_UNIFORM:                                "Uniform Request Form",
    QUEBEC_TAX:                                     "Quebec TD1 Form",
    ART_CLUB_DUBAI_BANK_ACCOUNT_DETAILS:            "Bank Details Form",
    BRITISH_COLUMBIA_TAX:                           "British Columbia Personal Tax Credit Withholding",
    STATE_W_MI:                                     "Michigan State Withholding Form",
    REZIDOR_ELIGIBLE_EMPLOYEES:                     "Auto Enrollment for Eligible Employees",
    REZIDOR_POSTPONEMENT_NOTICE:                    "Postponement notice",
    REZIDOR_SCOTTISH_WIDOW_GROUP:                   "GPP Quote Request Form - Tax Year 2021-22",
    RADISSON_SCOTTISH_WIDOW_GROUP:                  "GPP Quote Request Form - Tax Year 2021-22",
    REZIDOR_BLU_EXECUTIVE_CONTRACT:                 "Employment Contract",
    REZIDOR_JERSEY_CONTRACT:                        "Employment Contract",
    REZIDOR_JERSEY_EXECUTIVE_CONTRACT:              "Employment Contract",
    REZIDOR_PARK_EXECUTIVE_CONTRACT:                "Employment Contract",
    DIRTY_BONES_CONTRACT:                           "General Contract",
    REZIDOR_WORKING_TIME:                           "Working Time Directive",
    RICK_STEIN_BIOMETRIC_FORM:                      "Biometric consent Form",
    BANK_ACCOUNT_DETAILS:                           "Bank Account Details",
    WORKS_BANK_ACCOUNT_DETAILS:                     "Bank Account Details",
    IRL_BANK_ACCOUNT_DETAILS:                       "ROI Bank Account Details",
    NANDOS_BG_CHECK:                                "Nando's Background check",
    PREZZO_SUPPORT_CONTRACT:                        "Employment Contract",
    PREZZO_HEALTH_QUESTIONNAIRE:                    "Food Handlers",
    PREZZO_RESTAURANT_CONTRACT:                     "Employment Contract",
    PREZZO_RESTAURANT_NEW_CONTRACT:                 "Employment Contract",
    PREZZO_HOURLY_STANDARD_CONTRACT:                "Employment Contract",
    ETM_CONTRACT:                                   "Employment Contract",
    LANCASTER_CONTRACT:                             "Employment Contract",
    WYBOSTON_LAKES_CONTRACT:                        "Employment Contract",
    LANCASTER_EVENTS_OP_CONTRACT:                   "Employment Contract",
    LANCASTER_FB_CONTRACT:                          "Employment Contract",
    LANCASTER_MANAGEMENT_CONTRACT:                  "Employment Contract",
    SAN_DIEGO_SICK_AND_WAGE:                        "San Diego Sick and Wage",
    CAVA_GRILL_HEALTH_CONDITION:                    "Health Conditions Reporting",
    GRAND_BRIGHTON_CONTRACT:                        "Employment Contract",
    HONEST_BURGERS_CONTRACT:                        "Employment Contract",
    DARK_KITCHEN_CONTRACT:                          "Employment Contract",
    PIZZA_PILGRIMS_CONTRACT:                        "Employment Contract",
    PIZZA_PILGRIMS_CHILD_CONTRACT:                  "Employment Contract",
    PIZZA_PILGRIMS_CHILD_WITH_TRONC_CONTRACT:      "Employment Contract",
    SLIM_CHICKENS_NEW_CONTRACT:                     "Employment Contract",
    CARLUCCIOS_NEW_CONTRACT:                        "Employment Contract",
    CINNAMON_CONTRACT:                              "Employment Contract",
    HONEST_BURGERS_HEAD_OFFICE_CONTRACT:            "Employment Contract",
    ANDREW_BROWNSWORD_CONTRACT:                     "Employment Contract",
    ANDREW_BROWNSWORD_ACCOMMODATION:                "Accommodation Agreement",
    THE_BATH_PRIORY_CONTRACT:                       "Employment Contract",
    GENERATOR_SPAIN_CONTRACT:                       "Employment Contract",
    GENERATOR_DENMARK_CONTRACT:                     "Employment Contract",
    VILAGE_EAST_CONTRACT:                           "Employment Contract",
    RIDING_HOUSE_CAFE_CONTRACT:                     "Employment Contract",
    RAILHOUSE_CAFE_CONTRACT:                        "Employment Contract",
    RIDING_HOUSE_CAFE_HQ_CONTRACT:                  "Employment Contract",
    HONEST_BURGERS_CONTRACT_HOURLY_ONLY:            "Employment Contract",
    LANCASTER_LANDMARK_DISCLOSURE:                  "Disclosure Form",
    LANCASTER_LANDMARK_MEDICAL_QUESTIONNAIRE:       "Medical Questionnaire",
    DOMINOS_PIZZA_PARTNERS_FOUNDATION:              "Domino's Pizza Partners Foundation",
    LANCASTER_LANDMARK_REFERENCES:                  "References",
    LANCASTER_LANDMARK_DEATH_ASSURANCE:             "Death in Service Life Assurance Scheme",
    LANCASTER_LANDMARK_EEO:                         "Equal Opportunities Form",
    LANDMARK_CONTRACT:                              "Employment Contract",
    IRL_REFERENCE_FORM:                             "References Form",
    TRANSPORTATION_BENEFIT_FORM:                    "Qualified Transportation Benefit Election Form",
    RADISSON_MEDICAL_HISTORY:                       "Medical History",
    RADISSON_HEALTH_CHECK:                          "Health Check Questionnaire & Declaration",
    RADISSON_EMEA_PERSONAL_LAUFZETTEL:              "Fragebogen über persönliche Angaben für den Eintritt",
    RADISSON_GERMANY_DECLARATION_FOR_WORK:          "Erklärung zum Haupt_Nebenarbeitgeber",
    BREAKFAST_CLUB_ONBOARDING_DOCS:                 "The breakfast club onboarding docs",
    BREAKFAST_CLUB_STATEMENT_OF_WORK:               "Statement of Working Conditions",
    BREAKFAST_CLUB_HEALTH_QUESTIONNAIRE:            "Food Handler Health Questionnaire",
    STATE_W_PR:                                     "Puerto Rico State Withholding Form",
    STATE_W_DISPATCHER:                             "State Withholding",
    IDENTITY_DOCUMENT:                              "Identity document",
    RADISSON_FRANCE_PERSONAL_DETAILS:               "WE France Employee Personal Details",
    ASCOTT_CONTRACT:                                "Employment Contract",
    MAWGLI_CONTRACT:                                "Employment Contract",
    THE_LOWRY_CONTRACT:                             "Employment Contract",
    COTE_OPT_OUT:                                   "48 Hour Opt-Out Form",
    DEEP_BLUE_CONTRACT:                             "Employment Contract",
    APOS_ACCOMMODATION_AGREEMENT:                   "Accommodation Agreement",
    CW_ACCOMMODATION_AGREEMENT:                     "Accommodation Agreement",
    GREYHOUND_CAFE_CONTRACT:                        "Employment Contract",
    COMBINED_DISCLOSURE_AUTHORIZATION:              "Background Check Disclosure Authorization Form",
    LOCKER_LOCK_AGREEMENT:                          "Locker/Lock Agreement",
    NOHO_TRANSIT_CARD:                              "Transit Card",
    ART_CLUB_CONTRACT:                              "Employment Contract",
    AOK_CONTRACT:                                "Employment Contract",
    WAGAMAMA_MANAGER_CONTRACT:                      "Employment Contract",
    WAGAMAMA_HEAD_OFFICE_CONTRACT:                  "Employment Contract",
    WAGAMAMA_TEAM_CONTRACT:                         "Employment Contract",
    ART_CLUB_HEALTH_QUESTIONNAIRE:                  "TAC Medical Questionnaire",
    PIZZA_HUT_HEALTHCARE_PLAN:                      "Healthcare Plan Application Form",
    WYNDHAM_STARTER_FORM:                           "Registo Inicial de Colaborador (Employee Starter Form)",
    KFC_WELCOME_LETTER:                             "Uniform Request Form",
    KFC_PENNIES_FOR_CHANGE:                         "Pennies for Change",
    KFC_EXPRESSION_OF_WISH:                         "Expression of Wish Form",
    ARTFARM_HEALTH_QUESTIONNAIRE:                   "Health and Wellbeing Questionnaire",
    AHH_MEDIA_CONSENT:                              "Media Consent",
    NORTHERN_MANAGEMENT_MEDICAL_LEAVE_NOTICE_WEST: "Paid Family and Medical Leave Notice (West)",
    NORTHERN_MANAGEMENT_MEDICAL_LEAVE_NOTICE_EAST: "Paid Family and Medical Leave Notice (East)",
    AHH_WORKING_TIME_REGULATIONS_OPT_OUT:           "Working Time Regulations Opt Out Agreement",
    WYNDHAM_MATERIALS_EQUIPMENT:                    "Entrega de Materiais e Equipamentos (Materials and Equipment)",
    ART_CLUB_DUBAI_IMMIGRATION_FORM:                "Immigration Information Form",
    RBM_MEAL_TIME_WAIVER:                           "Waiver of Mandatory Meal Period Time",
    JIMBBQ_FAMILY_FUND_PAYROLL_DEDUCTION_AUTHORIZATION:"BBQ Family Fund Payroll Deduction Authorization",
    FMI_PRIDE_FUND_ENROLLMENT:                       "PRIDE Fund Enrollment",
    JERSY_MIKES_WC_INFORMATION_FORM:                 "WC Information form",
    JERSY_MIKES_WC_NOTIFICATION_FORM:                "WC Employee Notification form",
    KFC_EEO_FORM:                                    "Equality and Diversity Monitoring Form",
    HUDSON_WOTC_TAX_CREDIT_QUESTIONNAIRE:            "WOTC Tax Credit Questionnaire",
    BRINDISA_HEALTH_QUESTIONNAIRE:                   "Employment Health Questionnaire",
    COYA_CONTRACT:                                  "Employment Contract",
    BASTION_EMPLOYEE_NOTICE_FAMILY_LEAVE:           "Employee Notice of Paid Family Leave",
    RADISSON_EMEA_LOW_PAID_QUESTIONNAIRE:           "Fragebogen für geringfügig entlohnte oder kurzfristig Beschäftigte",
    WAFELS_DINGES_WAIVER_COVERAGE:                  "Request for waiver of coverage",
    FRONT_BURNER_COMPENSATION_ACKNOWLEDGEMENT:      "Workers' Compensation Network Acknowledgement",
    HUDSON_NY_YOUTH_QUESTIONNAIRE:                   "NY Youth Questionnaire",
    ISLAND_POKE_CONTRACT:                           "Island Poke Contracts",
    HARBOUR_CONTRACT:                               "Employment Contract",
    FISHWORKS_CONTRACT:                             "Employment Contract",
    GENERATOR_GELON_CONTRACT:                       "Employment Contract",
    GENERATOR_GENHQ_CONTRACT:                       "Employment Contract",
    GBK_CENTRAL_CONTRACT:                           "Employment Contract",
    GBK_IR_RESTAURANT_CONTRACT:                     "Employment Contract",
    GBK_MANAGEMENT_CONTRACT:                        "Employment Contract",
    GBK_UK_RESTAURANT_CONTRACT:                     "Employment Contract",
    GRABTHAI_CONTRACT:                              "Employment Contract",
    WYNDHAM_MEDICAL_QUESTIONNAIRE:                  "Questionário Médico e Contatos de Emergência",
    WYNDHAM_DECLARATION:                            "Declaração Duodécimos",
    CW_MASTER_CONTRACT:                             "Employment Contract",
    CW_MASTER_WEEKLY_CONTRACT:                      "Employment Contract",
    CW_MASTER_MONTHLY_CONTRACT:                     "Employment Contract",
    CW_MANAGED_HOUSE_SALARIED_CONTRACT:             "Employment Contract",
    CW_MANAGED_HOUSE_HOURLY_CONTRACT:               "Employment Contract",
    CW_MANAGED_HOUSE_CONTRACT:                      "Employment Contract",
    CW_APOSTROPHE_GM_CONTRACT:                      "Employment Contract",
    CW_APOSTROPHE_CONTRACT:                         "Employment Contract",
    CW_PIZZA_POT_CONTRACT:                          "Employment Contract",
    CW_PIZZA_POT_GM_CONTRACT:                       "Employment Contract",
    FRONTIER_PUBS_CONTRACT:                         "Employment Contract",
    FISHWORKS_CHILDREN_CONTRACT:                    "Employment Contract",
    BREAKFAST_CLUB_CONTRACT:                        "Employment Contract",
    PETERSHAM_CONTRACT:                             "Employment Contract",
    PREZZO_RESTAURANT_TEAM_CONTRACT:                "Employment Contract",
    CSDK_COE_CONTRACT:                              "Employment Contract",
    DD_LONDON_CONTRACT:                             "Employment Contract",
    DD_HEAD_OFFICE_CONTRACT:                        "Employment Contract",
    PREZZO_SUPPORT_CENTER_CONTRACT:                 "Employment Contract",
    WYNDHAM_GRAND_CONTRACT:                         "Employment Contract",
    BREAKFAST_CLUB_CONTRACT_HOURLY:                 "Employment Contract",
    IVY_COLLECTION_HEAD_OFFICE_CONTRACT:            "The Ivy Collection Head Office Contract",
    COTE_RESTAURANT_MERGED_CONTRACT:                 "Employment Contract",
    COTE_RESTAURANT_CONTRACTS:                      "Employment Contract",
    LIMEYARD_CONTRACT:                              "Employment Contract",
    JACKSON_CONTRACT:                               "Employment Contract",
    QUBIC_MANAGEMENT_CONTRACT:                      "Employment Contract",
    COTE_HEALTH_QUESTIONNAIRE:                      "New Employee Health Questionnaire",
    CG_HEALTH_QUESTIONNAIRE:                        "Health Questionnaire",
    COMPASSIONATE_CARE_FULL_OB:                     "Full On-Boarding Document",
    BELFRY_NOMINATION_OF_BENEFICIARY:               "Nomination of Beneficiary Form",
    US_FEDERAL_FORM_1_A:                            "US Federal FORM 1-A",
    JEAN_GEORGES_HEALTH_INSURANCE_WAIVER:           "Health Insurance Waiver",
    GOLD_CONTRACT:                                  "Employment Contract",
    TENPIN_LIVE_ASSURANCE_FORM:                     "Life Assurance Form",
    STEAK_N_SHAKE_W2_FORM:                          "W2 Consent Form",
    STEAK_N_SHAKE_ASSOCIATE_EMERGENCY:              "Associate Emergency Foundation",
    JEAN_GEORGES_HEALTH_INSURANCE_WAIVER_DOUBLE:    "Health Insurance Waiver",
    IVY_COLLECTION_CONTRACT:                        "The Ivy Collection Contract",
    BOXPARK_CONTRACT:                               "Employment Contract",
    IVY_MARKET_GRILL_CONTRACT:                      "The Ivy Collection Contract",
    BKUK_UNIFORM_ORDER:                             "BKUK Uniform Order",
    JOLLIBEE_VACCINATION_FORM:                      "Self Attestation (Vaccination)",
    AZUMI_EQUALITY_DIVERSITY_FOOD_HANDLERS:         "Questionnaire of Equality and Diversity and Food Handlers Health",
    ART_CLUB_BENEFICIARY_NOMINATION:                "Beneficiary Nomination (Expression of Wish Form)",
    THE_IVY_NEW_HIRE:                               "New Hire Form",
    STANDARD_EU_STARTER_FORM:                       "Standard EU New Starter Form",
    JM_BIOMETRIC_DATA_POLICY_FORM:                  "Biometric Data Policy and Release",
    IVY_COLLECTION_BRASSERIE_CONTRACT:              "The Ivy Collection Contract",
    BRASSERIE_LIGHT_CONTRACT:                       "Brasserie of Light Contract",
    PARIS_BAGUETTE_WAGE_PAYMENT_FORM:               "Wage Payment Election and Consent Form",
    IVY_DUBLIN_CONTRACT:                            "The Ivy Collection Contract",
    LIVELYHOOD_CONTRACT:                            "Employment Contract",
    HARRYS_DOLCI_CONTRACT:                          "Harry's Contract",
    GRANARY_SQUARE_CONTRACT:                        "Granary Square Contract",
    CAPRICE_EMPLOYEE_WISHES_FORM:                   "Employee Wishes Form",
    CRAVEABLE_TRANSITCHECK:                         "TransitChek Enrollment Form",
    BURGER_KING_EXPRESSION_OF_WISH:                 "Expression of Wish",
    ARTS_CLUB_REVISED_OFFER:                        "Revised offer of employment",
    IVY_HEALTH_QUESTIONNAIRE:                       "Health Questionnaire",
    ARABICA_RETURN_TO_WORK_CORONA:                  "Return to Work Questionnaire - CORONAVIRUS SPECIFIC",
    BICOS_APPLICANT_STATEMENT:                      "Applicant’s Statement",
    FARMER_BOYS_MEAL_WAIVER_AGREEMENT:              "Meal Period Waiver Agreement",
    TRUMP_UK_UNIFORM_SIZE_SHEET:                    "Uniform Size Sheet",
    BLAKENEY_UNIFORM_SIZE:                          "Uniform Size Sheet",
    HARRYS_DOLCI_HEALTH_QUESTIONNAIRE:              "Harry's Dolci Health Questionnaire",
    GRANARY_SQUARE_HEALTH_QUESTIONNAIRE:            "Granary Square Questionnaire",
    EAST_COAST_HEALTH_QUESTIONNAIRE    :            "Health and Safety Questionnaire",
    LITTLE_GEMS_FOOD_HANDLERS_QUESTIONNAIRE:        "Food Handlers Questionnaire",
    ABC_BENEFIT_ELECTION_SWIPE_N_SAVE:              "Benefit Election Swipe-N-save",
    GUACHO_HEALTH_QUESTIONNAIRE:                    "Employee health assessment declaration",
    TATTU_COV19_VULNERABILITY_ASSESSMENT:           "COVID-19 Vulnerability Assessment",
    REV_419_EX_FORM:                                "REV - 419 EX Form - Employee Nonwitholding Application Certificate",
    MICHAEL_CAINES_HEALTH_QUESTIONNAIRE:            "Health Questionnaire",
    BOPARAN_HEALTH_QUESTIONNAIRE:                   "Health Questionnaire",
    PJ_ALL_DELIVERY_DRIVER_INFO:                    "ALL - Delivery Driver Information",
    ST_AUSTELL_HEALTH_QUESTIONNAIRE:                "Health Questionnaire",
    IVY_STORE_APPROVAL_FORM:                        "Store approval information form",
    CHARLES_EMPLOYEE_DETAILS_FORM:                  "New Employee Details Form",
    AT_STAFF_ACCEPTANCE_FORM:                        "Casual Staff Acceptance Form",
    CAPRICE_NOK_FORM:                               "NOK Form",
    GUACHO_COVID_HEALTH_QUESTIONNAIRE:              "COVID Health Check Questionnaire",
    MERAKI_STARTER_FORM:                            "Starter From",
    WORKS_INCOME_TAX:                               "Income Tax Instalment Payments",
    WAFELS_DINGES_MVR_RELEASE_FORM:                 "MVR Release Consent Form",
    GUACHO_TIME_OPT_OUT:                            "48 hours Opt Out Agreement",
    ISLAND_POKE_EMPLOYEE_STARTER_FORM:              "Employee Starter Form",
    IVY_SUIT_ORDER:                                 "Uniform order form",
    ROSSOBLU_NEW_HIRE_SHEET:                        "Employee Confidential Data",
    JEAN_GEORGES_HEALTH_INSURANCE:                  "Jean-Georges Management’s Health Insurance",
    MH_WORKING_HOURS_AGREEMENT:                     "Working Hours Opt Out Agreement",
    WORKERS_COMPENSATION_NOTICE_CA:                 "Worker’s Compensation Notice",
    TRUMP_UK_PHOTOGRAPHY_CONSENT:                   "Photography & Filming Consent",
    ROCKFISH_MEDICAL_QUESTIONNAIRE:                 "Medical Questionnaire",
    PAPA_JOHNS_MEDICAL_QUESTIONNAIRE:               "Medical Questionnaire",
    RITZ_LONDON_MEDICAL_QUESTIONNAIRE:              "Pre employment medical questionnaire",
    BELFRY_HEALTH_QUESTIONNAIRE:                    "The Belfry Health Questionnaire",
    JERSY_MIKE_EMPLOYEE_AUTHORIZATION:              "Employee Authorizations & Acknowledgement Documents - English",
    PJ_FL_DELIVERY_DRIVER_POLICIES:                 "ALL - Delivery Driver Policies and Procedures",
    PJ_DMD_DELIVERY_DRIVER_POLICIES:                "DMD - Delivery Driver Policies and Procedures",
    CHESTERFORD_MEDICAL_QUESTIONNAIRE:              "Medical Questionnaire",
    STREET_GUYS_COMMUTER_BENEFITS:                  "Commuter Benefits Enrollment",
    HERTFORD_STREET_MEDICAL_QUESTIONNAIRE:          "5HS Post offer pre-employment medical questionnaire",
    HERTFORD_STREET_PO_MEDICAL_QUESTIONNAIRE:       "Post offer pre-employment medical questionnaire",
    ROTI_KING_MENTAL_HEALTH:                        "Mental Health Questionnaire",
    THE_RESTAURANT_MEDICAL_QUESTIONNAIRE:           "Medical Questionnaire",
    ANDREW_BROWNSWORD_EMPLOYEE_DETAILS:             "Employee Details Form",
    ANDREW_BROWNSWORD_EMERGENCY:                    "Emergency Contact",
    ANDREW_BROWNSWORD_INFECTION:                    "Agreement to report infection",
    ANDREW_BROWNSWORD_NIGHT_WORKER:                 "Night Worker Questionnaire",
    AUBAINE_WORKING_TIME_REGULATIONS:               "Working Time Regulations",
    AUBAINE_MEDICAL_QUESTIONNAIRE:                  "Medical Questionnaire",
    AUBAINE_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE:     "Food Handlers Health Assessment Questionnaire",
    UPHAM_HEALTH_QUESTIONNAIRE:                     "Pre Employment Health Questionnaire",
    WILTONS_HEALTH_BOOKLET:                         "Wiltons Staff Health & Safety Induction booklet",
    FRANCO_HEALTH_BOOKLET:                          "Franco’s Staff Health & Safety Induction booklet",
    VIVA_CHICKEN_PHOTO_FORM:                        "Photo Release Policy",
    AUBAINE_EQUAL_OPPORTUNITIES_FORM:               "Equal Opportunities Monitoring Form",
    FRANKIE_BENNY_MONITORING_QUESTIONNAIRE:         "Monitoring Questionnaire",
    MIGUELS_PHOTO_FORM:                             "Photo Release Form",
    PIZZA_PILGIRMS_OPT_OUT:                         "48 hours Opt Out Agreement",
    BKUK_WORKING_TIME_OPT_OUT:                      "BKUK Working Time Opt Out Form",
    BRASSERIE_BAR_WORKING_TIME_REGULATION:          "Working time Regulation",
    DD_EEO:                                         "Equal Opportunity Data Form",
    AUBAINE_FOOD_HANDLERS_HYGIENE:                  "Food Handlers Essential Food Hygiene Health and Safety Induction",
    AUBAINE_UNIFORM_AGREEMENT:                      "Uniform Agreement",
    BISCUITEERS_STAFF_MEDICAL_SCREENING:            "Staff Medical Screening",
    MCD_CREW_UNIFORM_AGREEMENT:                     "Crew Uniform Agreement and Disbursement",
    RADISSON_EMEA_DISTANCE_TO_WORK:                 "Entfernungskilometer zwischen Wohnort und Tätigkeitsstätte für die Firmenfahrzeugversteuerung",
    CAPRICE_HEALTH_QUESTIONNAIRE:                   "Medical Questionnaire",
    ABC_HEALTH_BENEFITS_WAIVER_FORM:                "Health Benefits Waiver form",
    SUMMER_OPS_EMPLOYEE_NOTICE:                     "Employee Warning Notice",
    CAPRICE_CONTRACT:                               "Employment Contract",
    BURGERS_COCKTAILS_CONTRACT:                     "Employment Contract",
    BURGERS_COCKTAILS_CHILDREN_CONTRACT:            "Employment Contract",
    PIEMINISTER_CONTRACT:                           "Employment Contract",
    PIEMINISTER_ALL_CONTRACT:                       "Employment Contract",
    BACKGROUND_GROUP_CONTRACT:                      "Employment Contract",
    YOUNGS_CONTRACT:                                "Employment Contract",
    CDG_CONTRACT:                                   "Employment Contract",
    CDG_MANAGER_CONTRACT:                           "Employment Contract",
    CDG_TEAM_MEMBER_2_CONTRACT:                     "Employment Contract",
    EMILY_ESTATE_CONTRACT:                          "Employment Contract",
    ROCKFISH_CONTRACT:                              "Employment Contract",
    SEAHORSE_CONTRACT:                              "Employment Contract",
    ROCKFISH_CASUAL_CONTRACT:                       "Employment Contract",
    ROCKFISH_MANAGEMENT_CONTRACT:                   "Employment Contract",
    BEDS_BARS_CONTRACT:                             "Employment Contract",
    CRAFT_LOCALS_CONTRACT:                          "Employment Contract",
    RUM_KITCHEN_CONTRACT:                           "Employment Contract",
    ISLAND_POKE_NEW_CONTRACT:                       "Employment Contract",
    PING_PONG_CONTRACT:                             "Employment Contract",
    STICK_SUSHI_CHANGE_EMPLOYMENT_AFLOSER:          "Change of employment - Afløser",
    STICK_SUSHI_CHANGE_EMPLOYMENT_HOURS_SALARY:     "Change of employment - Hours/Salary",
    FAZENDA_HEAD_OFFICE_CONTRACT:                   "Employment Contract",
    FAZENDA_CONTRACT:                               "Employment Contract",
    PING_PONG_CHILDREN_CONTRACT:                    "Employment Contract",
    PLATFORM_CONTRACT:                              "Employment Contract",
    SAN_CARLO_CONTRACT:                             "Employment Contract",
    BREAKFAST_CLUB_LETTER_CONTRACT:                 "Employment Contract",
    BREAKFAST_CLUB_NEW_CONTRACT:                    "Employment Contract",
    MARRIOTT_CONTRACT:                              "Employment Contract",
    UPHAM_CONTRACT:                                 "Employment Contracts",
    MERCER_STREET_HANDBOOK:                         "Staff Handbook Receipt",
    JEAN_GEORGES_HANDBOOK:                          "Handbook Acknowledgment of Receipt & Agreement",
    WRIGHT_BROTHERS_CONTRACT:                       "Employment Contract",
    THE_NEWT_CONTRACT:                              "Employment Contracts",
    HAWKSMOOR_CONTRACT:                             "Employment Contract",
    BERKELEY_INNS_CONTRACT:                         "Employment Contracts",
    HAWKSMOOR_EDINBURGH_CONTRACT:                   "Employment Contract",
    HALAL_GUYS_CONTRACT:                            "Employment Contract",
    ARABICA_BOROUGH_CONTRACT:                       "Employment Contract",
    WINGSTOP_CONTRACT:                              "Employment Contract",
    ARABICA_FOOD_SPICE_CONTRACT:                    "Employment Contract",
    ARABICA_FOOD_LIMTED_CONTRACT:                   "Employment Contract",
    ARABICA_KX_CONTRACT:                            "Employment Contract",
    ENOTECA_DA_LUCA_CONTRACT:                       "Employment Contract",
    LOCKETS_CONTRACT:                               "Employment Contract",
    ETM_BOTANIST_CONTRACT:                          "Employment Contract",
    LANSDOWNE_CONTRACT:                             "Employment Contract",
    KBK_CONTRACT:                                   "Employment Contract",
    SMF_CONTRACT:                                   "Employment Contract",
    ACADEMY_HS_INDUCTION_PACK_RARE:                 "Academy H&S induction pack rare",
    JERSY_MIKE_DIRECT_DEPOSIT:                      "Direct Deposit Enrollment, Change and Cancellation",
    M_RESTAURANTS_HS_INDUCTION_PACK_HOURLY:         "H&S induction pack hourly team M Restaurants",
    GAUCHO_HS_INDUCTION_PACK_HOURLY:                "H&S induction pack hourly team Gaucho",
    GOOD_FAITH_ESTIMATE_SCHEDULE_EXPRESS:           "Express - Good Faith Estimate of Schedule Form",
    GOOD_FAITH_ESTIMATE_SCHEDULE_OREGON:            "Oregon - Good Faith Estimate of Schedule Form",
    GOOD_FAITH_ESTIMATE_SCHEDULE_CHICAGO:           "Chicago - Good Faith Estimate of Schedule Form",
    GOOD_FAITH_ESTIMATE_SCHEDULE_SAN_FRANCISCO:     "San Francisco - Good Faith Estimate of Schedule Form",
    GOOD_FAITH_ESTIMATE_SCHEDULE_LITE:              "NYC - Regular Schedule Form",
    GOOD_FAITH_ESTIMATE_SCHEDULE_PHILADELPHIA:      "Philadelphia - Good Faith Estimate of Schedule Form",
    GOOD_FAITH_ESTIMATE_SCHEDULE_SEATTLE:           "Seattle - Good Faith Estimate of Schedule Form",
    GOOD_FAITH_ESTIMATE_SCHEDULE_EMERYVILLE:        "Emeryville - Good Faith Estimate of Schedule Form",
    GOOD_FAITH_ESTIMATE_SCHEDULE_LOS_ANGELES:       "Los Angeles - Good Faith Estimate of Schedule Form",
    GOOD_FAITH_ESTIMATE_SCHEDULE_BERKELEY:          "Berkeley - Good Faith Estimate of Schedule Form",
    GOOD_FAITH_ESTIMATE_SCHEDULE_EVANSTON:          "Evanston - Good Faith Estimate of Schedule Form",
    VILLAGE_HOTELS_EXPRESSION_OF_WISHES:            "Expression of Wishes",
    ROYAL_LANCASTER_EXPRESSIONS_OF_WISHES:          "Expression of Wishes",
    QBIC_CONTRACT:                                  "Employment Contract",
    VAGABOND_HQ_CONTRACT:                           "Employment Contract",
    VAGABOND_CONTRACT:                              "Employment Contract",
    RED_CAT_CONTRACT:                               "Employment Contract",
    ART_CLUB_DUBAI_LETTER_OF_INTENT:                "Letter of Intent",
    EGGSLUT_CONTRACT:                               "Employment Contract",
    SEV_CONTRACT:                                   "Employment Contract",
    TAMATANGA_CONTRACT:                             "Employment Contract",
    BOSTON_TEA_CONTRACT:                            "Employment Contracts",
    NZR_GROUP_CONTRACT:                             "Employment Contract",
    NOTICE_OF_TERMINATION_JUST_CAUSE:               "Fast Food Employers-Notice Of Termination For Just Cause",
    YARDBIRD_TERMINATION_CHECKLIST:                 "Termination Checklist and Notice of Change in Status",
    SEPARATION_NOTICE_GA:                           "Separation Notice",
    WULF_LAMB_CONTRACT_AMENDMENT:                   "Amendment to contract letter",
    WULF_LAMB_CONTRACT:                             "Employment Contract",
    BLAKENEY_HOTEL_CONTRACT:                        "Employment Contract",
    BERBERE_ITALY_CONTRACT:                         "Employment Contracts",
    KOH_THAI_CONTRACT:                              "Employment Contracts",
    PARK_INN_NORTHAMPTON_CONTRACT:                  "Employment Contracts",
    PAPA_JOHNS_QCC_CONTRACT:                        "Employment Contracts",
    PAPA_JOHNS_CONTRACT:                            "Employment Contracts",
    EAT_PITTA_CONTRACT:                             "Employment Contract",
    SEFTON_CONTRACT:                                "Employment Contract",
    NOBLE_INNS_CONTRACT:                            "Employment Contract",
    NOBLE_INNS_TRONC_LETTER:                        "Tronc Letter",
    GRIND_TRONC_LETTER:                             "Tronc Letter",
    LANGAN_CHUCS_TRONC_LETTER:                      "Tronc Letter",
    ARTFARM_CONTRACT:                               "Employment Contract",
    SCARPETTA_CONTRACT:                             "Employment Contract",
    IBERICA_CONTRACT:                               "Employment Contract",
    LIBERATION_UK_CONTRACT:                         "Employment Contracts",
    LIBERATION_ZERO_HOUR_CONTRACT:                  "Employment Contract",
    LIBERATION_GROUP_UK_CONTRACT:                   "Employment Contract",
    LIBERATION_GROUP_JERSEY_CONTRACT:               "Employment Contract",
    LIBERATION_GROUP_GUERNSEY_CONTRACT:             "Employment Contract",
    ARCHIES_CONTRACT:                               "Employment Contract",
    NOTICE_OF_HOURS_REDUCTION_JUST_CAUSE:           "Fast Food Employers-Notice Of Hours Reduction For Just Cause",
    LIBERATION_CONTRACT:                            "Employment Contract",
    WELLS_CO_ACCOMMODATION_AGREEMENT:               "Accommodation Agreement",
    LIBERATION_JERSEY_CONTRACT:                     "Employment Contracts",
    LIBERATION_GUERNSEY_CONTRACT:                   "Employment Contracts",
    COTE_TEAM_MEMBER_CONTRACTS:                     "Employment Contracts",
    GENERATOR_SWEDEN_CONTRACT:                     "Employment Contract",
    COTE_AGM_CONTRACTS:                             "Employment Contracts",
    FARM_GIRL_CONTRACT:                             "Contract of Employment",
    GENERATOR_ITALY_CONTRACT:                       "Employment Contract",
    OVER_UNDER_COFFEE_CONTRACT:                     "Employment contract",
    HALL_WOODHOUSE_CONTRACT:                        "Employment contract",
    SISBAN_UK_CONTRACT:                             "Employment contract",
    URBAN_FRESH_BURGERS_CONTRACT:                   "Employment contract",
    COACHING_INN_CONTRACT:                          "Employment contract",
    COACHING_INN_CO_CONTRACT:                          "Employment contract",
    ANNABELS_CONTRACT:                              "Employment contract",
    BIG_EASY_CONTRACT:                              "Employment contract",
    BRUNCHCO_UK_CONTRACT:                           "Employment contract",
    HARRYS_BAR_CONTRACT:                            "Employment contract",
    MARKS_CLUB_CONTRACT:                            "Employment contract",
    BATH_RACQUETS_CONTRACT:                         "Employment contract",
    BIRLEY_HO_CONTRACT:                             "Employment contract",
    YARD_SALE_CONTRACT:                             "Employment contract",
    DISCOVERY_ADVENTURE_CONTRACT:                   "Employment Contract",
    BART_TAYLOR_CONTRACT:                           "Employment contract",
    ARCHIES_HO_CONTRACT:                            "Employment contract",
    NOTICE_OF_LAYOFF_ECONOMIC_REASON:               "Fast Food Employers-Notice Of Layoff For Economic Reasons",
    KNOOPS_CONTRACT:                                "Employment Contracts",
    JULIENNE_BRUNO_CONTRACT:                        "Contract of Employment (2021)",
    PLANT_HUSTLER_CONTRACT:                         "Employment Contract",
    CHESTERFORD_JOY_BRAND_CONTRACT:                 "Employment Contract",
    BVLGARI_HOTEL_LONDON_CONTRACT:                  "Employment Contract",
    BOCCA_DI_LUPO_CONTRACT:                         "Employment Contract",
    AHH_CONTRACT:                                   "Employment Contract",
    AZUMI_CONTRACT:                                 "Employment Contract",
    WESTBEACH_CONTRACT:                             "Employment Contract",
    BIMS_CONTRACT:                                  "Employment Contract",
    BUBALA_CONTRACT:                                "Employment Contract",
    XP_FACTORY_CONTRACT:                            "Employment Contract",
    HERTFORD_5_STREET_CONTRACT:                     "Employment Contract",
    GASTRONOMY_CONTRACT:                            "Employment Contract",
    BEEFY_BOYS_CONTRACT:                            "Employment Contract",
    BOPARAN_STARTER_WELCOME_VOUCHER:                "New Starter Welcome Voucher",
    BLOOMSBURY_CONTRACT:                            "Employment Contract",
    SUPERMARKET_OF_DREAMS_CONTRACT:                 "Employment Contract",
    FULLER_SMITH_TURNER_CONTRACT:                   "Employment Contract",
    YOTEL_UK_CONTRACT:                              "Employment Contract",
    YOTEL_NETHERLANDS_CONTRACT:                     "Employment Contract",
    COTSWOLD_FARM_CONTRACT:                         "Employment Contract",
    WINGMANS_CONTRACT:                              "Employment Contract",
    TATTU_CONTRACT:                                 "Employment Contract",
    KITCHEN_VENTURES_RESTRICTIVE_COVENANT:          "Restrictive Covenant Agreement",
    KITCHEN_VENTURES_CONTRACT:                      "Employment contract",
    SWINGERS_CRAZY_GOLF_NDIAA:                      "NDIAA (Non Disclosure Agreement)",
    BONE_DADDIES_CONTRACT:                          "Employment Contract",
    BONE_DADDIES_TRONC_LETTER:                      "TRONC Letter",
    TAPATAPA_CONTACT:                               "Employment Contract",
    BODMIN_JAIL_HOTEL_CONTRACT:                     "Employment contract",
    KERB_CONTRACT:                                  "Employment contract",
    EAST_LONDON_PUB_CONTRACT:                       "Employment Contract",
    BIRLEY_CLUBS_OFFER_LETTER:                      "Offer Letter",
    TATTU_AGE_VERIFICATION_POLICY:                  "Age Verification Policy Staff Declaration",
    BOO_CONTRACT:                                   "Employment Contract",
    NURST_UK_CONTRACT:                              "Employment Contract",
    PAPA_JOHNS_NEW_FEDERAL_REG_TIPPED:              "New Federal Regulations for Tipped Employees",
    QFM_CONTRACT:                                   "Employment Contract",
    RITZ_LONDON_CONTRACT:                           "Employment Contracts",
    ZOOM1HR_CONTRACT:                               "Employment Contracts",
    CARLUCCIOS_DAWSON_CONTRACT:                     "Employment Contracts",
    CROCUS_CONTRACT:                                "Employment Contract",
    NICI_HOTELS_CONTRACT:                           "Employment Contract",
    CROCUS_MANAGEMENT_CONTRACT:                     "Employment Contract",
    DARJEELING_CONTRACT:                            "Employment Contracts",
    EPOCH_GROUP_CONTRACT:                           "Employment Contracts",
    NOTICE_OF_HOURS_REDUCTION_ECONOMIC_REASON:      "Fast Food Employers-Notice Of Hours Reduction For Economic Reasons",
    PAN_PACIFIC_CONTRACT:                           "Employment Contracts",
    POPEYES_CONTRACT:                               "Employment Contract",
    PALL_MALL_67_CONTRACT:                          "Employment Contract",
    DONER_SUMMER_CONTRACT:                          "Employment Contract",
    BT_CONTRACT:                                    "Employment Contract",
    BTG_CONTRACT:                                   "Employment Contract",
    NNA_CONTRACT:                                   "Employment Contracts",
    CHIKN_CONTRACT:                                  "Employment Contract",
    EPOCH_GROUP_HO_CONTRACT:                        "Employment Contracts",
    ROMET_GROUP_CONTRACT:                           "Employment Contracts",
    HAUS_HOLDNIG_CONTRACT:                          "Employment Contracts",
    HAUS_HOLDNIG_N_CONTRACT:                          "Employment Contracts",
    BAKER_HOSPITALITY_CHURCH_STREET_CONTRACT:       "Employment Contract",
    BAKER_HOSPITALITY_THE_SUN_CONTRACT:             "Employment Contract",
    BARACK_HOLDINGS_CONTRACT:                       "Employment Contract",
    COTE_GREENFIELDS_CONTRACT:                      "Employment Contract",
    FIRMDALE_CONTRACT:                              "Employment Contract",
    RAREBIRDS_CONTRACT:                             "Employment Contract",
    COTE_SO_CONTRACT:                               "Employment Contract",
    COTE_RESTAURANTS_CONTRACT:                      "Employment Contract",
    BISTROTHEQUE_PROPERTY_ISSUE_FORM:               "Property Issue",
    ARCHIES_STAFF_EQUIPMENTS_CHECKLIST:             "Staff Equipment Distribution Checklist",
    THE_GOOD_EGG_CONTRACT:                          "Employment Contract",
    ALLBRIGHT_OPERATION_CONTRACT:                   "Employment Contract",
    ALLBRIGHT_CENTRAL_CONTRACT:                     "Employment Contract",
    EDIN_HOTELS_CONTRACT:                           "Employment Contract",
    PIANO_WORKS_CONTRACT:                           "Employment Contract",
    MARTHA_CONTRACT:                                "Employment Contract",
    HARTS_CONTRACT:                                 "Employment Contract",
    HARTS_CHILDREN_CONTRACT:                        "Employment Contract",
    OLE_STEEN_CONTRACT:                             "Employment Contract",
    JERSY_MIKE_NEW_HIRE:                            "Employee Enrollment Documents (New Hire) - English",
    KRICKET_CONTRACT:                               "Employment Contract",
    BISCUITEERS_HEALTH_QUESTIONNAIRE:               "Initial Health Questionnaire Flour Dust",
    SEPARATION_NOTICE_TN:                           "Tennessee Separation Notice",
    SEPARATION_NOTICE_NJ:                           "Instructions for Claiming Unemployment Benefits",
    BLACKLOCK_CONTRACT:                             "Employment Contract",
    FLOR_CONTRACT:                                  "Employment Contract",
    CARLUCCIOS_CONTRACT:                            "Employment Contract",
    BIRD_CONTRACT:                                  "Employment Contract",
    DD_DISCLOSURE_CIVIL_DECLARATION:                "Disclosure of convictions and civil penalties declaration form",
    AT_HEALTH_QUESTIONNAIRE :                       "Pre Placement Health Questionnaire",
    CDG_SALARIED_CONTRACT:                          "Employment Contract",
    CDG_TEAM_MEMBER_CONTRACT:                       "Employment Contract",
    CDG_CONCESSIONS_CONTRACT:                       "Employment Contract",
    CDG_CONCESSIONS_MANAGEMENT_CONTRACT:            "Employment Contract",
    CDG_CONCESSIONS_TEAM_MEMBER_CONTRACT:           "Employment Contract",
    BLACK_SHEEP_CONTRACT:                           "Employment Contract",
    LKN_MARKETS_CONTRACT:                           "Employment Contract",
    BLACK_SHEEP_CHILDREN_CONTRACT:                  "Employment Contract",
    KANADA_YA_CONTRACT:                             "Employment Contract",
    COAL_KITCHEN_CONTRACT:                          "Employment Contract",
    HOME_HOUSE_CONTRACT:                            "Employment Contract",
    HOME_HOUSE_HG_CONTRACT:                         "Employment Contract",
    MARKET_HALL_CONTRACT:                           "Employment Contract",
    GENERATOR_IRELAND_CONTRACT:                      "Employment Contract",
    TRISHNA_TRONC_LETTER:                           "Tronc letter",
    HUMBLE_GRAPE_SALARIED_CONTRACT:                 "Salaried Contract",
    HUMBLE_GRAPE_HOURLY_CONTRACT:                   "Hourly Contract",
    BISTROTHEQUE_CONTRACT:                          "Employment Contract",
    IVY_COLLECTION_CONTRACT_SALARIED:               "The Ivy Collection Salaried Contract",
    IVY_COLLECTION_BRASSERIE_CONTRACT_SALARIED:     "The Ivy Collection Salaried Contract",
    BRASSERIE_LIGHT_CONTRACT_SALARIED:              "Brasserie of Light Salaried Contract",
    IVY_COLLECTION_GM_SALARIED_CONTRACT:            "The Ivy Collection General Manager/Head Chef Contract",
    IVY_COLLECTION_GM_SALARIED_2_CONTRACT:          "The Ivy Collection General Manager/Head Chef Contract",
    IVY_COLLECTION_BRASSERIE_GM_SALARIED_CONTRACT:  "The Ivy Collection General Manager/Head Chef Contract",
    BARTLETT_MITCHELL_CONTRACT:                     "Employment Contract",
    M_RESTAURANT_TRONC_LETTER:                      "Tronc letter",
    KRICKET_TRONC_INVITE:                            "Tronc Invite Template",
    BRASSERIE_LIGHT_GM_SALARIED_CONTRACT:           "Brasserie of Light General Manager/Head Chef Contract",
    HARRYS_DOLCI_GM_SALARIED_CONTRACT:              "Harry's General Manager/Head Chef Contract",
    GRANARY_SQUARE_GM_SALARIED_CONTRACT:            "Granary Square GM/Head Chef Contract",
    JAMES_HEALTH_ASSESSMENT:                        "New Starter and Annual Health assessment Declaration",
    WAHACA_HEALTH_QUESTIONNAIRE:                    "Wahaca Health Form",
    WAHACA_CONTRACT:                                "Written particulars of terms of employment",
    STATE_W_RI:                                     "Rhode Island State Withholding Form",
    WORKING_HOURS_OPTION_FORM:                      "Working Hours Option Form",
    BLAKENEY_WORKING_HOURS_OPTION:                  "Working Hours Option Form",
    CRIMINAL_RECORD_FORM:                           "Criminal Record Declaration",
    EXPRESSION_OF_WISH:                             "Expression of Wish Form",
    HOME_HOUSE_HEALTH_ASSESMENT:                    "Night Worker Health Assessment",
    REZIDOR_EMERGENCY_CONTACT:                      "Emergency Contact form",
    TRUMP_UK_EQUAL_OPPORTUNITY:                     "Equal Opportunity",
    JKS_REGULAR_ALL_CONTRACT:                       "Regular Contract",
    JKS_FOH_KT_CONTRACT:                            "FOH Contract",
    JKS_ZERO_ALL_CONTRACT:                          "Zero Contract",
    JKS_SALARIED_ALL_CONTRACT:                      "Salaried Contract",
    JKS_HOURLY_ALL_CONTRACT:                        "Hourly Contract",
    JKS_ZERO_LYLES_CONTRACT:                        "Zero Contract",
    JKS_REGULAR_LYLES_CONTRACT:                     "Regular Contract",
    JKS_MANAGEMENT_BAO_CONTRACT:                    "Management Contract",
    JKS_MANAGEMENT_B_KT_CONTRACT:                   "Management Contract",
    JKS_MANAGEMENT_CONTRACT:                        "Management Contract",
    JKS_MANAGEMENT_XU_CONTRACT:                     "Management Contract",
    JKS_MANAGEMENT_LYLES_CONTRACT:                  "Management Contract",
    BRUTTO_CONTRACT:                                "Employment Contract",
    DRAKE_MORGAN_HOURLY_CONTRACT:                   "Hourly Contract",
    DRAKE_MORGAN_FIXED_TERM_CONTRACT:               "Hourly Fixed Term Contract",
    DRAKE_MORGAN_SALARIED_CONTRACT:                 "Salaried Contract",
    GYMBOX_CONTRACT:                                "Employment Contracts",
    WYBOSTON_LAKES_TEAM_MEMBER_CONTRACT:            "Team Member Contract",
    MB_RETAIL_STAFF_AGREEMENT:                      "Retail Staff Individual Agreement",
    PITA_MEAL_TIME_WAIVER:                          "Agreement To Waive Meal Period",
    MB_MEDICAL_QUESTIONNAIRE:                       "Employee Medical Questionnaire",
    TIME_OF_HIRE_PAMPHLET_CA:                       "Time Of Hire Notice",
    EDS_MANAGEMENT_CONTRACT:                        "Employment Contract",
    GIRAFFE_STOP_CONTRACT:                          "Employment Contract",
    GIRAFFE_STOP_HOURLY_CONTRACT:                   "Employment Contract",
    EDS_HOURLY_CONTRACT:                            "Employment Contract",
    GIRAFFE_CONTRACT:                               "Employment Contract",
    JP_RESTAURANTS_CONTRACT:                        "Employment Contract",
    GIRAFFE_CHILDREN_CONTRACT:                      "Employment Contract",
    GC_MALLEN_CONTRACT:                             "Employment Contract",
    M_RESTAURANT_CONTRACT:                          "Employment Contract",
    SOURCED_MARKET_CONTRACT:                        "Employment Contract",
    CUBITT_HOUSE_CONTRACT:                          "Employment Contract - Salaried",
    CUBITT_HOUSE_HOURLY_CONTRACT:                   "Employment Contract - Hourly",
    INAMO_KEY_FOB_RESPONSIBILITY_FORM:              "Key Fob Responsibility Form",
    CHARLES_WTR_FORM:                               "Opt Out agreement",
    CHARLES_LIFE_ASSURANCE_BENEFICIARY_FORM:        "Life Assurance Beneficiary Nomination",
    CHARLES_STARTERS_FORM:                          "New Starters Form",
    COPPA_CLUB_CONTRACT:                            "Employment Contract",
    COPPA_CLUB_CHILDREN_CONTRACT:                   "Employment Contract",
    CG_WORKING_TIME_REGULATION:                     "Working Time regulation",
    EAST_COAST_CONTRACT:                            "Employment Contract",
    KITOPI_CONTRACT:                                "Employment Contract",
    MELROSE_MORGAN_CONTRACT:                        "Employment Contract",
    MEGANS_CONTRACT:                                "Employment Contract",
    SENOR_CEVICHE_CONTRACT:                         "Employment Contract",
    KOREAN_DINNER_PARTY_CONTRACT:                   "Employment Contract",
    MERCATO_METROPOLITANO_CONTRACT:                 "Employment Contract",
    HQ_THEATER_CONTRACT:                            "Employment Contract",
    MERCATO_METROPOLITANO_N_CONTRACT:               "Employment Contract",
    MEGANS_CHILD_CONTRACT:                          "Employment Contract",
    COMPASSIONATE_CARE_COMMUNITY_CONTRACT:          "Employment Contract",
    COMPASSIONATE_CARE_SUPPORT_CONTRACT:            "Employment Contract",
    COMPASSIONATE_CARE_HO_CONTRACT:                 "Employment Contract",
    BARONS_EDEN_CONTRACT:                           "Employment Contract",
    FARMER_J_CONTRACT:                              "Employment Contract",
    GRINDCO_SUPPORT_CONTRACT:                       "Employment Contract",
    GRINDCO_CONTRACT:                               "Employment Contract",
    HERTFORD_STREET_CONTRACT:                       "Employment Contract",
    THE_WAVE_CONTRACT:                              "Employment Contract",
    BRINDISA_CONTRACT:                              "Employment Contract",
    BRINDISA_GM_CONTRACT:                           "Employment Contract",
    BRINDISA_HO_CONTRACT:                           "Employment Contract",
    STICK_SUSHI_DE_CONTRACT:                        "Employment Contract",
    STICK_SUSHI_FLEX_CONTRACT:                      "Employment Contract",
    STICK_SUSHI_MANAGEMENT_CONTRACT:                "Employment Contract",
    KFC_DEMIPOWER_CONTRACT:                         "Employment Contract",
    KFC_DEMIPOWER_HO_CONTRACT:                      "Employment Contract",
    KFC_DEMIPOWER_HOURLY_CONTRACT:                  "Employment Contract",
    RICHMOND_HILL_CONTRACT:                         "Employment Contract",
    THE_IVY_MANAGEMENT_CONTRACT:                    "Employment Contract",
    THE_IVY_TEAM_MEMBER_CONTRACT:                   "Employment Contract",
    CAPRICE_MANAGEMENT_CONTRACT:                    "Employment Contract",
    CAPRICE_TEAM_MEMBER_CONTRACT:                   "Employment Contract",
    BALTHAZAR_MANAGEMENT_CONTRACT:                  "Employment Contract",
    DUNKIN_NMG_MA_DATA_PROTECTION_TRAINING:          "MA Data Protection Training (Mgmt)",
    B_TOGETHER_CONTRACT:                            "Employment Contract",
    GENERATOR_FRANCE_CONTRACT:                       "Employment Contract",
    BALTHAZAR_TEAM_MEMBER_CONTRACT:                 "Employment Contract",
    WENDY_CONTRACT:                                  "Employment Contract",
    KFC_RSC_CONTRACT:                               "RSC Contract",
    VECTOR_CONTRACT:                                "Employment Contract",
    CHEESE_BAR_CONTRACT:                            "Employment Contract",
    PROPER_EMPLOYMENT_APPLICATION:                  "Employment Application",
    LDV_EMPLOYMENT_APPLICATION:                     "Employment Application",
    PROPER_REFERENCE_AUTHORIZATION:                 "Professional Reference Authorization Form",
    SNOOZE_GETTING_TO_KNOW_YOU:                     "Getting to know you",
    SNOOZE_DIRECT_DEPOSIT:                          "Living That DIRECT DEPOSIT Life",
    DOS_TOROS_DISPUTE_AGREEMENT:                    "Dos Toros- Dispute Agreement",
    CHOPT_DISPUTE_AGREEMENT:                        "CHOPT- Dispute Agreement",
    HONEST_BURGER_BANK_ACCOUNT_NI_FORM:             "Bank account and NI proof",
    HUMBLE_GRAPE_ONBOARDING_QA:                     "Onboarding Q&A",
    COPPA_CLUB_PENSION_LETTER:                      "Pension letter",
    CC_COV19_VACCINE_QUESTIONNAIRE:                 "Confidential COVID-19 Vaccination Questionnaire",
    COVID_VACCINATION_QUESTIONNAIRE:                "COVID-19 Vaccination Questionnaire",
    JG_COV19_VACCINE_QUESTIONNAIRE:                 "Confidential COVID-19 Vaccination Questionnaire",
    ABC_EMPLOYEE_HEALTH_PLAN:                       "ABC Employee Benefit Health Plan",
    GOTHAM_BENEFIT_INFORMATION:                     "Employee Benefit Health Plan",
    GOTHAM_BENEFIT_INFORMATION_DOUBLE:              "Employee Benefit Health Plan",
    MFG_FAMILY_MEAL_ELECTION:                       "Family meal election/waiver form",
    WOLFGANG_PUCK_TIP_AGREEMENT:                    "Tipped Employee Participation Agreement",
    MERAKI_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE:      "Food Handler’s Health assessment questionnaire",
    MICHAEL_CAINS_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE:"Food Handler Questionnaire",
    MICHIGAN_TAX_WITHHOLDING:                        "Michigan Employee's tax withholding form",
    HAWKSMOOR_LIFE_ASSURANCE_FORM:                   "Life Assurance Form",
    PAPA_JOHNS_ENROLLMENT_FORM:                     "Employee Enrollment Form",
    MARKET_HALL_MENTAL_HEALTH:                      "Mental Health Questionnaire",
    DAVE_CONFIDENTIALITY_AGREEMENT:                  "Confidentiality and Inventions Agreement",
    PIZZA_HUT_DRIVER_HEALTH_QUESTIONNAIRE:          "Driver Health Assessment Questionnaire",
    HALL_WOODHOUSE_VISITOR_CENTER_MY_REWARDS:       "Visitor Centre Only - My Rewards Form",
    HALL_WOODHOUSE_SALARIED_MY_REWARDS:             "Salaried Team only - My Rewards Form",
    VILLAGE_HOTELS_CRIMINAL_REFERENCE:              "Criminal Reference Form",
    PITA_VOLUNTARY_ARBITRATION_AGREEMENT:            "Voluntary Arbitration Agreement",
    RECEIPT_ACK_EMPLOYEE_HANDBOOK:                  "Receipt and Acknowledgement of Employee Handbook",
    NORTHERN_MANAGEMENT_EMPLOYEE_HANDBOOK_POLICY_ACK: "Employee Handbook Policy Acknowledgement",
    FMI_CA_DISPUTE_RESOLUTION:                      "CA Dispute Resolution Program and Arbitration Opt-Out",
    SF_CITY_OPTION_FORM:                            "San Francisco City Option Enrollment",
    DONER_SUMMER_HEALTH_DECLARATION:                "New Employee Registration Form - Health Declaration",
    DAVE_PERSONAL_ACTION_FORM:                      "Personal Action Form (PAF)",
    MCD_PROGRESSIVE_DISCIPLINARY_ACTION_FORM:       "Progressive Disciplinary Action Form",
    PREZZO_LIFE_BENEFICIARY_FORM:                   "Group Life Beneficiary Form",
    LIBERATION_GROUP_STARTER_FORM:                  "New Starter Monthly Payroll Information",
    NJ_COMMUTER_BENEFITS_PARTICIPATION_FORM:         "Commuter Benefits Participation Form",
    BPA_BIOMETRIC_DATA_POLICY:                       "BPA Biometric Data Policy and Release",
    YELLOWSTONE_PROPERTY_DRIVING_AGREEMENT:         "Property Driving Agreement",
    ART_CLUB_DUBAI_PRE_EMPLOYMENT_MEDICAL_FORM:     "Pre-Employment Medical Information Form",
    LACOSTE_ARBITRATION_AGREEMENT:                  "Lacoste Arbitration Agreement",
    WENDY_EXPRESSION_OF_WISH:                       "Expression of Wish Form",
    RADISSON_DENMARK_PERSONAL_DETAILS:              "Nordics - Personal Details - DENMARK",
    RADISSON_SWEDEN_PERSONAL_DETAILS:               "Nordics - Personal Details - SWEDEN",
    NORTH_COUNTRY_PIZZA_DRIVER_AGREEMENT:           "Vehicle Information and Driver Agreement",
    MARKS_CLUB_OFFER_LETTER:                        "Mark's Club - Offer Letter",
    RADISSON_NORWAY_PERSONAL_DETAILS:               "Nordics - Personal Details - NORWAY",
    PIZZA_HUT_RSC_CONTRACT:                         "RSC Contract",
    RADISSON_BRUSSEL_PERSONAL_DETAILS:              "RHG Starter Form - Brussels",
    RADISSON_MADRID_PERSONAL_DETAILS:               "RHG Starter Form - Madrid",
    RADISSON_SPAIN_PERSONAL_DETAILS:                "WE Spain Employee Personal Details",
    RADISSON_BELGIUM_PERSONAL_DETAILS:              "WE Belgium Employee Personal Details NL and FR",
    AT_PERSONAL_DETAILS_FORM:                       "Personal Details Form",
    YELLOWSTONE_SKI_PASS_AGREEMENT:                 "Ski Pass Agreement",
    PIZZA_HUT_HEALTH_QUESTIONNAIRE:                 "Health Assessment Questionnaire",
    PIZZA_HUT_PENSION_PLAN:                         "Pizza Hut Pension Plan",
    PIZZA_HUT_CONTRACT:                              "Employment contract",
    SF_HEALTH_CARE_WAIVER_FORM:                     "SF Health Care Waiver Form",
    TOG_MEAL_WAIVER_FORM:                           "Meal and rest break acknowledgement and meal waiver for STK Bellevue",
    SLIM_CHICKENS_CONTRACT:                         "Employment Contract",
    BLEECKER_BURGER_CONTRACT:                       "Employment Contract",
    MUSTARD_CATERING_CONTRACT:                      "Employment Contract",
    SLIM_CHICKENS_HOURLY_CONTRACT:                  "Employment Contract",
    LUXURY_FAMILY_HOTELS_CONTRACT:                  "Employment Contract",
    THE_BELFRY_CONTRACT:                            "Employment Contract",
    ST_JAMES_CONTRACT:                              "Employment Contract",
    MICHAEL_CAINES_CONTRACT:                        "Employment Contract",
    PAPA_JOHNS_GB_CONTRACT:                         "Employment Contracts",
    ST_JAMES_SJH_CONTRACT:                          "Employment Contract",
    SAMBA_GARDEN_CONTRACT:                          "Offer & Contract",
    SAMBA_LONDON_CONTRACT:                          "Offer & Contract",
    SAMBA_CRIMINAL_CONVICTION:                      "Criminal Conviction",
    FARMER_BOYS_CHANGE_RELATIONSHIP:                "Change in Relationship Form",
    UNEMPLOYMENT_ELIGIBILITY_NY:                     "New York State Unemployment Eligibility",
    SAMBA_HEALTH_QUESTIONNAIRE:                     "Health Check Questionnaire",
    SAMBA_REFERENCE_FORM:                           "References Contact Details",
    ST_AUSTELL_BREWERY_CONTRACT:                    "Employment Contracts",
    SAMBA_TRONC_LETTER:                             "Tronc Letter and Rules",
    ORANGE_TRONC_LETTER:                            "Tronc Letter and Rules - SS, SSCG and DW HOURLY",
    INCIPIO_CONTRACT:                               "Employment Contract",
    ICF_WORK_OPPORTUNITY_TAX_CREDIT:                "Form 9061",
    STICK_SUSHI_OFFBOARDING_FISH:                   "OffBoarding of a Fish",
    FUGGLES_CONTRACT:                               "Employment Contract",
    BADIANI_1932_CONTRACT:                          "Employment Contract",
    WYNDHAM_PAUSE_LAUNCH:                           "Autorização Pausa Almoço",
    HARRYS_BAR_OFFER_LETTER:                        "Harry's Bar - Offer Letter",
    THE_PAROGON_CONTRACT:                           "Employment Contract",
    COTE_HO_CONTRACTS:                              "Employment Contract",
    SHIVA_CONTRACT:                                 "Employment Contract",
    COTE_HO_HOURLY_CONTRACTS:                       "Hourly Head Office Contract",
    SEASONS_SEAHAM_CONTRACT:                        "Employment Contract",
    SEASONS_OPERATIONS_CONTRACT:                    "Employment Contract",
    SEASONS_SALES_CONTRACT:                         "Employment Contract",
    VARIOS_EATERIES_CONTRACT:                       "Employment Contracts",
    BURGER_KING_CONTRACT:                           "Employment Contract",
    BROTHER_MARCUS_CONTRACT:                        "Employment Contracts",
    CHILLED_PUBS_CONTRACT:                          "Employment Contract",
    CHESTERFORD_FISH_CONTRACT:                      "Employment Contract",
    CHESTERFORD_GROUP_CONTRACT:                     "Employment Contract",
    MKD_HOLDINGS_CONTRACT:                          "Employment Contracts",
    DD_CONTRACT:                                    "Employment Contract",
    VE_RARE_BIRD_HOTELS_CONTRACT:                   "Employment Contract",
    BILLS_CONTRACT:                                 "Employment Contract",
    BILLS_HOURLY_CONTRACT:                          "Employment Contract",
    TATTU_TRAINING_HEALTH_SAFETY_BOOKLET:           "Training Record – Health and Safety Induction Booklet",
    BIRLEY_HO_OFFER_LETTER:                         "Head Office - Offer Letter",
    RED_ENGINE_CONTRACT:                            "Employment Contract",
    CENTURION_CONTACT:                              "Employment Contract",
    BATH_RACQUETS_OFFER_LETTER:                     "Bath & Racquets Club - Offer Letter",
    WH_380_E_FORM:                                  "Certification of Health Care Provider for Employee’s Serious Health Condition under the Family and Medical Leave Act",
    PJ_ARBITRATION_AGREEMENT:                       "Arbitration Agreement",
    PJ_PZ_CAROLINA_ARBITRATION_AGREEMENT:           "Arbitration Agreement",
    PJ_PERFECT_TN_ARBITRATION_AGREEMENT:            "Arbitration Agreement",
    PJ_PIE_GUYS_ARBITRATION_AGREEMENT:              "Arbitration Agreement",
    PJ_STANZEL_ARBITRATION_AGREEMENT:               "Arbitration Agreement",
    ARCHIES_OFFER_LETTER:                           "Offer Letter",
    HC_5_EMPLOYEE_NOTIFICATION:                     "Form HC - 5 Employee Notification to Employer",
    HALL_WOODHOUSE_GM_FINANCE_CHECK:                "GM and DGM only - Finance Check",
    CATCH_WAGE_NOTIFICATION_FORM:                   "Wage Notification Form – Tipped Employees",
    BROTHER_MARCUS_TRONC_LETTER:                    "BM Tronc Letter",
    GENTLEMEN_BARISTAS_CONTRACT:                    "Employment contract",
    SHOOT_THE_BULL_CONTRACT:                        "Employment Contract",
    THE_BATH_BUP_CONTRACT:                          "Employment Contract",
    LANGAN_CHUCS_CONTRACT:                          "Employment contract",
    ADVENTURE_PARC_CONTRACT:                        "Employment Contract",
    SQUARE_GRILL_CONTRACT:                          "Employment Contract",
    TATTU_RISK_ASSESSMENT_TRAINING_RECORD:          "Risk Assessment Training Record",
    BOPARAN_BANK_DETAILS_VERIFICATION:              "Bank Details Verification",
    NY_WAGE_NOTICE:                                 "NY -195 NY Custom Notice of Pay",
    STICK_SUSHI_ONBOARDING_FISH:                    "OnBoarding of a Fish",
    ORANGE_MANAGEMENT_TRONC_LETTER:                 "Tronc Letter - Salaried",
    CAL_SAVERS_OPT_OUT:                             "CalSavers Optout Form",
    ROTIKING_CONTRACT:                              "Employment Contract",
    HALL_WOODHOUSE_SALARIED_EXPRESSION_OF_WISH:     "Salaried Only - Expression of Wish",
    RITZ_LONDON_NOMINATION_OF_BENEFICIARY:          "Nomination of Beneficiary",
    THE_WORKS_EIRE_CONTRACT:                        "Republic of Ireland Contract",
    THE_WORKS_ISLE_CONTRACT:                        "Isle of Man Contract",
    THE_WORKS_NIR_CONTRACT:                         "Employment Contract",
    THE_WORKS_UK_CONTRACT:                          "Employment Contract",
    THE_WORKS_UK_PROMOTION_CONTRACT:                "Employment Contract - Promotion",
    FIGHT_CLUB_CONTRACT:                            "Employment Contract",
    PJ_DMD_CHILD_LABOR_LAW_NOTICE:                  "DMD Child Labor Law Notice",
    PJ_FL_CHILD_LABOR_LAW_NOTICE:                   "FL Child Labor Law Notice",
    ELECTRIC_SHUFFLE_CONTRACT:                      "Employment Contract",
    FIGHT_CLUB_MANAGEMENT_CONTRACT:                 "Employment Contract",
    SAVOY_MEDICAL_QUESTIONNAIRE:                    "Employment Medical Questionnaire",
    PAPA_JOHNS_AIO_DRIVER_MANAGER:                  "All In One Sheet - Driver Manager",
    PAPA_JOHNS_AIO_INSIDER:                         "All In One Sheet - Insider",
    CHALKPIT_CONTRACT:                              "Employment Contract",
    STRADA_CONTRACT:                                "Employment Contract",
    ST_JAMES_IMOLOTT_CONTRACT:                      "Employment Contract",
    BELOW_CONTRACT:                                 "Employment Contract",
    VURGER_CO_CONTRACT:                             "Employment Contract",
    WILTON_HOLDINGS_CONTRACT:                       "Employment Contract",
    FRANCO_HOLDINGS_CONTRACT:                       "Employment Contract",
    BELOW_CHILDREN_CONTRACT:                        "Employment Contract",
    AUBAINE_CONTRACT:                               "Employment Contract",
    AUBAINE_FRANCAIS_CONTRACT:                      "Employment Contract",
    AUBAINE_SUPPORT_CONTRACT:                       "Employment Contract",
    GAUCHO_CONTRACT:                                "Employment Contract",
    GAUCHO_HEAD_OFFICE_CONTRACT:                    "Employment Contract",
    WR_LINA_STORE_CONTRACT:                         "Employment Contract",
    WR_KYMS_CONTRACT:                               "Employment Contract",
    MERAKI_CONTRACT:                                "Employment Contract",
    DISHOOM_CONTRACT:                               "Employment Contract",
    DEEP_BLUE_OPT_OUT:                              "48 Hour Opt-Out Form",
    DAVES_TWC_INSURANCE_FORM:                       "Traveler's Workers Compensation Insurance form",
    VIVA_CARES_AUTHORIZATION_FORM:                  "#VivaCares Authorization Form",
    NORTHSTAR_REFERRAL_FORM:                        "Referral Form",
    NORTHSTAR_REFERRAL_FORM_V2:                      "Referral Form",
    SMASHBURGER_MEAL_WAIVER_FORM:                   "Meal Break Waiver Form",
    SMASHBURGER_CWOPA_NEW_HIRE_FORM:                "New Hire Reporting Form",
    ANNABELS_OFFER_LETTER:                          "Annabel - Offer Letter",
    JOLIBEE_EMPLOYEMENT_ELIGIBITLITY_VERIFICATION:  "Employment Eligibility Verification",
    WORKS_NOK_FORM:                                 "Next of Kin Information Form",
    CHESTERFORD_EXPRESSION_OF_WISH:                 "Expression of Wish Form",
    MULINO_PERSONAL_INFO:                           "Personal Information Form",
    LORE_HOTELS_PERSONAL_FORM:                      "Personal Form",
    LORE_PERSONAL_DETAILS_FORM:                     "Personal Details Form",
    MIGUELS_UNIFORM_AUTHORIZATION:                  "Uniform Authorization",
    WELLS_CO_TIPS_DECLARATION:                      "Employee Declaration - Cash Tips",
    IVY_DAWOSN_OFFER_LETTER:                        "Offer Letter",
    CIRRUS_INNS_PERSONAL_DETAILS:                   "Personal Details",
    ARTIST_RESIDENCE_CONTRACT:                      "Employment Contract",
    MAGNOLIA_PAY_RATE_NOTICE:                       "Notice and Acknowledgement of Pay Rate and Pay Day",
    AHH_EMPLOYEE_REQUIREMENTS:                      "Employee Requirements",
    MULINO_ACK_PAY_RATE_NY:                         "Acknowledgement of Pay Rate and Payday",
    MULINO_ACK_PAY_RATE_IL:                         "Acknowledgement of Pay Rate and Payday",
    LITTLE_GEMS_ACCOMMODATION_AGREEMENT:            "Accommodation Agreement",
    BKUK_CHANGE_OF_DETAILS:                         "BKUK Change of Details Form",
    DRAKE_MORGAN_EMPLOYMENT_CONFIRMATION:           "Employment Confirmation",
    SABOR_CONTRACT:                                 "Employment Contract",
    BONE_BURGER_CONTRACT:                           "Employment Contract",
    BRASSERIE_BAR_CONTRACT:                         "Employment Contract",
    SEASONS_STARTER_FORM:                           "New Starter Form - Working Location Details",
    ACE_HOTEL_CONTRACT:                             "Employment Contract",
    COTE_RESTAURANT_MANAGER_CONTRACTS:              "Employment Contract",
    COTE_RESTAURANT_HOURLY_ALL_CONTRACTS:           "Employment Contract",
    COTE_RESTAURANT_HOURLY_CONTRACTS:               "Employment Contract",
    COTE_RESTAURANT_TEAM_HOURLY_CONTRACTS:          "Employment Contract",
    THUNDERBIRD_CONTRACT:                           "Employment Contract",
    MONTE_FORTE_CONTRACT:                           "Employment Contract",
    BISTROT_PIERRE_HOURLY_CONTRACT:                 "Employment Contract",
    BISTROT_PIERRE_SALARIED_CONTRACT:               "Employment Contract",
    BISTROT_PIERRE_GM_CONTRACT:                     "Employment Contract",
    BRASSERIE_BAR_TEAM_MEMBER_CONTRACT:             "Employment Contract",
    ARCADE_THEATRE_CONTRACT:                        "Employment Contract",
    THE_CONDUIT_CONTRACT:                           "Employment Contract",
    RC_GROUP_CONTRACT:                              "Employment Contract",
    CARAVAN_CCR_CONTRACT:                           "Employment Contract",
    CARAVAN_GM_CONTRACT:                            "Employment Contract",
    CARAVAN_CONTRACT:                               "Employment Contract",
    VEL_CONTRACT:                                   "Employment Contract",
    VARIOUS_EATERIES_CONTRACT:                      "Employment Contract",
    CARAVAN_PRIVACY_NOTICE:                         "Candidate Privacy Notice",
    SWAN_INN_CONTRACT:                              "Employment Contract",
    COUNTRY_CREATURES_CONTRACT:                     "Employment Contract",
    GET_FOOD_CONTRACT:                              "Employment Contract",
    TOMAHAWK_CONTRACT:                              "Employment Contracts",
    URBAN_LEISURE_CONTRACT:                          "Employment Contract",
    BIRLEY_CLUB_CONTRACT:                            "Employment Contract",
    FLAT_IRON_CONTRACT:                              "Employment Contract",
    ANNABELS_TRONC_LETTER:                           "TRONC Letter",
    SHEPHERD_NEAME_CONTRACT:                        "Employment Contract",
    GALETA_CONTRACT:                                 "Employment Contract",
    MJMK_CONTRACT:                                   "Employment Contract",
    GUESTHOUSE_CONTRACT:                            "Employment Contract",
    WEBBER_TIP_CREDIT_NOTICE:                        "Tip Credit Notice",
    NZR_GROUP_UNIFORM_EQUIPMENT_ISSUE_FORM:          "Uniform & Equipment issue form",
    CJB_TERMS_CONDITIONS_OF_EMPLOYMENT:              "Terms and Conditions of Employment",
    TATTU_LIQUOR_INDEMNITY_EMPLOYEE_DECLARATION:    "Liquor Indemnity Employee Declaration Form",
    CHEQUERS_INN_CONTRACT:                          "Employment Contract",
    WATCH_HOUSE_CONTRACT:                           "Employment Contract ",
    WATCH_HOUSE_HO_CONTRACT:                        "Employment Contract",
    ALMOND_FAMILY_PUBS_CONTRACT:                    "Employment Contract",
    VINOTECA_CONTRACT:                              "Employment Contract",
    HARRY_RAMSDEN_CONTRACT:                         "Employment Contract",
    HARRY_RAMSDEN_HOURLY_CONTRACT:                  "Employment Contract",
    HARRY_RAMSDEN_EU_HOURLY_CONTRACT:               "Employment Contract",
    HARRY_RAMSDEN_IRELAND_CONTRACT:                 "Employment Contract",
    RED_CARNATION_HEALTH_QUESTIONNAIRE:             "Health Questionnaire",
    CIRRUS_INNS_HEALTH_QUESTIONNAIRE:               "Health Questionnaire",
    MCDONALDS_CONDITIONAL_FOOD_INTERVIEW:           "Conditional Employee and Food Employee Interview",
    CIRRUS_INNS_POLICIES:                           "Policies",
    SEAC_CERTIFICATE_QUESTIONNAIRE:                 "Certificate Questionnaire",
    BIG_TABLE_EXPRESS_OF_WISH:                      "Express of Wish Form",
    BIG_TABLE_EMPLOYMENT_DECLARATION:               "Employment Declaration Form",
    BIG_TABLE_EEO:                                  "Equal Opportunities Monitoring Form",
    BIG_TABLE_HO_CONTRACT:                          "Head Office Contract",
    SEAC_FOOD_SAFETY_POLICIES:                      "Food Safety Policies",
    SEAC_CONSENT_FORM:                              "Consent Form for Existing Employees (GDPR compliant)",
    SEAC_MEDICAL_QUESTIONNAIRE:                     "Medical Questionnaire",
    SEAC_WORKING_TIME_REGULATIONS:                  "Working Time Regulations",
    GAUCHO_POLICIES_BIRMINGHAM:                     "Policies and procedures Gaucho - Management team Birmingham",
    GAUCHO_POLICIES_EDINBURGH:                      "Policies and procedures Gaucho - Management team Edinburgh",
    GAUCHO_POLICIES_LEEDS:                          "Policies and procedures Gaucho - Management team Leeds",
    GAUCHO_POLICIES_LONDON_MANCHESTER:              "Policies and procedures Rare Restaurants – Management team",
    THE_WORKS_UNIFORM_ORDER:                        "Uniform Order Form",
    SCHEDULE_AVAILABILITY_FORM:                     "Schedule Availability",
    DAVES_CHICKEN_ARBITRATION_AGREEMENT:            "Binding Arbitration Agreement",
    PAPA_JOHNS_VEHICLE_INSPECTION:                  "Vehicle Inspection",
    FARMERS_BOYS_EMPLOYEE_INFO:                     "Employee Information Form",
    COTE_PERSONAL_OPT_OUT:                          "Personnel Opt-Out Agreement",
    AUBAINE_PERSONAL_DETAILS_SINGLE:                "Personal Details Form",
    COTE_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE:        "Food Handlers Health Questionnaire",
    JEAN_GEORGES_TRANSITCHECK_DEDUCTION:            "Transit Deduction Authorization",
    I9_REVERIFICATION_SECTION_3:                    "Reverification-Section 3",
    ANDREW_BROWNSWORD_HEALTH_ASSESSMENT:            "Health Assessment",
    FOOD_HANDLERS_HEALTH_DECLARATION:               "Food Handler’s Pre-Employment Health Declaration",
    HARTS_EMPLOYEE_STARTER_FORM :                   "Employee Starter Form",
    KRICKET_STARTER_FORM :                          "Employee Starter Form",
    CHARLES_REFERENCE_FORM:                         "Reference Form",
    CDG_BANK_ACCOUNT_DETAILS:                       "Bank Account Details",
    CDG_EMERGENCY:                                  "Emergency Contact",
    CDG_EMPLOYEE_STARTER_FORM:                      "Employee Starter Form",
    ROCKFISH_STARTER_FORM:                          "Rockfish Starter Form",
    ROCKFISH_HEALTH_QUESTIONNAIRE:                  "Health Check Questionnaire",
    BOWERY_COMMUTER_BENEFITS:                       "Commuter Benefits Plan",
    WENDY_PERMIT_TO_EMPLOY:                         "Permit To Employ And Work",
    AHH_NIGHT_HEALTH_QUESTIONNAIRE:                 "Night Health Questionnaire",
    AHH_EMPLOYMENT_HEALTH_QUESTIONNAIRE:            "Employment Health Questionnaire",
    CONDITIONAL_EMPLOYEE_INTERVIEW:                 "Conditional Employee and Food Employee Interview",
    RADISSON_SWITZERLAND_PERSONAL_LAUFZETTEL:       "Personalstammblatt_CH",
    RADISSON_PERSONALSTAMMBLATT_AT:                 "Personalstammblatt_AT",
    CDG_CRIMINAL_RECORD_FORM:                       "Criminal Record Declaration",
    CDG_REFERENCE_REQUEST_FORM:                     "Reference Request Form",
    CDG_PERSONAL_LICENSE:                           "Personal License",
    ANTI_SEXUAL_HARASSMENT_NY:                      "Anti-Sexual Harassment Factsheet",
    FEDERAL_TD1:                                    "Federal TD1 Form",
    ONTARIO_TAX:                                    "Ontario Personal Tax Credits Return",
    CG_TUTTONS_CONTRACT:                            "Employment Contract",
    CG_FIRE_STONE_CONTRACT:                         "Employment Contract",
    CG_DIRTY_MARTINI_CONTRACT:                      "Employment Contract",
    CG_HEAD_OFFICE_CONTRACT:                        "Employment Contract",
    LDV_ARBITRATION_AGREEMENT:                      "Arbitration Agreement",
    CUBITT_HOUSE_SET_TRONC:                         "Set Tronc",
    CUBITT_HOUSE_VARIANCE_TRONC:                    "Variance Tronc",
    OLE_STEEN_MEDICAL_QUESTIONNAIRE:                "Medical Questionnaire",
    RARE_BIRD_CONTRACT:                             "Employment Contract",
    INAMO_CONTRACT:                                 "Employment Contract",
    RED_CARNATION_CONTRACT:                         "Employment Contract",
    GENERATOR_GERMANY_CONTRACT:                      "Employment Contract",
    JP_TAX_RESIDENTIAL_STATUS:                      "New Joiner: Tax and Residential Status",
    MARKS_CLUB_TRONC_LETTER:                         "Tronc Letter",
    BUNDOBUST_CONTRACT:                             "Employment Contract",
    VILLAGE_HOTELS_TM_CONTRACT:                     "Employment Contract",
    VILLAGE_HOTELS_HOD_CONTRACT:                    "Employment Contract",
    SEAFOOD_PUB_CONTRACT:                           "Employment Contract",
    SEAFOOD_BAR_CONTRACT:                           "Employment Contract",
    FOLIE_CONTRACT:                                 "Employment Contract",
    BIG_SMOKE_CONTRACT:                             "Employment contract",
    MORGAN_PUB_CONTRACT:                             "Employment contract",
    VQ_RESTAURANT_CONTRACT:                         "Employment Contract",
    ROYAL_LANCASTER_CONTRACT:                       "Employment Contract",
    RED_CARNATION_ADDITIONAL_DOCS:                  "Additional Documents",
    GENERATOR_HEALTH_QUESTIONNAIRE:                 "Health Questionnaire",
    BREAKFAST_CLUB_FOOD_HANDLERS_HEALTH_QUESTIONNAIRE: "Food Handlers Health Questionnaire",
    TATTU_FOOD_HANDLER_QUESTIONNAIRE: "Pre-employment Food Handler Questionnaire",
    GENERATOR_STARTER_ACCEPTANCE_FORM:              "New Starter Acceptance Form",
    FARMER_BOYS_LOF_MEAL_WAIVER:                    "Meal Period Waiver Agreement - Leading Our Future, LLC dba Farmer Boys",
    FARMER_BOYS_IRIS_MEAL_WAIVER:                   "Meal Period Waiver Agreement - Iris & Perris Moreno, Inc. dba Farmer Boys",
};

OnBoardingAPI.NON_CANDIDATE_PROSPECT_TYPE = {
    NEW_NON_APPLICANT: "NEW_NON_APPLICANT",
    EXISTING_NON_APPLICANT: "EXISTING_NON_APPLICANT"
};

OnBoardingAPI.DOC_REMINDER_TYPE = {
    CORRECTION: 'CORRECTION',
    MISSING_INFO: 'MISSING_INFO'
};

OnBoardingAPI.PROSPECT_VISIBILITY = {
    HIDDEN: 'HIDDEN',
    SHOWN: 'SHOWN'
};

OnBoardingAPI.PAYROLL_CHANNELS = {};
OnBoardingAPI.PAYROLL_CHANNELS.ADP = "ADP";
OnBoardingAPI.PAYROLL_CHANNELS.PAYCOM = "PAYCOM";
OnBoardingAPI.PAYROLL_CHANNELS.ADP_CSV = "ADP_CSV";

OnBoardingAPI.DOCUMENT_CODES_TITLES = {
    "N/A":                                          "N/A",
    US_PASSPORT:                                    "U.S. passport ID page",
    RADISSON_PERSONALSTAMMBLATT_AT_ID_CARD:         "Ausweisdokumentes",
    RADISSON_PERSONALSTAMMBLATT_AT_WORK_PERMIT:     "Arbeitsbewilligung",
    US_PASSPORT_BACK:                               "U.S. passport barcode page",
    US_PASSPORT_CARD:                               "U.S. passport card ID page",
    UK_RTW_REPORT:                                  "UK RTW Report",
    US_PASSPORT_CARD_BACK:                          "U.S. passport card barcode page",
    PERM_RESID_CARD:                                "Perm. Resident Card (Form I-551)",
    PERM_RESID_CARD_BACK:                           "Perm. Resident Card (Form I-551) back card",
    ALIEN_PERM_RESID_CARD:                          "Alien Reg. Receipt Card (Form I-551)",
    FOREIGN_PASSPORT_TEMP_STAMP:                    "Foreign passport with Temp. I-551 Stamp",
    FOREIGN_PASSPORT_TEMP_MRIV:                     "Foreign passport with Temp. I-551 MRIV",
    RECEIPT_I_94:                                   "Receipt: Form I-94/I-94A w/I-551 stamp, photo",
    RECEIPT_PERM_RESID_CARD:                        "Receipt: Receipt Replacement Perm. Res. Card (Form I-551)",
    EMP_AUTH_DOC:                                   "Employment Auth. Document (Form I-766)",
    EMP_AUTH_DOC_BACK:                              "Employment Auth. Document (Form I-766) back card",
    FOREIGN_PASSPORT:                               "Foreign passport, with work authorized nonimmigrant",
    RIM_PASSPORT:                                   "RMI Passport with Form I-94",
    FSM_PASSPORT:                                   "FSM Passport with Form I-94",
    RECEIPT_REPLACEMENT_EAD:                        "Receipt: Replacement EAD (Form I-766)",
    RADISSON_EMEA_PERSONAL_LAUFZETTEL:              "Fragebogen über persönliche Angaben für den Eintritt",
    RADISSON_GERMANY_DECLARATION_FOR_WORK:          "Erklärung zum Haupt_Nebenarbeitgeber",
    WAFELS_DINGES_MVR_RELEASE_FORM:                 "MVR Release Consent Form",
    RECEIPT_I_94_REFUGEE:                           "Receipt: Form I-94/I-94A w/refugee stamp (or RE class of admission)",
    RECEIPT_FOREIGN_PASSPORT:                       "Receipt: Foreign passport, work-authorized nonimmigrant.",
    RECEIPT_FSM_PASSPORT:                           "Receipt: FSM passport with Form I-94",
    RECEIPT_RIM_PASSPORT:                           "Receipt: RMI passport with Form I-94",
    RADISSON_EMEA_LOW_PAID_QUESTIONNAIRE:           "Fragebogen für geringfügig entlohnte oder kurzfristig Beschäftigte",
    WAFELS_DINGES_WAIVER_COVERAGE:                  "Request for waiver of coverage",
    DRIVER_LICENSE:                                 "Driver's license issued by state/territory",
    NMC_PIN:                                        "Nursing and Midwifery Council Document",
    ID_CARD_BY_STATE:                               "ID card issued by state/territory",
    GOVERMENT_ID:                                   "Government ID",
    SCHOOL_ID:                                      "School ID",
    VOTER_REG_CARD:                                 "Voter registration card",
    US_MILITARY_CARD:                               "U.S. Military card",
    US_MILITARY_DRAFT:                              "U.S. Military draft record",
    MILITARY_DEP_ID:                                "Military dependent's ID card",
    USCG_MERCH_MARINER_CARD:                        "USCG Merchant Mariner card",
    NATIVE_AMERICAN_TRIPLE_DOC:                     "Native American tribal document",
    CANADIAN_DRIVER_LICENSE:                        "Canadian driver's license",
    SPECIAL_PLACEMENT:                              "Special Placement",
    RECEIPT_DRIVER_LICENSE:                         "Receipt: Replacement driver's license",
    RECEIPT_ID_CARD_BY_STATE:                       "Receipt: Replacement ID card",
    RECEIPT_GOVERMENT_ID:                           "Receipt: Replacement Gov't ID",
    RECEIPT_SCHOOL_ID:                              "Receipt: Replacement School ID",
    RECEIPT_VOTER_REG_CARD:                         "Receipt: Replacement Voter reg. Card",
    RECEIPT_US_MILITARY_CARD:                       "Receipt: Replacement U.S. Military card",
    RECEIPT_US_MILITARY_DRAFT:                      "Receipt: Replacement U.S. Military dep. Card",
    RECEIPT_MILITARY_DEP_ID:                        "Receipt: Replacement Military draft record",
    RECEIPT_USCG_MERCH_MARINER_CARD:                "Receipt: Replacement  Native American tribal doc",
    RECEIPT_NATIVE_AMERICAN_TRIPLE_DOC:             "Receipt: Replacement Merchant Mariner card",
    RECEIPT_CANADIAN_DRIVER_LICENSE:                "Receipt: Replacement Canadian DL",
    SOCIAL_SECURITY_CARD_UNRESTRICTED:              "Social Security Card (Unrestricted)",
    FORM_FS_545:                                    "Form FS-545",
    FORM_DS_1350:                                   "Form DS-1350",
    US_BRITH_CERTIFICATE:                           "U. S. Birth Certificate",
    FORM_I_197:                                     "Form I-197",
    FORM_I_179:                                     "Form I-179",
    EMPLOYMENT_AUTH_DHS:                            "Employment Auth. document (DHS)",
    RECEIPT_REPLACEMENT_BIRTH_CERTIFICATE:          "Receipt: Replacement Birth Certificate",
    RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL:         "Receipt: Replace. Native American Tribal Doc.",
    RECEIPT_REPLACEMENT_UNRESTRICTED_SS_CARD:       "Receipt: Replacement Unrestricted SS Card",
    RECEIPT_REPLACEMENT_EMPLOYMENT_AUTH_DHS:        "Receipt: Replacement Employment Auth. Doc. (DHS)",
    TEMP_I_551_STAMP:                               "Temporary I-551 Stamp",
    MACHINE_READABLE_IMMIGRANT_VISA:                "Machine-readable immigrant visa (MRIV)",
    FORM_I_94_A:                                    "Form I-94/I-94A",
    RECEIPT_FORM_I_94_A:                            "Receipt: Form I-94/I-94A",
    FORM_I_20:                                      "Form I-20",
    FORM_DS_2019:                                   "Form DS-2019",
    CONSULAR_REPORT_OF_BIRTH_ABROAD:                "Form FS-240",
    FOREIGN_PASSPORT_Form_I_94:                     "Foreign passport with Form I-94, endorsement",
    RECEIPT_REPLACEMENT_FOREIGN_PASSPORT_Form_I_94: "Receipt: Replacement Foreign passport with Form I-94, endorsement",
    RECEIPT_REPLACEMENT_SOCIAL_SECURITY_CARD:       "Receipt: Replacement Social Security Card",
    RECEIPT_REPLACEMENT_EMP_AUTH_DOC:               "Receipt: Replacement Employment Auth. Document (Form-I-766)",
    SCHOOL_RECORD_UND_18:                           "School record (under age 18)",
    REPORT_CARD_UND_18:                             "Report card (under age 18)",
    CLINIC_RECORD_UND_18:                            "Clinic record (under age 18)",
    DOCTOR_RECORD_UND_18:                           "Doctor record (under age 18)",
    HOSPITAL_RECORD_UND_18:                         "Hospital record (under age 18)",
    DAY_CARE_RECORD_UND_18:                         "Day-care record (under age 18)",
    NURSERY_SCHOOL_RECORD_UND_18:                   "Nursery school record (under age 18)"
};

OnBoardingAPI.DOCUMENT_CODES_FULL_NAMES = {
    FOREIGN_PASSPORT_TEMP_STAMP:                    "Foreign passport containing a temporary I-551 stamp.",
    ALIEN_PERM_RESID_CARD:                          "Alien Registration Receipt Card (Form I-551).",
    PERM_RESID_CARD:                                "Permanent Resident Card (Form I-551).",
    PERM_RESID_CARD_BACK:                           "Permanent Resident Card (Form I-551) back card.",
    EMP_AUTH_DOC:                                   "Employment Authorization Document (Form I-766).",
    EMP_AUTH_DOC_BACK:                              "Employment Authorization Document (Form I-766) back card.",
    FOREIGN_PASSPORT_TEMP_MRIV:                     "Foreign passport containing a temporary I-551 printed notation on a machine-readable immigrant visa (MRIV).",
    RECEIPT_I_94:                                   "Receipt: The arrival portion of Form I-94/I-94A containing a temporary I-551 stamp and photograph.",
    RECEIPT_PERM_RESID_CARD:                        "Receipt for an application to replace a lost, stolen or damaged Permanent Resident Card (Form I-551).",
    FOREIGN_PASSPORT:                               "For a nonimmigrant alien authorized to work for a specific employer because of his or her status, a foreign passport with Form I/94/I-94A that contains an endorsement of the alien's nonimmigrant status.",
    RIM_PASSPORT:                                   "Passport from the Republic of the Marshall Islands (RMI) with Form I-94/I94A.",
    FSM_PASSPORT:                                   "Passport from the Federated States of Micronesia (FSM) with Form I-94/I-94A.",
    RECEIPT_REPLACEMENT_EAD:                        "Receipt for an application to replace a lost, stolen or damaged Employment Authorization Document (Form I-766).",
    RECEIPT_I_94_REFUGEE:                           "Receipt: The departure portion of Form I-94/I-94A with an unexpired refugee admission stamp.",
    RECEIPT_FOREIGN_PASSPORT:                       "Receipt for an application to replace a lost, stolen or damaged foreign passport with Form I-94/I-94A that contains an endorsement of the alien's nonimmigrant status.",
    RECEIPT_FSM_PASSPORT:                           "Receipt for an application to replace a lost, stolen or damaged passport from the Federated States of Micronesia with Form I-94/I-94A.",
    RECEIPT_RIM_PASSPORT:                           "Receipt for an application to replace a lost, stolen or damaged passport from the Republic of the Marshall Islands with Form I-94/I-94A.",
    DRIVER_LICENSE:                                 "Driver's license issued by a State or outlying possession of the United States.",
    ID_CARD_BY_STATE:                               "ID card issued by a State or outlying possession of the United States.",
    GOVERMENT_ID:                                   "ID card issued by federal, state, or local government agencies or entities.",
    SCHOOL_ID:                                      "School ID card with photograph.",
    VOTER_REG_CARD:                                 "Voter's registration card.",
    USCG_MERCH_MARINER_CARD:                        "U.S. Coast Guard Merchant Mariner Card.",
    CANADIAN_DRIVER_LICENSE:                        "Driver's license issued by a Canadian government authority.",
    SPECIAL_PLACEMENT:                              "Special placement endorsement for persons with disabilities.",
    RECEIPT_DRIVER_LICENSE:                         "Receipt for the application to replace a lost, stolen or damaged Driver's License issued by a State or outlying possession of the United States.",
    RECEIPT_ID_CARD_BY_STATE:                       "Receipt for the application to replace a lost, stolen or damaged ID card issued by a State or outlying possession of the United States.",
    RECEIPT_GOVERMENT_ID:                           "Receipt for the application to replace a lost, stolen or damaged ID card issued by federal, state, or local government agencies or entities.",
    RECEIPT_SCHOOL_ID:                              "Receipt for the application to replace a lost, stolen or damaged School ID card with photograph.",
    RECEIPT_VOTER_REG_CARD:                         "Receipt for the application to replace a lost, stolen or damaged Voter's registration card.",
    RECEIPT_US_MILITARY_CARD:                       "Receipt for the application to replace a lost, stolen or damaged U.S. Military card.",
    RECEIPT_US_MILITARY_DRAFT:                      "Receipt for the application to replace a lost, stolen or damaged Military dependent's ID card.",
    RECEIPT_MILITARY_DEP_ID:                        "Receipt for the application to replace a lost, stolen or damaged U.S. Military draft record.",
    RECEIPT_USCG_MERCH_MARINER_CARD:                "Receipt for the application to replace a lost, stolen or damaged Native American tribal document.",
    RECEIPT_NATIVE_AMERICAN_TRIPLE_DOC:             "Receipt for the application to replace a lost, stolen or damaged U.S. Coast Guard Merchant Mariner Card.",
    RECEIPT_CANADIAN_DRIVER_LICENSE:                "Receipt for the application to replace a lost, stolen or damaged Driver's license issued by a Canadian government authority.",
    SOCIAL_SECURITY_CARD_UNRESTRICTED:              "Social Security Account Number card without restrictions.",
    FORM_FS_545:                                    "Certification of Birth Abroad (Form FS-545).",
    FORM_DS_1350:                                   "Certification of Report of Birth (Form DS-1350).",
    US_BRITH_CERTIFICATE:                           "Original or certified copy of a U.S. birth certificate bearing an official seal.",
    FORM_I_197:                                     "U.S. Citizen ID Card (Form I-197).",
    FORM_I_179:                                     "Identification Card for use of Resident Citizen in the United States (Form I-179).",
    EMPLOYMENT_AUTH_DHS:                            "Employment authorization document issued by DHS (List C #7).",
    RECEIPT_REPLACEMENT_BIRTH_CERTIFICATE:          "Receipt for the application to replace a lost, stolen or damaged Original or certified copy of a U.S. birth certificate bearing an official seal.",
    RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL:         "Receipt for the application to replace a lost, stolen or damaged Native American Tribal Document.",
    RECEIPT_REPLACEMENT_UNRESTRICTED_SS_CARD:       "Receipt for the application to replace a lost, stolen or damaged Social Security Account Number Card without restrictions.",
    RECEIPT_REPLACEMENT_EMPLOYMENT_AUTH_DHS:        "Receipt for the application to replace a lost, stolen or damaged Employment Authorization Document issued by DHS.",
    CONSULAR_REPORT_OF_BIRTH_ABROAD:                "Consular Report of Birth Abroad (Form FS-240).",
    RECEIPT_REPLACEMENT_EMP_AUTH_DOC:               "Receipt: Replacement Employment Authorization Document (Form-I-766)."
};

OnBoardingAPI.DOCUMENT_CODES_IMAGE_INFO = {
    // Section 1 (employee side)
    SSN:                                         "../images/forms/i9/ssn_h.png",
    USCIS:                                       "../images/forms/i9/uscis_h.png",
    I94:                                         "../images/forms/i9/i-94_h.png",

    // LISTS (employer side)
    US_PASSPORT_CARD:                            "../images/forms/i9/us_pc_h.png",
    PERM_RESID_CARD:                             "../images/forms/i9/prc_h_e.png",
    EMP_AUTH_DOC:                                "../images/forms/i9/ead_h.png",
    RIM_PASSPORT:                                "../images/forms/i9/rmi.jpeg",
    FSM_PASSPORT:                                "../images/forms/i9/fsm.png",
    DRIVER_LICENSE:                              "../images/forms/i9/dl_h.png",
    ID_CARD_BY_STATE:                            "../images/forms/i9/id_h.png",
    SOCIAL_SECURITY_CARD_UNRESTRICTED:           "../images/forms/i9/ssn_h.png",
    FORM_DS_1350:                                "../images/forms/i9/ds_1350_h.png",
    US_BRITH_CERTIFICATE:                        "../images/forms/i9/ri_bc_h.png",
    FORM_I_197:                                  "../images/forms/i9/i-197_h.png",
    FORM_I_179:                                  "../images/forms/i9/i_179.png",
    FORM_I_94_A:                                 "../images/forms/i9/i-94a_h.png",
    CONSULAR_REPORT_OF_BIRTH_ABROAD:             "../images/forms/i9/fs_240_h.png"
};

OnBoardingAPI.ARCHIVE_REASONS = {
    REJECTED_OFFER: $filter("translate")('Rejected Offer'),
    INCOMPLETE_OB_DOCS: $filter("translate")('Incomplete OB Docs'),
    OTHER: $filter("translate")('Others'),
    POSITION_CHANGE: $filter("translate")('Position Change')
};

OnBoardingAPI.TERMINATE_REASONS = [];

OnBoardingAPI.SERVICE_END_REASONS = {
    TERMINATION: "TERMINATION",
    ARCHIVING: "ARCHIVING",
};

OnBoardingAPI.WAGE_MATRIX = {
    CLOSE_WAGE_CONFIRMATION_MODAL: "CLOSE_WAGE_CONFIRMATION_MODAL"
};

OnBoardingAPI.DOCUMENT_CUSTOM_BUILT_FORM_TYPE = {
    MANAGER: 'MANAGER',
    EMPLOYEE: 'EMPLOYEE',
    MANAGER_EMPLOYEE: 'MANAGER_EMPLOYEE'
}